import * as i0 from '@angular/core';
import { Injectable, Component, Input, EventEmitter, Output, ViewChild, ViewChildren, Directive, NgModule } from '@angular/core';
import { Subject, EMPTY, throwError, from, of, Subscription } from 'rxjs';
import { takeUntil, expand, reduce, map, catchError, switchMap, tap, shareReplay } from 'rxjs/operators';
import * as i1 from '@angular/forms';
import { UntypedFormGroup, Validators, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { Config } from '@mitel/cloudlink-sdk';
import * as _ from 'lodash';
import * as i2 from '@ngx-translate/core';
import { TranslateModule } from '@ngx-translate/core';
import * as i5 from '@angular/common';
import { CommonModule } from '@angular/common';
import * as i8 from '@angular/material/form-field';
import { MatFormFieldModule } from '@angular/material/form-field';
import * as i7 from '@angular/material/select';
import { MatSelectModule } from '@angular/material/select';
import * as i8$1 from '@angular/material/core';
import * as i9 from '@angular/material/button';
import { MatButtonModule } from '@angular/material/button';
import * as i10 from '@angular/material/tooltip';
import { MatTooltipModule } from '@angular/material/tooltip';
import * as i11 from 'ngx-mat-select-search';
import { NgxMatSelectSearchModule } from 'ngx-mat-select-search';
import * as i1$2 from '@angular/material/icon';
import { MatIconModule } from '@angular/material/icon';
import * as i10$1 from '@angular/material/expansion';
import { MatExpansionPanel, MatExpansionModule } from '@angular/material/expansion';
import * as i1$1 from '@angular/common/http';
import { HttpHeaders, HttpErrorResponse } from '@angular/common/http';
import { AdminService as AdminService$1 } from '@mitel/cloudlink-sdk/admin';
import { Config as Config$1 } from '@mitel/cloudlink-sdk/config';
import * as i2$1 from '@angular/platform-browser';
import * as i9$1 from '@angular/material/input';
import { MatInputModule } from '@angular/material/input';
import { MatDialogModule } from '@angular/material/dialog';
import { MatTableModule } from '@angular/material/table';
import { MatSortModule } from '@angular/material/sort';
import { MatMenuModule } from '@angular/material/menu';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatRadioModule } from '@angular/material/radio';
import { MatProgressBarModule } from '@angular/material/progress-bar';

var licenseType;
(function (licenseType) {
    licenseType["NEXT_GEN"] = "next_gen";
    licenseType["BUILD_YOUR_OWN"] = "build_your_own";
})(licenseType || (licenseType = {}));
var licenseUCCV40Tier;
(function (licenseUCCV40Tier) {
    licenseUCCV40Tier["BASIC"] = "basic";
    licenseUCCV40Tier["ENTRY"] = "entry";
    licenseUCCV40Tier["STANDARD"] = "standard";
    licenseUCCV40Tier["PREMIUM"] = "premium";
    licenseUCCV40Tier["HOTDESK_SIP_SOFTPHONE"] = "hotdesk_sip_softphone";
})(licenseUCCV40Tier || (licenseUCCV40Tier = {}));
var tableOfContentsChange;
(function (tableOfContentsChange) {
    tableOfContentsChange["NAME_CHANGE"] = "nameChange";
    tableOfContentsChange["ITEM_REMOVED"] = "itemRemoved";
    tableOfContentsChange["ERROR_CHANGE"] = "errorChange";
    tableOfContentsChange["DIRTY_CHANGE"] = "dirtyChange";
})(tableOfContentsChange || (tableOfContentsChange = {}));
var ActionType;
(function (ActionType) {
    ActionType[ActionType["CREATE"] = 0] = "CREATE";
    ActionType[ActionType["EDIT"] = 1] = "EDIT";
})(ActionType || (ActionType = {}));
var TemplateLabel;
(function (TemplateLabel) {
    TemplateLabel["MITEL_DEFAULT"] = "mitel_default";
    TemplateLabel["LEARNED"] = "learned";
    TemplateLabel["PARTNER_DEFAULT"] = "partner_default";
    TemplateLabel["CUSTOMIZED"] = "customized";
})(TemplateLabel || (TemplateLabel = {}));
var BaseLicense;
(function (BaseLicense) {
    BaseLicense["BYO"] = "Build Your Own";
    BaseLicense["UCC_V4_0"] = "UCC V4.0";
})(BaseLicense || (BaseLicense = {}));
var asyncJobStatus;
(function (asyncJobStatus) {
    asyncJobStatus["QUEUED"] = "queued";
    asyncJobStatus["IN_PROGRESS"] = "in-progress";
    asyncJobStatus["COMPLETE"] = "complete";
    asyncJobStatus["FAILED"] = "failed";
})(asyncJobStatus || (asyncJobStatus = {}));
var asyncJobProcessingStatus;
(function (asyncJobProcessingStatus) {
    asyncJobProcessingStatus["START"] = "start";
    asyncJobProcessingStatus["IN_PROGRESS"] = "inProgress";
})(asyncJobProcessingStatus || (asyncJobProcessingStatus = {}));
var HTTP_METHODS;
(function (HTTP_METHODS) {
    HTTP_METHODS["POST"] = "POST";
    HTTP_METHODS["PUT"] = "PUT";
    HTTP_METHODS["DELETE"] = "DELETE";
})(HTTP_METHODS || (HTTP_METHODS = {}));
var groupTypes;
(function (groupTypes) {
    groupTypes["NONE"] = "none";
    groupTypes["PRG"] = "prg";
    groupTypes["MDUG"] = "mdug";
    groupTypes["MDET"] = "mdet";
})(groupTypes || (groupTypes = {}));
const noneGroup = {
    groupType: groupTypes.NONE
};
var phoneTypes;
(function (phoneTypes) {
    phoneTypes["DESK_PHONE"] = "deskPhone";
    phoneTypes["HOT_DESK"] = "hotDesk";
    phoneTypes["GENERIC_SIP"] = "genericSipPhone";
})(phoneTypes || (phoneTypes = {}));
var saveTypes;
(function (saveTypes) {
    saveTypes["SAVE"] = "save";
    saveTypes["SAVE_AND_DEPLOY"] = "save_and_deploy";
    saveTypes["DEPLOY"] = "deploy";
})(saveTypes || (saveTypes = {}));
;
;
const appPasswordMinLength = 8;
const appPasswordMaxLength = 20;
const appPasswordRequirements = [
    {
        type: 'uppercase letter',
        characters: 'ABCDEFGHIJKLMNOPQRSTUVWXYZ',
        num: 6,
        selected: ''
    },
    {
        type: 'lowercase letter',
        characters: 'abcdefghijklmnopqrstuvwxyz',
        num: 7,
        selected: ''
    },
    {
        type: 'number',
        characters: '0123456789',
        num: 3,
        selected: ''
    },
    {
        type: 'special characters',
        characters: '!@#$%&_-~+',
        num: 2,
        selected: ''
    }
];
// Fixed ID for Media Server defined for IVR Reporting.  Should not be treated as a valid Voice MS
const ivrReportingMSId = '31930290-b22d-44e6-ba78-d36062b4fa19';

class PropertyShareService {
    _accountId;
    _siteId;
    _primeData = {
        extension: null,
        single_line: false,
        acd: false,
        group: noneGroup,
        groupDeviceCount: 0,
        groupSingleLineCount: 0,
        secondaryNetwork: null,
        index: -1,
        voicemailEnabled: false,
        phoneType: undefined
    };
    _temporaryTemplate;
    _numberOfACDsData;
    numberOfACDsChanged = new Subject();
    get accountId() {
        return this._accountId;
    }
    set accountId(accountId) {
        this._accountId = accountId;
    }
    get siteId() {
        return this._siteId;
    }
    set siteId(siteId) {
        this._siteId = siteId;
    }
    get primeData() {
        return this._primeData;
    }
    set temporaryTemplate(temporaryTemplate) {
        this._temporaryTemplate = temporaryTemplate;
    }
    get temporaryTemplate() {
        return this._temporaryTemplate;
    }
    get numberOfACDsData() {
        return this._numberOfACDsData;
    }
    isMiccbUserConfigurationComplete(miccbConfiguration) {
        return !!miccbConfiguration;
    }
    static ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: PropertyShareService, deps: [], target: i0.ɵɵFactoryTarget.Injectable });
    static ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: PropertyShareService, providedIn: 'root' });
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: PropertyShareService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root'
                }]
        }] });

class TemplatesService {
    propertyShareService;
    templatesService;
    constructor(propertyShareService) {
        this.propertyShareService = propertyShareService;
        this.templatesService = {
            baseUrl: Config.cloud === 'dev' ? 'https://billing.dev.api.mitel.io/2019-03-01' : 'https://billing.api.mitel.io/2019-03-01',
            httpService: Config.httpService,
            async getUserTemplates(queryParams) {
                let url = `${this.baseUrl}/user-templates`;
                if (queryParams) {
                    url = this.addQueryParamsToUrl(url, queryParams);
                }
                let httpRequest = {
                    url: url
                };
                try {
                    let getUserTemplatesResponse = await this.httpService.get(httpRequest);
                    return getUserTemplatesResponse.body;
                }
                catch (error) {
                    throw error;
                }
            },
            async getUserTemplate(userTemplateId) {
                let httpRequest = {
                    url: `${this.baseUrl}/user-templates/${userTemplateId}`
                };
                try {
                    let getUserTemplateResponse = await this.httpService.get(httpRequest);
                    return getUserTemplateResponse.body;
                }
                catch (error) {
                    throw error;
                }
            },
            async getUserTemplateAssignments(queryParams) {
                let httpRequest = {
                    url: `${this.baseUrl}/user-template-assignments`
                };
                try {
                    if (queryParams) {
                        httpRequest.url = this.addQueryParamsToUrl(httpRequest.url, queryParams);
                    }
                    let getUserTemplateAssignmentsResponse = await this.httpService.get(httpRequest);
                    return getUserTemplateAssignmentsResponse.body;
                }
                catch (error) {
                    throw error;
                }
            },
            addQueryParamsToUrl(url, queryParams) {
                let firstParam = true;
                _.forEach(queryParams, (value, qParam) => {
                    if (firstParam) {
                        url = `${url}?`;
                        firstParam = false;
                    }
                    else {
                        url = `${url}&`;
                    }
                    url = `${url}${qParam}=${value}`;
                });
                return url;
            }
        };
    }
    async getUserTemplates(queryParams) {
        let getUserTemplatesResponse = await this.templatesService.getUserTemplates(queryParams);
        return getUserTemplatesResponse._embedded?.items || [];
    }
    async getUserTemplateById(userTemplateId) {
        let getUserTemplateResponse = await this.templatesService.getUserTemplate(userTemplateId);
        return getUserTemplateResponse;
    }
    async getUserTemplateAssignments(queryParams) {
        const getUserTemplateAssignmentsResponse = await this.templatesService.getUserTemplateAssignments(queryParams);
        return getUserTemplateAssignmentsResponse._embedded?.items || [];
    }
    async getUserTemplatesAssignedToAccount() {
        const queryParams = {
            $expand: 'userTemplates'
        };
        return this.getUserTemplateAssignments(queryParams).then((collection) => {
            return collection?.map(assignment => assignment._embedded.userTemplate) || [];
        });
    }
    async getAllUserTemplates() {
        const userTemplates = [this.getUserTemplates(), this.getUserTemplatesAssignedToAccount()];
        return Promise.all(userTemplates).then(values => values.reduce((acc, val) => acc.concat(val), []));
    }
    getLicenseTypeByBaseLicenseProperty(userTemplateBaseLicense) {
        var type = '';
        try {
            if (userTemplateBaseLicense
                .toLocaleLowerCase()
                .replace(/[ ]|[.]/g, '_')
                .replace(/[(]|[)]/g, '')
                .indexOf(licenseType.BUILD_YOUR_OWN) !== -1) {
                type = licenseType.BUILD_YOUR_OWN;
            }
        }
        catch (error) {
            console.log(`Error while setting up the type for userTemplateBaseLicense: ${userTemplateBaseLicense} -> error ${error}`);
        }
        return type;
    }
    getLicenseTierByNameProperty(userTemplateName) {
        var tier = '';
        try {
            if (userTemplateName.toLocaleLowerCase().indexOf(licenseUCCV40Tier.BASIC) !== -1) {
                tier = licenseUCCV40Tier.BASIC;
            }
            else if (userTemplateName.toLocaleLowerCase().indexOf(licenseUCCV40Tier.ENTRY) !== -1) {
                tier = licenseUCCV40Tier.ENTRY;
            }
            else if (userTemplateName.toLocaleLowerCase().indexOf(licenseUCCV40Tier.STANDARD) !== -1) {
                tier = licenseUCCV40Tier.STANDARD;
            }
            else if (userTemplateName.toLocaleLowerCase().indexOf(licenseUCCV40Tier.PREMIUM) !== -1) {
                tier = licenseUCCV40Tier.PREMIUM;
            }
            else if (userTemplateName.toLocaleLowerCase().replace(/ /g, '_').indexOf(licenseUCCV40Tier.HOTDESK_SIP_SOFTPHONE) !== -1) {
                tier = licenseUCCV40Tier.HOTDESK_SIP_SOFTPHONE;
            }
        }
        catch (error) {
            console.log(`Error while setting up the tier for userTemplateName: ${userTemplateName} -> error ${error}`);
        }
        return tier;
    }
    mapUserTemplateToUserConfiguration(userTemplate) {
        if (!userTemplate.pbxConfig) {
            return null;
        }
        else if (userTemplate.pbxConfig.userServiceTemplate) {
            //return { type: UserConfigurationDataType.MIVB_TEMPLATE, data: this.mapLearnedUserTemplateData(userTemplate) }; //template may have originated in MiVB or MiCollab
            return null;
        }
        else {
            return null;
        }
    }
    getTemplateLabel(template, accountId, parentTemplate) {
        let templateLabels = [];
        // learned label
        if (template.pbxConfig?.userServiceTemplate) {
            templateLabels.push(TemplateLabel.LEARNED);
        }
        // mitel default label
        if (template.pbxConfig?.uccServices?.defaultTemplate && template.pbxConfig?.uccServices?.defaultTemplate === true) {
            templateLabels.push(TemplateLabel.MITEL_DEFAULT);
        }
        // partner default label
        if (template.accountId !== accountId) {
            templateLabels.push(TemplateLabel.PARTNER_DEFAULT);
        }
        // customized label
        if (template.parentTemplateId) {
            if (parentTemplate && parentTemplate.accountId !== accountId) {
                if (!templateLabels.includes(TemplateLabel.PARTNER_DEFAULT)) {
                    templateLabels.push(TemplateLabel.PARTNER_DEFAULT);
                }
                templateLabels.push(TemplateLabel.CUSTOMIZED);
            }
            else if (template.pbxConfig?.userServiceTemplate) {
                templateLabels.push(TemplateLabel.CUSTOMIZED);
            }
        }
        return templateLabels;
    }
    static ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: TemplatesService, deps: [{ token: PropertyShareService }], target: i0.ɵɵFactoryTarget.Injectable });
    static ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: TemplatesService, providedIn: 'root' });
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: TemplatesService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root'
                }]
        }], ctorParameters: function () { return [{ type: PropertyShareService }]; } });

class ErrorAlertComponent {
    translateSvc;
    errorMessage = '';
    externalStyles = {};
    id = 'theAlert';
    constructor(translateSvc) {
        this.translateSvc = translateSvc;
    }
    static ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: ErrorAlertComponent, deps: [{ token: i2.TranslateService }], target: i0.ɵɵFactoryTarget.Component });
    static ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.2.12", type: ErrorAlertComponent, selector: "miccb-error-alert", inputs: { errorMessage: "errorMessage", externalStyles: "externalStyles", id: "id" }, ngImport: i0, template: "<div class=\"alert alert-custom\" [ngStyle]=\"externalStyles\" id=\"theAlert\">\n    <div class=\"row\">\n        <div class=\"col alert-custom-message\" id=\"theAlertMessage\">\n            <span [innerHTML]=\"errorMessage | translate\"></span>\n        </div>\n        <div class=\"col-auto\">\n            <span class=\"error-icon\">\n                <img src=\"assets/miccb-components/images/information-circle.svg\" />\n            </span>\n        </div>\n    </div>\n</div>\n", styles: [".alert-custom{background-color:#eb3530;min-height:30px;height:auto;border-radius:4px;border:solid 1px #eb3530;margin-top:10px}.alert{margin-bottom:0!important;padding-top:5px!important;padding-bottom:5px!important;padding-left:16px!important}.row{align-items:center}.alert-custom-message{font-family:Open Sans;min-height:21px;font-size:14px;font-weight:600;font-style:normal;font-stretch:normal;line-height:21px;letter-spacing:normal;color:#fff;vertical-align:middle}.error-icon img{vertical-align:middle!important;width:16px;height:16px;color:#fff}\n"], dependencies: [{ kind: "directive", type: i5.NgStyle, selector: "[ngStyle]", inputs: ["ngStyle"] }, { kind: "pipe", type: i2.TranslatePipe, name: "translate" }] });
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: ErrorAlertComponent, decorators: [{
            type: Component,
            args: [{ selector: 'miccb-error-alert', template: "<div class=\"alert alert-custom\" [ngStyle]=\"externalStyles\" id=\"theAlert\">\n    <div class=\"row\">\n        <div class=\"col alert-custom-message\" id=\"theAlertMessage\">\n            <span [innerHTML]=\"errorMessage | translate\"></span>\n        </div>\n        <div class=\"col-auto\">\n            <span class=\"error-icon\">\n                <img src=\"assets/miccb-components/images/information-circle.svg\" />\n            </span>\n        </div>\n    </div>\n</div>\n", styles: [".alert-custom{background-color:#eb3530;min-height:30px;height:auto;border-radius:4px;border:solid 1px #eb3530;margin-top:10px}.alert{margin-bottom:0!important;padding-top:5px!important;padding-bottom:5px!important;padding-left:16px!important}.row{align-items:center}.alert-custom-message{font-family:Open Sans;min-height:21px;font-size:14px;font-weight:600;font-style:normal;font-stretch:normal;line-height:21px;letter-spacing:normal;color:#fff;vertical-align:middle}.error-icon img{vertical-align:middle!important;width:16px;height:16px;color:#fff}\n"] }]
        }], ctorParameters: function () { return [{ type: i2.TranslateService }]; }, propDecorators: { errorMessage: [{
                type: Input
            }], externalStyles: [{
                type: Input
            }], id: [{
                type: Input
            }] } });

const logContext$9 = 'MiccbTemplateConfigurationComponent';
class MiccbTemplateConfigurationComponent {
    formBuilder;
    templatesService;
    translate;
    propertyShareSvc;
    user;
    collapsed = false;
    inputData = undefined;
    allInputsSentFromParent = new Subject();
    dirty = new EventEmitter();
    readyForInputs = new EventEmitter();
    updateProdStateEvent = new Subject();
    form = {};
    showFormError = false;
    errMsgStyle = { 'max-width': '500px' };
    loading = true;
    promises = [];
    userTemplates = [];
    templates = [];
    templateOptions = [];
    templateSelection;
    setupComplete = false;
    enableSave = false;
    longNameTemplatesDetermined = false;
    _onDestroy = new Subject();
    constructor(formBuilder, templatesService, translate, propertyShareSvc) {
        this.formBuilder = formBuilder;
        this.templatesService = templatesService;
        this.translate = translate;
        this.propertyShareSvc = propertyShareSvc;
    }
    ngOnInit() {
        this.initForm();
        this.allInputsSentFromParent.pipe(takeUntil(this._onDestroy)).subscribe(() => {
            if (this.inputData?.templateId) {
                // Caller is providing a default template
                this.form.controls['templateId'].patchValue(this.inputData.templateId, { emitEvent: false });
                this.updateState();
            }
        });
        const templatePromise = this.templatesService
            .getAllUserTemplates()
            .then(templates => {
            if (templates) {
                templates = templates.filter(template => !!template?.pbxConfig?.cceServiceTemplate);
                this.userTemplates = templates;
                this.templates = this.processData(templates).sort((a, b) => a.name.localeCompare(b.name));
                this.templates.unshift(this.setNoneTemplate());
            }
            // Use readyForInputs to tell the parent that we've subscribed to allInputsSentFromParent and are ready to receive inputs
            this.readyForInputs.emit();
        })
            .catch(error => {
            console.error(`${logContext$9}.getAllUserTemplates: ${error}`);
        });
        this.addPromise(templatePromise);
        // listen for search field value changes
        this.form.controls['searchTemplate'].valueChanges.pipe(takeUntil(this._onDestroy)).subscribe(() => {
            this.filterTemplateOptions();
        });
    }
    setNoneTemplate() {
        return {
            templateId: 'none',
            baseLicense: BaseLicense.BYO,
            labels: [],
            name: this.translate.instant('miccb_template_config.none'),
            type: licenseType.BUILD_YOUR_OWN,
            tier: ''
        };
    }
    addPromise(promise) {
        this.promises.push(promise);
        Promise.all(this.promises).then(values => {
            this.loading = false;
            this.filterTemplateOptions();
            return;
        });
    }
    initForm() {
        this.form = this.formBuilder.group({
            templateId: [undefined],
            searchTemplate: ['', []]
        });
    }
    processData(templates) {
        if (templates && templates.length > 0) {
            return templates.map(template => {
                return {
                    templateId: template.userTemplateId,
                    name: template.name,
                    labels: this.templatesService.getTemplateLabel(template, this.user.accountId ?? '', templates.find((userTemplate) => userTemplate.userTemplateId == template.parentTemplateId)),
                    collaborationEntitlement: template.collaborationEntitlement,
                    baseLicense: template.baseLicense,
                    type: this.templatesService.getLicenseTypeByBaseLicenseProperty(template.baseLicense),
                    tier: this.templatesService.getLicenseTierByNameProperty(template.name ?? '')
                };
            });
        }
        else {
            return [];
        }
    }
    isSaveDisabled() {
        return !this.enableSave;
    }
    getUpdateProdStateEventConfigComp() {
        return this.updateProdStateEvent;
    }
    updateState() {
        this.updateProdStateEvent.next('updateState');
    }
    determineLongNameSelectedTemplate() {
        if (this.templateSelection) {
            setTimeout(() => {
                document.querySelectorAll('.selected-template-name').forEach(el => {
                    if (el.scrollWidth > el.offsetWidth) {
                        this.templateSelection.longName = true;
                    }
                });
            }, 100);
        }
    }
    determineLongNameTemplates() {
        if (!this.longNameTemplatesDetermined) {
            document.querySelectorAll('.template-name').forEach((el, index) => {
                if (el.scrollWidth > el.offsetWidth) {
                    this.templateOptions[index].longName = true;
                }
            });
            this.longNameTemplatesDetermined = true;
        }
    }
    onTemplateChange(event) {
        let newTemplateSelection = this.templateOptions.find(option => option.templateId === event.value);
        if (newTemplateSelection) {
            this.templateSelection = newTemplateSelection;
            this.determineLongNameSelectedTemplate();
        }
        this.enableSave = !!this.templateSelection;
    }
    openedChangeTemplateSelection(opened) {
        if (opened) {
            this.filterTemplateOptions();
        }
        this.determineLongNameTemplates();
    }
    filterTemplateOptions() {
        this.templateOptions = this.templates;
        if (this.form.controls['searchTemplate'] && this.form.controls['searchTemplate'].value) {
            let search = this.form.controls['searchTemplate'].value?.trim().toLowerCase();
            if (search && this.templateOptions) {
                this.templateOptions = this.templateOptions.filter(template => template.name.toLocaleLowerCase().indexOf(search) !== -1);
            }
        }
    }
    getTemporaryTemplate() {
        let template = this.templateSelection;
        //remove none template selection if service chosen but not BYO
        if (template?.templateId === 'none') {
            template = undefined;
        }
        return template;
    }
    updateFormAfterTemporarySetup(temporaryTemplate) {
        //template updates
        this.templateSelection = temporaryTemplate;
        this.filterTemplateOptions();
        this.form.controls['templateId'].patchValue(this.templateSelection?.templateId, { emitEvent: false });
    }
    async onSave() {
        // mark form as dirty
        this.dirty.emit(true);
        // prevent clicking save setting again after saving
        this.enableSave = false;
        let temporaryTemplate = this.getTemporaryTemplate();
        if (temporaryTemplate?.templateId !== this.templateSelection?.templateId) {
            this.updateFormAfterTemporarySetup(temporaryTemplate);
        }
        this.propertyShareSvc.temporaryTemplate = this.userTemplates.find(userTemplate => userTemplate.userTemplateId === this.templateSelection?.templateId);
        console.log(`${logContext$9}.onSave`, this.propertyShareSvc.temporaryTemplate);
        return Promise.resolve(true);
    }
    ngOnDestroy() {
        this._onDestroy.next();
        this._onDestroy.complete();
    }
    static ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: MiccbTemplateConfigurationComponent, deps: [{ token: i1.UntypedFormBuilder }, { token: TemplatesService }, { token: i2.TranslateService }, { token: PropertyShareService }], target: i0.ɵɵFactoryTarget.Component });
    static ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.2.12", type: MiccbTemplateConfigurationComponent, selector: "miccb-template-configuration", inputs: { user: "user", collapsed: "collapsed", inputData: "inputData", allInputsSentFromParent: "allInputsSentFromParent" }, outputs: { dirty: "dirty", readyForInputs: "readyForInputs" }, ngImport: i0, template: "<div class=\"ipad-width\">\n    <div class=\"title-container\">\n        <div class=\"title\">{{ 'miccb_template_config.title' | translate }}</div>\n        <div class=\"sub-title\" [ngStyle]=\"{ display: !collapsed ? 'block' : 'none' }\">\n            <span>{{ 'miccb_template_config.description' | translate }}</span>\n        </div>\n    </div>\n    <div class=\"step-section\" [ngStyle]=\"{ display: !collapsed ? 'block' : 'none' }\">\n        <div class=\"error-message\" *ngIf=\"showFormError\">\n            <miccb-error-alert [errorMessage]=\"'miccb_template_config.errors.generic-error' | translate\" [externalStyles]=\"errMsgStyle\">\n            </miccb-error-alert>\n        </div>\n\n        <div class=\"row section-container\" *ngIf=\"!loading\">\n            <div class=\"col section-details\">\n                <div class=\"title\">{{ 'miccb_template_config.template' | translate }}</div>\n            </div>\n            <div class=\"col section-content\">\n                <h6 class=\"title\">{{ 'miccb_template_config.choose_template' | translate }}</h6>\n                <div class=\"section\">\n                    <mat-form-field tabindex=\"0\" class=\"form-input\">\n                        <mat-label>{{ 'miccb_template_config.template' | translate }}</mat-label>\n                        <mat-select\n                            id=\"template\"\n                            data-e2e=\"cap-template-dropdown\"\n                            (selectionChange)=\"onTemplateChange($event)\"\n                            [formControl]=\"form.controls['templateId']\"\n                            (openedChange)=\"openedChangeTemplateSelection($event)\"\n                        >\n                            <mat-select-trigger *ngIf=\"templateSelection\">\n                                <div\n                                    class=\"template-name-with-label\"\n                                    matTooltip=\"{{ templateSelection.name }}\"\n                                    [matTooltipDisabled]=\"!templateSelection.longName\"\n                                    matTooltipPosition=\"above\"\n                                >\n                                    <div class=\"selected-template-name\">\n                                        {{ templateSelection.name }}\n                                    </div>\n                                    <div class=\"label-badge-container\">\n                                        <div *ngFor=\"let label of templateSelection.labels\" class=\"badge {{ label }}-label-badge\">\n                                            {{ 'miccb_template_config.label.' + label | translate | uppercase }}\n                                        </div>\n                                    </div>\n                                </div>\n                            </mat-select-trigger>\n                            <mat-option>\n                                <ngx-mat-select-search\n                                    name=\"searchTemplate\"\n                                    ngDefaultControl\n                                    tabindex=\"0\"\n                                    id=\"searchTemplate\"\n                                    [formControl]=\"form.controls['searchTemplate']\"\n                                    [ariaLabel]=\"'miccb_template_config.search' | translate\"\n                                    [placeholderLabel]=\"'miccb_template_config.search' | translate\"\n                                    [noEntriesFoundLabel]=\"'miccb_template_config.no_matching_template_found' | translate\"\n                                >\n                                    <div class=\"mat-select-search-custom-header-content search-icon\">\n                                        <img src=\"../assets/images/search-big.svg\" />\n                                    </div>\n                                </ngx-mat-select-search>\n                            </mat-option>\n                            <mat-option\n                                *ngFor=\"let template of templateOptions\"\n                                [value]=\"template.templateId\"\n                                matTooltip=\"{{ template.name }}\"\n                                [matTooltipDisabled]=\"!template.longName\"\n                                matTooltipPosition=\"above\"\n                            >\n                                <div class=\"template-name-with-label\">\n                                    <div class=\"template-name\">\n                                        {{ template.name }}\n                                    </div>\n                                    <div class=\"label-badge-container\">\n                                        <div *ngFor=\"let label of template.labels\" class=\"badge {{ label }}-label-badge\">\n                                            {{ 'miccb_template_config.label.' + label | translate | uppercase }}\n                                        </div>\n                                    </div>\n                                </div>\n                            </mat-option>\n                        </mat-select>\n                    </mat-form-field>\n                </div>\n            </div>\n        </div>\n\n        <div class=\"spinner-state\" *ngIf=\"loading\">\n            <img src=\"assets/miccb-components/images/Spinner.png\" class=\"licenses-loading animate-spinner\" />\n        </div>\n\n        <div class=\"form-buttons\">\n            <div class=\"move-right\">\n                <button\n                    mat-flat-button\n                    [disabled]=\"!enableSave\"\n                    color=\"primary\"\n                    attr.aria-label=\"{{ 'miccb_template_config.buttons.apply_changes' | translate }}\"\n                    data-e2e=\"cap-apply-changes-button\"\n                    (click)=\"updateState()\"\n                >\n                    {{ 'miccb_template_config.buttons.apply_changes' | translate }}\n                </button>\n            </div>\n        </div>\n    </div>\n</div>\n", styles: ["@charset \"UTF-8\";.title-container{margin-bottom:16px;margin-top:0}.title-container .title{font-family:Open Sans,serif;font-weight:600;font-size:22px;font-style:normal;font-stretch:normal;line-height:1.45;letter-spacing:normal;color:#1f1f1f}.title-container .sub-title{font-family:Open Sans;font-weight:600;font-size:14px;font-style:normal;font-stretch:normal;line-height:1.45;letter-spacing:normal;color:#1f1f1f}.step-section{margin-top:16px}.step-section .section-container:first-child{border-top:1px solid #d1d6db}.step-section .section-container{margin:0 -20px}.step-section .section-container .title{font-family:Open Sans,serif;font-weight:600;font-size:14px;font-style:normal;font-stretch:normal;line-height:1.45;letter-spacing:normal;color:#1f1f1f}.step-section .section-container>.col{border-bottom:1px solid #d1d6db;padding:16px 24px 17px}.step-section .section-details{border-right:1px solid #d1d6db;background:#f1f4f8;max-width:280px;padding-top:24px!important}.step-section .section-details .section-details-container{position:sticky;top:87px}.step-section .section-details .title{font-family:Open Sans,serif;font-style:normal;font-weight:600;font-size:16px;line-height:24px;color:#464b51}.step-section .section-details .description{font-family:Open Sans,serif;font-style:normal;font-weight:400;font-size:12px;line-height:16px;color:#595e64}.step-section .section{margin:20px 0}.step-section .section .checkbox-section{display:flex;flex-direction:row;align-items:center;margin-bottom:.5rem}.step-section .section .checkbox-section input[type=checkbox]{-webkit-appearance:none;width:16px;height:16px;border-radius:4px;border:solid 1px #d1d6db;background-image:linear-gradient(to top,#f2f4f7,#fff)}.step-section .section .checkbox-section input[type=checkbox]:checked{border-color:#0080e7;background-image:linear-gradient(to top,#0080e7,#0080e7);transform:translate(0)}.step-section .section .checkbox-section input[type=checkbox]:checked:disabled{background:linear-gradient(0deg,#fff9,#fff9),#0073d0;border-color:#d1d6db}.step-section .section .checkbox-section input[type=checkbox]:checked:disabled+label{font-weight:600;color:#49505761}.step-section .section .checkbox-section input[type=checkbox]:checked:after{content:\"\\2713\";color:#fff;position:absolute;left:50%;top:50%;transform:translate(-50%,-50%)}.step-section .section .checkbox-section input[type=checkbox]:checked+label{color:#1f1f1f;font-weight:600}.step-section .section .checkbox-section input[type=checkbox]:disabled{background-image:linear-gradient(to top,#d1d6db,#d1d6db80)}.step-section .section .checkbox-section input[type=checkbox]:disabled+label{color:#49505761}.step-section .section .checkbox-section input[type=checkbox]:focus{outline:none;box-shadow:0 0 5px 1px #2ea2f8}.step-section .section .checkbox-section label{margin-left:8px;margin-bottom:0;font-family:Open Sans;font-size:14px;font-weight:400;font-stretch:normal;font-style:normal;line-height:1.375;letter-spacing:normal;color:#495057}.step-section .section .checkbox-section .error-margin{margin-left:8px}.step-section .chosen{display:flex;flex-direction:row}.step-section .change-button{margin-right:10px}.step-section .error-message{margin-bottom:10px}.step-section .alert{margin-left:0;margin-bottom:0;margin-top:5px;font-size:12px;color:#595e64;font-family:Open Sans,serif;padding:0}.step-section .alert p{display:inline}.step-section .alert .alert-icon{width:16px;height:16px;margin-right:5px;vertical-align:text-top}.step-section .form-buttons{display:flex;margin:20px 10px 0}.step-section .form-buttons .move-right{margin-left:auto;margin-right:0}.step-section .spinner-state{height:36px;padding-top:2px;overflow:hidden}.step-section .spinner-state .licenses-loading{height:27px;width:27px;opacity:.6;display:inline-block;vertical-align:middle;white-space:nowrap}.step-section .spinner-state .animate-spinner{animation:rotate .75s linear infinite}.template-name-with-label{display:flex;gap:8px;align-items:center}.template-name-with-label .selected-template-name,.template-name-with-label .template-name{font-family:Open Sans,serif;font-weight:400;font-style:normal;font-stretch:normal;line-height:1.45;letter-spacing:normal;max-width:-moz-fit-content;max-width:fit-content;white-space:nowrap;overflow:hidden;text-overflow:ellipsis}.template-name-with-label .label-badge-container{display:flex;gap:8px;float:right;max-width:-moz-fit-content;max-width:fit-content;white-space:nowrap}.template-name-with-label .label-badge-container .badge{white-space:nowrap;font-family:Open Sans,serif;font-weight:600;font-size:10px;width:-moz-fit-content;width:fit-content;padding:2px 5px;height:20px;line-height:15px;color:#fff}.template-name-with-label .label-badge-container .mitel_default-label-badge{background-color:#6db6ac}.template-name-with-label .label-badge-container .learned-label-badge{background-color:#0081b3}.template-name-with-label .label-badge-container .partner_default-label-badge{background-color:#002856}.template-name-with-label .label-badge-container .customized-label-badge{background-color:#6f9240}::ng-deep .mat-select-search-inside-mat-option .mat-select-search-input{padding-left:40px!important;font-family:Open Sans;font-size:14px;font-weight:400;font-style:normal;font-stretch:normal;line-height:1.5;letter-spacing:normal}.search-icon{width:50px;height:32px;margin-top:-30px;padding-left:15px;pointer-events:none}@media only screen and (device-width: 768px){.ipad-width{max-width:unset!important}}@media only screen and (min-device-width: 481px) and (max-device-width: 1024px) and (orientation: portrait){.ipad-width{max-width:unset!important}}@media only screen and (min-device-width: 481px) and (max-device-width: 1024px) and (orientation: landscape){.ipad-width{max-width:unset!important}}@keyframes rotate{to{-webkit-transform:rotate(360deg)}}\n"], dependencies: [{ kind: "directive", type: i5.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { kind: "directive", type: i5.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: i5.NgStyle, selector: "[ngStyle]", inputs: ["ngStyle"] }, { kind: "component", type: i8.MatFormField, selector: "mat-form-field", inputs: ["hideRequiredMarker", "color", "floatLabel", "appearance", "subscriptSizing", "hintLabel"], exportAs: ["matFormField"] }, { kind: "directive", type: i8.MatLabel, selector: "mat-label" }, { kind: "directive", type: i1.DefaultValueAccessor, selector: "input:not([type=checkbox])[formControlName],textarea[formControlName],input:not([type=checkbox])[formControl],textarea[formControl],input:not([type=checkbox])[ngModel],textarea[ngModel],[ngDefaultControl]" }, { kind: "directive", type: i1.NgControlStatus, selector: "[formControlName],[ngModel],[formControl]" }, { kind: "directive", type: i1.FormControlDirective, selector: "[formControl]", inputs: ["formControl", "disabled", "ngModel"], outputs: ["ngModelChange"], exportAs: ["ngForm"] }, { kind: "component", type: i7.MatSelect, selector: "mat-select", inputs: ["disabled", "disableRipple", "tabIndex", "panelWidth", "hideSingleSelectionIndicator"], exportAs: ["matSelect"] }, { kind: "directive", type: i7.MatSelectTrigger, selector: "mat-select-trigger" }, { kind: "component", type: i8$1.MatOption, selector: "mat-option", exportAs: ["matOption"] }, { kind: "component", type: i9.MatButton, selector: "    button[mat-button], button[mat-raised-button], button[mat-flat-button],    button[mat-stroked-button]  ", inputs: ["disabled", "disableRipple", "color"], exportAs: ["matButton"] }, { kind: "directive", type: i10.MatTooltip, selector: "[matTooltip]", exportAs: ["matTooltip"] }, { kind: "component", type: i11.MatSelectSearchComponent, selector: "ngx-mat-select-search", inputs: ["placeholderLabel", "type", "closeIcon", "closeSvgIcon", "noEntriesFoundLabel", "clearSearchInput", "searching", "disableInitialFocus", "enableClearOnEscapePressed", "preventHomeEndKeyPropagation", "disableScrollToActiveOnOptionsChanged", "ariaLabel", "showToggleAllCheckbox", "toggleAllCheckboxChecked", "toggleAllCheckboxIndeterminate", "toggleAllCheckboxTooltipMessage", "toggleAllCheckboxTooltipPosition", "hideClearSearchButton", "alwaysRestoreSelectedOptionsMulti"], outputs: ["toggleAll"] }, { kind: "component", type: ErrorAlertComponent, selector: "miccb-error-alert", inputs: ["errorMessage", "externalStyles", "id"] }, { kind: "pipe", type: i5.UpperCasePipe, name: "uppercase" }, { kind: "pipe", type: i2.TranslatePipe, name: "translate" }] });
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: MiccbTemplateConfigurationComponent, decorators: [{
            type: Component,
            args: [{ selector: 'miccb-template-configuration', template: "<div class=\"ipad-width\">\n    <div class=\"title-container\">\n        <div class=\"title\">{{ 'miccb_template_config.title' | translate }}</div>\n        <div class=\"sub-title\" [ngStyle]=\"{ display: !collapsed ? 'block' : 'none' }\">\n            <span>{{ 'miccb_template_config.description' | translate }}</span>\n        </div>\n    </div>\n    <div class=\"step-section\" [ngStyle]=\"{ display: !collapsed ? 'block' : 'none' }\">\n        <div class=\"error-message\" *ngIf=\"showFormError\">\n            <miccb-error-alert [errorMessage]=\"'miccb_template_config.errors.generic-error' | translate\" [externalStyles]=\"errMsgStyle\">\n            </miccb-error-alert>\n        </div>\n\n        <div class=\"row section-container\" *ngIf=\"!loading\">\n            <div class=\"col section-details\">\n                <div class=\"title\">{{ 'miccb_template_config.template' | translate }}</div>\n            </div>\n            <div class=\"col section-content\">\n                <h6 class=\"title\">{{ 'miccb_template_config.choose_template' | translate }}</h6>\n                <div class=\"section\">\n                    <mat-form-field tabindex=\"0\" class=\"form-input\">\n                        <mat-label>{{ 'miccb_template_config.template' | translate }}</mat-label>\n                        <mat-select\n                            id=\"template\"\n                            data-e2e=\"cap-template-dropdown\"\n                            (selectionChange)=\"onTemplateChange($event)\"\n                            [formControl]=\"form.controls['templateId']\"\n                            (openedChange)=\"openedChangeTemplateSelection($event)\"\n                        >\n                            <mat-select-trigger *ngIf=\"templateSelection\">\n                                <div\n                                    class=\"template-name-with-label\"\n                                    matTooltip=\"{{ templateSelection.name }}\"\n                                    [matTooltipDisabled]=\"!templateSelection.longName\"\n                                    matTooltipPosition=\"above\"\n                                >\n                                    <div class=\"selected-template-name\">\n                                        {{ templateSelection.name }}\n                                    </div>\n                                    <div class=\"label-badge-container\">\n                                        <div *ngFor=\"let label of templateSelection.labels\" class=\"badge {{ label }}-label-badge\">\n                                            {{ 'miccb_template_config.label.' + label | translate | uppercase }}\n                                        </div>\n                                    </div>\n                                </div>\n                            </mat-select-trigger>\n                            <mat-option>\n                                <ngx-mat-select-search\n                                    name=\"searchTemplate\"\n                                    ngDefaultControl\n                                    tabindex=\"0\"\n                                    id=\"searchTemplate\"\n                                    [formControl]=\"form.controls['searchTemplate']\"\n                                    [ariaLabel]=\"'miccb_template_config.search' | translate\"\n                                    [placeholderLabel]=\"'miccb_template_config.search' | translate\"\n                                    [noEntriesFoundLabel]=\"'miccb_template_config.no_matching_template_found' | translate\"\n                                >\n                                    <div class=\"mat-select-search-custom-header-content search-icon\">\n                                        <img src=\"../assets/images/search-big.svg\" />\n                                    </div>\n                                </ngx-mat-select-search>\n                            </mat-option>\n                            <mat-option\n                                *ngFor=\"let template of templateOptions\"\n                                [value]=\"template.templateId\"\n                                matTooltip=\"{{ template.name }}\"\n                                [matTooltipDisabled]=\"!template.longName\"\n                                matTooltipPosition=\"above\"\n                            >\n                                <div class=\"template-name-with-label\">\n                                    <div class=\"template-name\">\n                                        {{ template.name }}\n                                    </div>\n                                    <div class=\"label-badge-container\">\n                                        <div *ngFor=\"let label of template.labels\" class=\"badge {{ label }}-label-badge\">\n                                            {{ 'miccb_template_config.label.' + label | translate | uppercase }}\n                                        </div>\n                                    </div>\n                                </div>\n                            </mat-option>\n                        </mat-select>\n                    </mat-form-field>\n                </div>\n            </div>\n        </div>\n\n        <div class=\"spinner-state\" *ngIf=\"loading\">\n            <img src=\"assets/miccb-components/images/Spinner.png\" class=\"licenses-loading animate-spinner\" />\n        </div>\n\n        <div class=\"form-buttons\">\n            <div class=\"move-right\">\n                <button\n                    mat-flat-button\n                    [disabled]=\"!enableSave\"\n                    color=\"primary\"\n                    attr.aria-label=\"{{ 'miccb_template_config.buttons.apply_changes' | translate }}\"\n                    data-e2e=\"cap-apply-changes-button\"\n                    (click)=\"updateState()\"\n                >\n                    {{ 'miccb_template_config.buttons.apply_changes' | translate }}\n                </button>\n            </div>\n        </div>\n    </div>\n</div>\n", styles: ["@charset \"UTF-8\";.title-container{margin-bottom:16px;margin-top:0}.title-container .title{font-family:Open Sans,serif;font-weight:600;font-size:22px;font-style:normal;font-stretch:normal;line-height:1.45;letter-spacing:normal;color:#1f1f1f}.title-container .sub-title{font-family:Open Sans;font-weight:600;font-size:14px;font-style:normal;font-stretch:normal;line-height:1.45;letter-spacing:normal;color:#1f1f1f}.step-section{margin-top:16px}.step-section .section-container:first-child{border-top:1px solid #d1d6db}.step-section .section-container{margin:0 -20px}.step-section .section-container .title{font-family:Open Sans,serif;font-weight:600;font-size:14px;font-style:normal;font-stretch:normal;line-height:1.45;letter-spacing:normal;color:#1f1f1f}.step-section .section-container>.col{border-bottom:1px solid #d1d6db;padding:16px 24px 17px}.step-section .section-details{border-right:1px solid #d1d6db;background:#f1f4f8;max-width:280px;padding-top:24px!important}.step-section .section-details .section-details-container{position:sticky;top:87px}.step-section .section-details .title{font-family:Open Sans,serif;font-style:normal;font-weight:600;font-size:16px;line-height:24px;color:#464b51}.step-section .section-details .description{font-family:Open Sans,serif;font-style:normal;font-weight:400;font-size:12px;line-height:16px;color:#595e64}.step-section .section{margin:20px 0}.step-section .section .checkbox-section{display:flex;flex-direction:row;align-items:center;margin-bottom:.5rem}.step-section .section .checkbox-section input[type=checkbox]{-webkit-appearance:none;width:16px;height:16px;border-radius:4px;border:solid 1px #d1d6db;background-image:linear-gradient(to top,#f2f4f7,#fff)}.step-section .section .checkbox-section input[type=checkbox]:checked{border-color:#0080e7;background-image:linear-gradient(to top,#0080e7,#0080e7);transform:translate(0)}.step-section .section .checkbox-section input[type=checkbox]:checked:disabled{background:linear-gradient(0deg,#fff9,#fff9),#0073d0;border-color:#d1d6db}.step-section .section .checkbox-section input[type=checkbox]:checked:disabled+label{font-weight:600;color:#49505761}.step-section .section .checkbox-section input[type=checkbox]:checked:after{content:\"\\2713\";color:#fff;position:absolute;left:50%;top:50%;transform:translate(-50%,-50%)}.step-section .section .checkbox-section input[type=checkbox]:checked+label{color:#1f1f1f;font-weight:600}.step-section .section .checkbox-section input[type=checkbox]:disabled{background-image:linear-gradient(to top,#d1d6db,#d1d6db80)}.step-section .section .checkbox-section input[type=checkbox]:disabled+label{color:#49505761}.step-section .section .checkbox-section input[type=checkbox]:focus{outline:none;box-shadow:0 0 5px 1px #2ea2f8}.step-section .section .checkbox-section label{margin-left:8px;margin-bottom:0;font-family:Open Sans;font-size:14px;font-weight:400;font-stretch:normal;font-style:normal;line-height:1.375;letter-spacing:normal;color:#495057}.step-section .section .checkbox-section .error-margin{margin-left:8px}.step-section .chosen{display:flex;flex-direction:row}.step-section .change-button{margin-right:10px}.step-section .error-message{margin-bottom:10px}.step-section .alert{margin-left:0;margin-bottom:0;margin-top:5px;font-size:12px;color:#595e64;font-family:Open Sans,serif;padding:0}.step-section .alert p{display:inline}.step-section .alert .alert-icon{width:16px;height:16px;margin-right:5px;vertical-align:text-top}.step-section .form-buttons{display:flex;margin:20px 10px 0}.step-section .form-buttons .move-right{margin-left:auto;margin-right:0}.step-section .spinner-state{height:36px;padding-top:2px;overflow:hidden}.step-section .spinner-state .licenses-loading{height:27px;width:27px;opacity:.6;display:inline-block;vertical-align:middle;white-space:nowrap}.step-section .spinner-state .animate-spinner{animation:rotate .75s linear infinite}.template-name-with-label{display:flex;gap:8px;align-items:center}.template-name-with-label .selected-template-name,.template-name-with-label .template-name{font-family:Open Sans,serif;font-weight:400;font-style:normal;font-stretch:normal;line-height:1.45;letter-spacing:normal;max-width:-moz-fit-content;max-width:fit-content;white-space:nowrap;overflow:hidden;text-overflow:ellipsis}.template-name-with-label .label-badge-container{display:flex;gap:8px;float:right;max-width:-moz-fit-content;max-width:fit-content;white-space:nowrap}.template-name-with-label .label-badge-container .badge{white-space:nowrap;font-family:Open Sans,serif;font-weight:600;font-size:10px;width:-moz-fit-content;width:fit-content;padding:2px 5px;height:20px;line-height:15px;color:#fff}.template-name-with-label .label-badge-container .mitel_default-label-badge{background-color:#6db6ac}.template-name-with-label .label-badge-container .learned-label-badge{background-color:#0081b3}.template-name-with-label .label-badge-container .partner_default-label-badge{background-color:#002856}.template-name-with-label .label-badge-container .customized-label-badge{background-color:#6f9240}::ng-deep .mat-select-search-inside-mat-option .mat-select-search-input{padding-left:40px!important;font-family:Open Sans;font-size:14px;font-weight:400;font-style:normal;font-stretch:normal;line-height:1.5;letter-spacing:normal}.search-icon{width:50px;height:32px;margin-top:-30px;padding-left:15px;pointer-events:none}@media only screen and (device-width: 768px){.ipad-width{max-width:unset!important}}@media only screen and (min-device-width: 481px) and (max-device-width: 1024px) and (orientation: portrait){.ipad-width{max-width:unset!important}}@media only screen and (min-device-width: 481px) and (max-device-width: 1024px) and (orientation: landscape){.ipad-width{max-width:unset!important}}@keyframes rotate{to{-webkit-transform:rotate(360deg)}}\n"] }]
        }], ctorParameters: function () { return [{ type: i1.UntypedFormBuilder }, { type: TemplatesService }, { type: i2.TranslateService }, { type: PropertyShareService }]; }, propDecorators: { user: [{
                type: Input
            }], collapsed: [{
                type: Input
            }], inputData: [{
                type: Input
            }], allInputsSentFromParent: [{
                type: Input
            }], dirty: [{
                type: Output
            }], readyForInputs: [{
                type: Output
            }] } });

var FormStatus;
(function (FormStatus) {
    FormStatus["VALID"] = "VALID";
    FormStatus["INVALID"] = "INVALID";
})(FormStatus || (FormStatus = {}));
class FormStatusManager {
    name;
    status;
    _errors;
    dirty;
    constructor(name) {
        this.name = name;
        this.status = FormStatus.VALID;
        this._errors = [];
        this.dirty = false;
    }
    set errors(errors) {
        this._errors = errors;
        this.status = this.hasErrors() ? FormStatus.INVALID : FormStatus.VALID;
    }
    get errors() {
        return this._errors;
    }
    isValid() {
        if (this.status == FormStatus.VALID) {
            return true;
        }
        else {
            return false;
        }
    }
    errorCount() {
        return this._errors.length;
    }
    hasErrors() {
        return this._errors.length > 0;
    }
}

class FormStatusService {
    translateService;
    update$ = new Subject();
    _userConfiguration;
    _contactCenterEmployee;
    constructor(translateService) {
        this.translateService = translateService;
    }
    get userConfiguration() {
        return this._userConfiguration;
    }
    get contactCenterEmployee() {
        return this._contactCenterEmployee;
    }
    get errorInForm() {
        return this._userConfiguration.hasErrors();
    }
    get errorCount() {
        return this._userConfiguration.errorCount();
    }
    set contactCenterErrors(errors) {
        if (!!this._contactCenterEmployee) {
            this._contactCenterEmployee.errors = errors;
            this.updateStatusManager();
        }
    }
    init() {
        this._userConfiguration = new FormStatusManager(this.translateService.instant('miccb_user_config.title'));
        this._contactCenterEmployee = new FormStatusManager(this.translateService.instant('miccb_user_config.contactCenter'));
    }
    updateStatusManager() {
        let formErrors = [];
        if (!!this._contactCenterEmployee && this._contactCenterEmployee.hasErrors()) {
            formErrors.push(...this._contactCenterEmployee.errors);
        }
        if (this._userConfiguration.errors !== formErrors) {
            this._userConfiguration.errors = formErrors;
            this.update$.next();
        }
    }
    getFormValidationErrors(form) {
        let errors = [];
        Object.keys(form.controls).forEach(key => {
            if (form.controls[key] instanceof UntypedFormGroup) {
                errors = errors.concat(this.getFormValidationErrors(form.controls[key]));
            }
            const controlErrors = form.get(key)?.errors;
            if (controlErrors != null) {
                errors.push({ key: key, value: controlErrors });
            }
        });
        return errors;
    }
    getTableOfContents() {
        let tableOfContentsList = [];
        tableOfContentsList.push({
            id: 'contactCenterEmployee',
            name: this.translateService.instant('miccb_user_config.contactCenter'),
            errorCount: 0,
            dirty: this._contactCenterEmployee.dirty,
            parentId: 'UserConfigurationComponent'
        });
        return tableOfContentsList;
    }
    getItemFromTableOfContentsById(itemId) {
        return this.getItemFromTableOfContents(this.getTableOfContents(), itemId);
    }
    getItemFromTableOfContents(items, itemId) {
        for (let item of items) {
            if (item.id === itemId) {
                return item;
            }
            if (Array.isArray(item.subContentList) && item.subContentList.length > 0) {
                return this.getItemFromTableOfContents(item.subContentList, itemId);
            }
        }
        return;
    }
    hasTableOfContentsUnsavedChanges() {
        return this.hasItemUnsavedChanges(this.getTableOfContents());
    }
    hasItemUnsavedChanges(items) {
        if (items && items.length) {
            let isDirty = !!items.find(sc => sc.dirty);
            if (isDirty) {
                return true;
            }
            for (let item of items) {
                if (item.subContentList) {
                    return this.hasItemUnsavedChanges(item.subContentList);
                }
            }
        }
        return false;
    }
    static ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FormStatusService, deps: [{ token: i2.TranslateService }], target: i0.ɵɵFactoryTarget.Injectable });
    static ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FormStatusService, providedIn: 'root' });
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FormStatusService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root'
                }]
        }], ctorParameters: function () { return [{ type: i2.TranslateService }]; } });

var ComponentTypes;
(function (ComponentTypes) {
    ComponentTypes["ANY"] = "*";
    ComponentTypes["MiVB"] = "mivoice-business";
    ComponentTypes["MBG"] = "mitel-border-gateway";
    ComponentTypes["MiccB"] = "micc-business";
    ComponentTypes["MiCollab"] = "micollab";
    ComponentTypes["MiVo400"] = "mivoice-office-400";
    ComponentTypes["MiVo5000"] = "mivoice-5000";
    ComponentTypes["MxOne"] = "mx-one";
    ComponentTypes["CL_GW"] = "cloudlink-gateway";
    ComponentTypes["CLD"] = "cloudlink-daemon";
    ComponentTypes["DEPLOY_U"] = "deploy-u";
})(ComponentTypes || (ComponentTypes = {}));
var ServiceTypes;
(function (ServiceTypes) {
    ServiceTypes["ADMIN_API"] = "adminapi";
    ServiceTypes["CLGWAPI"] = "clgwapi";
    ServiceTypes["CTIAPI"] = "ctiapi";
    ServiceTypes["ADMIN_PORTAL"] = "adminportal";
})(ServiceTypes || (ServiceTypes = {}));
var SubResourceParentType;
(function (SubResourceParentType) {
    SubResourceParentType["component"] = "component";
    SubResourceParentType["platform"] = "platform";
})(SubResourceParentType || (SubResourceParentType = {}));
var SystemGroupStatus;
(function (SystemGroupStatus) {
    SystemGroupStatus["NONE"] = "none";
    SystemGroupStatus["ALREADY_JOINED"] = "already_joined";
    SystemGroupStatus["MODIFYING"] = "modifying";
    SystemGroupStatus["LEAVING"] = "leaving";
    SystemGroupStatus["JOINING"] = "joining";
})(SystemGroupStatus || (SystemGroupStatus = {}));
var SystemGroupAdditionalOptionTypes;
(function (SystemGroupAdditionalOptionTypes) {
    SystemGroupAdditionalOptionTypes["PRESENCE"] = "presence";
    SystemGroupAdditionalOptionTypes["SKILL_LEVEL"] = "skillLevel";
})(SystemGroupAdditionalOptionTypes || (SystemGroupAdditionalOptionTypes = {}));

/**
 * A simple TTL Cache.
 * I wrote this because I could not get https://www.npmjs.com/package/lru-cache to compile.
 *   lru-cache does not compile -- Support for the experimental syntax 'classProperties' isn't currently enabled
 */
class TtlCache {
    ttlMs;
    cache = new Map();
    /**
     * @param ttlMs cached items time to live, in miliseconds
     */
    constructor(ttlMs) {
        this.ttlMs = ttlMs;
    }
    isExpired(item) {
        const now = Date.now();
        return item.expiryTime < now;
    }
    set(key, value) {
        this.cache.set(key, { expiryTime: Date.now() + this.ttlMs, value: value });
    }
    get(key) {
        const item = this.cache.get(key);
        if (!!item) {
            if (this.isExpired(item)) {
                this.cache.delete(key);
            }
            else {
                return item.value;
            }
        }
        return undefined;
    }
    /**
     *
     * @param key
     * @returns true if key exists and not expired
     */
    has(key) {
        return this.get(key) !== undefined;
    }
    /**
     * @param key
     * @returns @returns — true if an element in the Map existed and has been removed, or false if the element does not exist.
     */
    delete(key) {
        return this.cache.delete(key);
    }
}

var employeeErrorSeverityType;
(function (employeeErrorSeverityType) {
    employeeErrorSeverityType["ERROR"] = "Error";
    employeeErrorSeverityType["WARN"] = "Warning";
})(employeeErrorSeverityType || (employeeErrorSeverityType = {}));
var SupervisorLicenseLabel;
(function (SupervisorLicenseLabel) {
    // This acts as a map to the key found in supervisorLicenseType property of the Employee interface
    // and the value is the label that is displayed in the UI.
    // key = 'value'
    SupervisorLicenseLabel["None"] = "None";
    SupervisorLicenseLabel["Advanced"] = "Advanced";
    SupervisorLicenseLabel["Premium"] = "System Administrator";
})(SupervisorLicenseLabel || (SupervisorLicenseLabel = {}));

class AdminService {
    Configuration = Config;
    api;
    constructor() {
        // setting up admin service.
        this.api = new AdminService$1({
            notify: this.Configuration.notifications,
            http: this.Configuration.httpService,
            cloud: this.Configuration.cloud
        });
    }
    async tryUpdateTagsOfUserByAccountId(accountId, userId, body, existingTags) {
        console.log(body, existingTags);
        const updatedTags = {};
        let newTags;
        for (const updatedTagId of Object.keys(body)) {
            if (existingTags[updatedTagId] !== undefined) {
                if (!_.isEqual(existingTags[updatedTagId], body[updatedTagId])) {
                    const tagValue = typeof body[updatedTagId] === 'string' ? JSON.stringify(body[updatedTagId]) : body[updatedTagId];
                    let result = body[updatedTagId];
                    await this.updateUserTagByAccountId(accountId, userId, updatedTagId, tagValue).catch(err => {
                        console.log('Failed to update tag:' + updatedTagId + ' for user: ', userId, body[updatedTagId], '***', JSON.stringify(body[updatedTagId]));
                        result = existingTags[updatedTagId];
                    });
                    updatedTags[updatedTagId] = result;
                }
            }
            else {
                if (!newTags) {
                    newTags = {};
                }
                newTags[updatedTagId] = body[updatedTagId];
            }
        }
        if (newTags) {
            return await this.createUserTagByAccountId(accountId, userId, newTags).catch(err => {
                console.log('Failed to create new tags for user with userId', userId);
                return { ...existingTags, ...updatedTags };
            });
        }
        return { ...existingTags, ...updatedTags };
    }
    updateUserTagByAccountId(accountId, userId, tagId, body) {
        return this.api.updateUserTagByAccountId({ accountId, userId, tagId, body });
    }
    deleteUserTagByAccountIdWithoutSpinner(accountId, userId, tagId) {
        return this.api.deleteUserTagByAccountId({ accountId, userId, tagId });
    }
    createUserTagByAccountId(accountId, userId, body) {
        return new Promise(async (resolve, reject) => {
            try {
                const result = await this.api.createUserTagByAccountId({ accountId, userId, body });
                delete result._links;
                console.log('user tags are: ', result);
                resolve(result);
            }
            catch (err) {
                reject(err);
            }
        });
    }
    getUserTagsByAccountId(accountId, userId) {
        return new Promise(async (resolve, reject) => {
            try {
                const result = await this.api.getUserTagsByAccountId({ accountId, userId });
                delete result._links;
                console.log('user tags are: ', result);
                resolve(result);
            }
            catch (err) {
                resolve({});
            }
        });
    }
    getAccountTags(accountId) {
        console.log('fetching tags');
        return this.api
            .getAccountTags({ accountId })
            .then(tags => {
            return tags;
        })
            .catch(err => {
            throw err;
        });
    }
    getAccountTag(accountId, tagId) {
        return this.api.getAccountTag({ accountId, tagId })
            .catch(error => {
            if (error.body?.name === "NoAccountTagForTagId") {
                return undefined;
            }
            throw error;
        });
    }
    /**
     * Creates a new tag for the account.   If tagId already exist it will overwrite.
     * @param accountId
     * @param tagId
     * @param body
     * @returns
     */
    createAccountTag(accountId, body) {
        return this.api.createAccountTag({ accountId, body });
    }
    deleteAccountTag(accountId, tagId) {
        return this.api.deleteAccountTag({ accountId, tagId })
            .catch(error => {
            if (error.body?.name === "NoAccountTagForTagId") {
                return undefined;
            }
            throw error;
        });
    }
    getSites(accountId, odata, options) {
        if (odata) {
            return this.api.getSites({
                accountId,
                $Top: odata.$Top,
                $Skip: odata.$Skip,
                $Expand: odata.$Expand,
                $SkipToken: odata.$SkipToken,
                options
            });
        }
        else {
            return this.api.getSites({ accountId, options });
        }
    }
    // returns the first siteId for an account
    getSiteIdForAccount(accountId) {
        console.log(`Requesting the siteId for account ${accountId}`);
        return this.getSites(accountId).then(siteCollection => {
            if (siteCollection && siteCollection.count > 0 && siteCollection._embedded && siteCollection._embedded.items) {
                let sites = siteCollection._embedded.items;
                console.log(`All the sites for account ${sites}`);
                if (sites[0]) {
                    return sites[0].siteId;
                }
                else {
                    return undefined;
                }
            }
            else {
                return undefined;
            }
        });
    }
    getUser(userId) {
        return this.api.getUser({ userId: userId });
    }
    static ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: AdminService, deps: [], target: i0.ɵɵFactoryTarget.Injectable });
    static ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: AdminService, providedIn: 'root' });
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: AdminService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root'
                }]
        }], ctorParameters: function () { return []; } });

// import { Context, HttpService, HttpOptions } from '@mitel-internal/cloudlink-platform-common';
// import { config } from '../config';
// import { Logger } from '../utils/logger';
// import { TunnelCacheService } from './tunnel-cache.service';
// import { compareVersions } from 'compare-versions';
const context = 'SystemManagerService';
class SystemManagerService {
    httpClient;
    base = Config$1.cloud === 'dev' ? 'https://system-manager.dev.api.mitel.io' : 'https://system-manager.api.mitel.io';
    baseUrl = `${this.base}/2023-07-01`;
    // private readonly cacheOptions = {
    //     ttl: 15 * 60 * 1000, // Max time to live for items before they are considered stale. in ms
    //     max: 25,
    //     updateAgeOnGet: false
    // };
    // /**
    //  * Cache SystemInventory by account ID
    //  */
    // private readonly cacheSystemInventory = new LRUCache<string, Promise<SystemInventory>>(this.cacheOptions);
    constructor(httpClient) {
        this.httpClient = httpClient;
    }
    /**
     * /components?$expand=services
     * @returns
     */
    getComponents() {
        const url = `${this.baseUrl}/components?$expand=services`;
        const token = localStorage.getItem("@mitel/token.access_token");
        const headers = new HttpHeaders()
            .set("Authorization", `Bearer ${token}`);
        return this.httpClient.get(url, { headers }).pipe(expand((response) => {
            if (response?._links?.next) {
                var nextUrl = `${this.base}${response._links.next}`;
                return this.httpClient.get(nextUrl, { headers });
            }
            else {
                return EMPTY;
            }
        }), reduce((acc, response) => acc.concat(this.mapComponentApp(response._embedded?.items ?? [])), []));
    }
    /**
     * Cleanup
     * @param componentsEmbedded
     * @returns
     */
    mapComponentApp(componentsEmbedded) {
        if (componentsEmbedded?.length > 0) {
            return componentsEmbedded.map(componentEmbedded => {
                const services = componentEmbedded._embedded?.services?._embedded?.items || [];
                const component = {
                    accountId: componentEmbedded.accountId,
                    parentId: componentEmbedded.parentId ?? '',
                    componentId: componentEmbedded.componentId ?? '',
                    componentType: componentEmbedded.componentType ?? '',
                    licenseId: componentEmbedded.licenseId ?? '',
                    name: componentEmbedded.name ?? '',
                    createdOn: componentEmbedded.createdOn ?? '',
                    createdBy: componentEmbedded.createdBy ?? '',
                    modifiedOn: componentEmbedded.modifiedOn ?? '',
                    modifiedBy: componentEmbedded.modifiedBy ?? '',
                    version: componentEmbedded.version ?? '',
                    services: services.map((service) => {
                        return {
                            serviceId: service.serviceId,
                            serviceType: service.serviceType,
                            serviceUrl: service.serviceUrl
                        };
                    }) || []
                };
                return component;
            });
        }
        else {
            return [];
        }
    }
    static ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: SystemManagerService, deps: [{ token: i1$1.HttpClient }], target: i0.ɵɵFactoryTarget.Injectable });
    static ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: SystemManagerService, providedIn: 'root' });
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: SystemManagerService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root'
                }]
        }], ctorParameters: function () { return [{ type: i1$1.HttpClient }]; } });

const logContext$8 = 'MiccbApiService';
class MiccbApiService {
    http;
    adminService;
    systemManagerService;
    static miccbComponentTagId = 'MiCCBComponent';
    tunnelUrl;
    /**
     * Cache of active MiCCB component ID by accountId
     */
    activeMiccbIdCache = new TtlCache(60 * 1000); // cache by account ID
    /**
     * Will be true if we presented what we thought was a valid MiCC-B componentId but recieved a 404.
     * Used to force a refresh of the componentId from System Manager microservice.
     */
    componentIdCompromised = false;
    constructor(http, adminService, systemManagerService) {
        this.http = http;
        this.adminService = adminService;
        this.systemManagerService = systemManagerService;
        this.tunnelUrl = Config.cloud === 'dev' ? 'https://tunnel.dev.api.mitel.io' : 'https://tunnel.api.mitel.io';
    }
    getSites(accountId) {
        return this.get(accountId, 'sites').pipe(map((response) => {
            console.log(`${logContext$8}.getSites:`, response);
            const embeddedItems = response?._embedded?.items || [];
            return embeddedItems.map((item) => ({
                id: item.id,
                label: item.name
            }));
        }), catchError(err => {
            console.error(`${logContext$8}.getSites:`, err);
            return throwError(err);
        }));
    }
    getSecurityRoles(accountId) {
        return this.get(accountId, 'securityroles').pipe(map((response) => {
            console.log(`${logContext$8}.getSecurityRoles:`, response);
            const embeddedItems = response?._embedded?.items || [];
            return embeddedItems.map((item) => ({
                id: item.id,
                label: item.name
            }));
        }), catchError(err => {
            console.error(`${logContext$8}.getSecurityRoles:`, err);
            return throwError(err);
        }));
    }
    getWorkloads(accountId) {
        return this.get(accountId, 'workloads').pipe(map((response) => {
            console.log(`${logContext$8}.getWorkloads:`, response);
            let items = [];
            if (Array.isArray(response)) {
                items = response;
            }
            return items.map((item) => ({
                id: item.id,
                label: item.name
            }));
        }), catchError(err => {
            console.error(`${logContext$8}.getWorkloads:`, err);
            return throwError(err);
        }));
    }
    getSupervisorLicenseTypes(accountId) {
        return this.get(accountId, 'general/supervisorLicenseTypes').pipe(map((response) => {
            console.log(`${logContext$8}.getSupervisorLicenseTypes:`, response);
            const embeddedItems = response?._embedded?.items || [];
            return embeddedItems.map((item) => ({
                id: item,
                label: SupervisorLicenseLabel[item] ?? item
            }));
        }), catchError(err => {
            console.error(`${logContext$8}.getSupervisorLicenseTypes:`, err);
            return throwError(err);
        }));
    }
    getPhoneTypes(accountId) {
        return this.get(accountId, 'general/phoneTypes').pipe(map((response) => {
            console.log(`${logContext$8}.getPhoneTypes:`, response);
            const embeddedItems = response?._embedded?.items || [];
            return embeddedItems.map((item) => ({
                id: item,
                label: item
            }));
        }), catchError(err => {
            console.error(`${logContext$8}.getPhoneTypes:`, err);
            return throwError(err);
        }));
    }
    getAuthType(accountId) {
        return this.get(accountId, 'enterprise').pipe(map((response) => {
            console.log(`${logContext$8}.getAuthType:`, response);
            return response?.authenticationType;
        }), catchError(err => {
            console.error(`${logContext$8}.getAuthType:`, err);
            return throwError(err);
        }));
    }
    getMediaServers(accountId) {
        return this.get(accountId, 'mediaservers').pipe(map((response) => {
            console.log(`${logContext$8}.getMediaServers:`, response);
            const embeddedItems = response?._embedded?.items || [];
            return embeddedItems.filter((item) => item.id !== ivrReportingMSId).map((item) => item.mediaType.toLowerCase());
        }), catchError(err => {
            console.error(`${logContext$8}.getMediaServers:`, err);
            return throwError(err);
        }));
    }
    getMediaServerByIpAddressOrDnsName(accountId, ipAddressOrDnsName) {
        return this.getSdk(accountId, `mediaservers?$filter=IpAddressOrDnsName eq '${ipAddressOrDnsName}'`).pipe(map((response) => {
            console.log(`${logContext$8}.getMediaServerByIpAddressOrDnsName:`, response);
            const embeddedItems = response?._embedded?.items || [];
            return embeddedItems[0].id;
        }), catchError(err => {
            console.error(`${logContext$8}.getMediaServerByIpAddressOrDnsName:`, err);
            return throwError(err);
        }));
    }
    getGatewayMediaServers(accountId) {
        return this.get(accountId, 'gatewaymediaservers').pipe(map((response) => {
            console.log(`${logContext$8}.gatewaymediaservers:`, response);
            const embeddedItems = response?._embedded?.items || [];
            return embeddedItems;
        }), catchError(err => {
            console.error(`${logContext$8}.gatewaymediaservers:`, err);
            return throwError(err);
        }));
    }
    getAgentGroupByReporting(accountId, reporting) {
        return this.get(accountId, `agents/groups?$filter=Reporting eq '${reporting}'`);
    }
    getAgentGroupByGroupIdNumber(accountId, number) {
        return this.get(accountId, `agents/groups?$filter=GroupIdNumber eq '${encodeURIComponent(number)}'`);
    }
    getAgentGroups(accountId) {
        return this.get(accountId, 'agents/groups');
    }
    createAgentGroup(accountId, body) {
        return this.post(accountId, 'agents/groups', body);
    }
    deleteAgentGroup(accountId, id) {
        return this.delete(accountId, `agents/groups/${id}?BypassWriteBack=true`);
    }
    updateAgentGroup(accountId, id, body) {
        return this.put(accountId, `agents/groups/${id}`, body);
    }
    getAgentGroupMembers(accountId, id) {
        return this.get(accountId, `agents/groups/${id}/members`);
    }
    getAgent(accountId, id) {
        return this.get(accountId, `agents/${id}`);
    }
    deleteAgentGroupMember(accountId, id, mid) {
        return this.delete(accountId, `agents/groups/${id}/members/${mid}?BypassWriteBack=true`);
    }
    addAgentGroupMember(accountId, id, body) {
        return this.post(accountId, `agents/groups/${id}/members`, body);
    }
    updateAgentGroupMember(accountId, id, mid, body) {
        return this.put(accountId, `agents/groups/${id}/members/${mid}`, body);
    }
    getAgentByReporting(accountId, reporting) {
        return this.get(accountId, `agents?$filter=Reporting eq '${reporting}'`);
    }
    createEmployee(accountId, body) {
        return this.post(accountId, 'employees', body);
    }
    validateEmployee(accountId, body) {
        return this.post(accountId, 'employees/validate', body);
    }
    getEmployee(accountId, id) {
        return this.getSdk(accountId, `employees/${id}`);
    }
    getEmployees(accountId, odataParam) {
        return this.getSdk(accountId, 'employees', odataParam);
    }
    updateEmployee(accountId, id, body) {
        return this.put(accountId, `employees/${id}`, body);
    }
    deleteEmployee(accountId, id) {
        return this.delete(accountId, `employees/${id}?BypassWriteBack=true`);
    }
    searchEmployees(accountId, term) {
        return this.get(accountId, `employees?$filter=isRealTime and contains(LastName, '${term}') or contains(FirstName, '${term}')`);
    }
    getEmployeeByCloudlinkId(accountId, cloudlinkId) {
        return this.get(accountId, `employees?$filter=CloudlinkId eq '${cloudlinkId}'`);
    }
    getEmployeeByEmail(accountId, email) {
        return this.get(accountId, `employees?$filter=contains(Email,'${email}')`);
    }
    getEmployeeByCloudlinkIdOrEmail(accountId, cloudlinkId, email) {
        return this.get(accountId, `employees?$filter=CloudlinkId eq '${cloudlinkId}' or contains(Email, '${email}')`);
    }
    getSecurityRole(accountId, securityRoleRefId) {
        return this.get(accountId, `securityRoles/${securityRoleRefId}`);
    }
    getEnterprise(accountId) {
        return this.get(accountId, 'enterprise');
    }
    getQueues(accountId, odataParam) {
        return this.get(accountId, 'queues', odataParam);
    }
    getQueueById(accountId, id) {
        return this.get(accountId, `queues/${id}`);
    }
    updateQueue(accountId, id, body) {
        body.BypassWriteBack = true;
        return this.put(accountId, `queues/${id}`, body);
    }
    deleteQueue(accountId, id) {
        return this.delete(accountId, `queues/${id}?BypassWriteBack=true`);
    }
    createQueue(accountId, body) {
        body.BypassWriteBack = true;
        return this.post(accountId, 'queues', body);
    }
    updateQueueMembers(accountId, id, body) {
        return this.post(accountId, `queues/${id}/member`, body);
    }
    getInQueueWorkflowById(accountId, id) {
        return this.get(accountId, `routing/workflows/${id}`);
    }
    getBusinessSchedules(accountId) {
        return this.get(accountId, 'businessschedules');
    }
    get(accountId, urlPath, odataParam) {
        return this._get(accountId, urlPath, odataParam).pipe(catchError(err => {
            if (err.status === 404) {
                // will retry
                console.warn(`${logContext$8}.get: error, will retry`, err);
                this.activeMiccbIdCache.delete(accountId);
                // force a refresh of the componentId that is stored in account.tags
                this.componentIdCompromised = true;
                return this._get(accountId, urlPath, odataParam).pipe(catchError(() => {
                    this.componentIdCompromised = false;
                    throw err;
                })); // 1 retry
            }
            else {
                throw err; // we do not want to retry
            }
        }));
    }
    _get(accountId, urlPath, odataParam) {
        const token = localStorage.getItem('@mitel/token.access_token');
        let headers = new HttpHeaders().set('Authorization', `Bearer ${token}`).set('x-mitel-tunnel-service', ServiceTypes.ADMIN_API);
        var url = `${this.tunnelUrl}/miccconfig/api/v1/${urlPath}`;
        if (!!odataParam) {
            url += '?' + odataParam;
        }
        return this.getActiveMiccbId(accountId).pipe(switchMap(componentId => {
            headers = headers.set('x-mitel-tunnel-component-id', componentId);
            return this.http.get(url, { headers });
        }));
    }
    getSdk(accountId, urlPath, odataParam) {
        return this._getSdk(accountId, urlPath, odataParam).pipe(catchError(err => {
            if (err.status === 404) {
                // will retry
                console.warn(`${logContext$8}.get: error, will retry`, err);
                this.activeMiccbIdCache.delete(accountId);
                // force a refresh of the componentId that is stored in account.tags
                this.componentIdCompromised = true;
                return this._get(accountId, urlPath, odataParam).pipe(catchError(() => {
                    this.componentIdCompromised = false;
                    throw err;
                })); // 1 retry
            }
            else {
                throw err; // we do not want to retry
            }
        }));
    }
    _getSdk(accountId, urlPath, odataParam) {
        const token = localStorage.getItem('@mitel/token.access_token');
        let headers = new HttpHeaders().set('Authorization', `Bearer ${token}`).set('x-mitel-tunnel-service', ServiceTypes.ADMIN_API);
        var url = `${this.tunnelUrl}/miccsdk/api/v1/${urlPath}`;
        if (!!odataParam) {
            url += '?' + odataParam;
        }
        return this.getActiveMiccbId(accountId).pipe(switchMap(componentId => {
            headers = headers.set('x-mitel-tunnel-component-id', componentId);
            return this.http.get(url, { headers });
        }));
    }
    post(accountId, urlPath, body) {
        const token = localStorage.getItem('@mitel/token.access_token');
        let headers = new HttpHeaders()
            .set('Authorization', `Bearer ${token}`)
            .set('Content-Type', 'application/json')
            .set('x-mitel-tunnel-service', ServiceTypes.ADMIN_API);
        return this.getActiveMiccbId(accountId).pipe(switchMap(componentId => {
            headers = headers.set('x-mitel-tunnel-component-id', componentId);
            return this.http.post(`${this.tunnelUrl}/miccconfig/api/v1/${urlPath}`, body, { headers });
        }));
    }
    put(accountId, urlPath, body) {
        const token = localStorage.getItem('@mitel/token.access_token');
        let headers = new HttpHeaders()
            .set('Authorization', `Bearer ${token}`)
            .set('Content-Type', 'application/json')
            .set('x-mitel-tunnel-service', ServiceTypes.ADMIN_API);
        return this.getActiveMiccbId(accountId).pipe(switchMap(componentId => {
            headers = headers.set('x-mitel-tunnel-component-id', componentId);
            return this.http.put(`${this.tunnelUrl}/miccconfig/api/v1/${urlPath}`, body, { headers });
        }));
    }
    delete(accountId, urlPath) {
        const token = localStorage.getItem('@mitel/token.access_token');
        let headers = new HttpHeaders().set('Authorization', `Bearer ${token}`).set('x-mitel-tunnel-service', ServiceTypes.ADMIN_API);
        return this.getActiveMiccbId(accountId).pipe(switchMap(componentId => {
            headers = headers.set('x-mitel-tunnel-component-id', componentId);
            return this.http.delete(`${this.tunnelUrl}/miccconfig/api/v1/${urlPath}`, { headers });
        }));
    }
    /**
     * Cached.
     * Get the System Manager/Inventory component ID for the active MiCCB server.
     * Obtained from account.tags or system-manager micro
     * @param accountId
     * @returns componentId of active MiCCB
     */
    getActiveMiccbId(accountId) {
        if (!this.activeMiccbIdCache.has(accountId)) {
            this.activeMiccbIdCache.set(accountId, this._getActiveMiccbId(accountId));
        }
        return this.activeMiccbIdCache.get(accountId);
    }
    _getActiveMiccbId(accountId) {
        let miccbComponentTag;
        return from(this.adminService.getAccountTag(accountId, MiccbApiService.miccbComponentTagId)).pipe(tap(componentTag => (miccbComponentTag = componentTag)), map(componentTag => componentTag?.active?.componentId), switchMap((componentId) => {
            if (!!componentId && !this.componentIdCompromised) {
                return of(componentId);
            }
            else {
                return this.getActiveComponentFromSystemManager().pipe(
                // The tag was empty. We now know there is only 1 component, so write that to the tags
                switchMap(component => from(this.updateMiccbComponentTag(accountId, miccbComponentTag, component).then(() => component))), map(component => component.componentId));
            }
        }), catchError(err => {
            this.activeMiccbIdCache.delete(accountId); // remove dead item from cache
            throw err;
        }), shareReplay(1));
    }
    updateMiccbComponentTag(accountId, existingTag, activeComponent) {
        const body = this.createTagObject(existingTag, activeComponent);
        return this.adminService
            .createAccountTag(accountId, { [MiccbApiService.miccbComponentTagId]: body })
            .finally(() => (this.componentIdCompromised = false));
    }
    /**
     * Will generate or modify an existing tag object.
     * @param accountId
     * @param existingTag an existing MiCCBComponent tag
     * @param activeComponent
     * @returns tag of type  MiccbApiService.miccbComponentTagId
     */
    createTagObject(existingTag, activeComponent) {
        return {
            ...existingTag,
            active: {
                ...existingTag?.active,
                name: activeComponent.name,
                componentId: activeComponent.componentId
            }
        };
    }
    /**
     * Gets MiCCB component from System Manager micro
     * @returns
     * @throws if fetch error or 0 or more than 1 MiCCB components found
     */
    getActiveComponentFromSystemManager() {
        return this.getMiccbComponents().pipe(map(components => {
            if (components.length === 0) {
                throw new Error(`${logContext$8} no MiCC-B component found`);
            }
            else if (components.length > 1) {
                console.log(`${logContext$8}.getActiveComponentFromSystemManager, conflict multiple MiCC-B components found:`, components);
                throw new Error(`${logContext$8} conflict, multiple MiCC-B components found`);
            }
            return components[0];
        }));
    }
    /**
     * @returns All components with type MiCCB and have ADMIN_API service
     */
    getMiccbComponents() {
        return this.systemManagerService
            .getComponents()
            .pipe(map(components => components.filter(c => c.componentType === ComponentTypes.MiccB && c.services.find(s => s.serviceType === ServiceTypes.ADMIN_API))));
    }
    flushActiveMiccbCache(accountId) {
        return this.activeMiccbIdCache.delete(accountId);
    }
    // Read list of MBGs if there are multiple Gateway Media Servers defined on MiCC to find the one that matches
    getMBGs() {
        const token = localStorage.getItem('@mitel/token.access_token');
        let headers = new HttpHeaders().set('Authorization', `Bearer ${token}`);
        const url = Config.cloud === 'dev'
            ? 'https://mivb.provisioning.dev.api.mitel.io/2017-09-01/mbgs'
            : 'https://mivb.provisioning.api.mitel.io/2017-09-01/mbgs';
        return this.http.get(url, { headers }).pipe(map((response) => {
            console.log(`${logContext$8}.mbgs:`, response);
            return response?.mbgs || [];
        }), catchError(err => {
            console.error(`${logContext$8}.mbgs:`, err);
            return throwError(err);
        }));
    }
    static ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: MiccbApiService, deps: [{ token: i1$1.HttpClient }, { token: AdminService }, { token: SystemManagerService }], target: i0.ɵɵFactoryTarget.Injectable });
    static ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: MiccbApiService, providedIn: 'root' });
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: MiccbApiService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root'
                }]
        }], ctorParameters: function () { return [{ type: i1$1.HttpClient }, { type: AdminService }, { type: SystemManagerService }]; } });

const logContext$7 = 'MiccbEmployeeService';
const MiccSecurityAccess = {
    All: 'all',
    ReadOnly: 'read-only',
    None: 'none',
    CommunicationError: 'communicationError'
};
class EmployeeService {
    apiService;
    adminService;
    translateService;
    _employee;
    set employee(employee) {
        this._employee = employee;
    }
    get employee() {
        return this._employee;
    }
    constructor(apiService, adminService, translateService) {
        this.apiService = apiService;
        this.adminService = adminService;
        this.translateService = translateService;
    }
    async createEmployee(accountId, reqBody) {
        let cloudlinkId = '';
        if (Array.isArray(reqBody) && reqBody.length > 0) {
            cloudlinkId = reqBody[0].cloudlinkId;
        }
        try {
            const res = await this.apiService.createEmployee(accountId, reqBody).toPromise();
            console.log(`${logContext$7}: create employee success.`, res);
            if (Array.isArray(res) && res.length > 0) {
                this.employee = this.mapEmployee(res[0]);
                return this.employee;
            }
            return undefined;
        }
        catch (error) {
            if (error instanceof HttpErrorResponse) {
                const msg = this.getMessageFromTags(error);
                if (msg) {
                    throw new Error(msg);
                }
            }
            console.error(`${logContext$7}: create employee failed.`, error);
            throw (error);
        }
    }
    async validateEmployee(accountId, reqBody) {
        if (Array.isArray(reqBody) && reqBody.length > 0) {
            try {
                const result = await this.apiService.validateEmployee(accountId, reqBody[0]).toPromise();
                if (Array.isArray(result) && result.length > 0) {
                    console.log(`${logContext$7}: validate employee`, result);
                }
                return result;
            }
            catch (error) {
                console.error(`${logContext$7}: validate emloyee`, error);
            }
        }
        else {
            console.error(`${logContext$7}: validate emloyee - invalid request`);
        }
    }
    async updateEmployee(accountId, id, reqBody) {
        try {
            const res = await this.apiService.updateEmployee(accountId, id, reqBody).toPromise();
            console.log(`${logContext$7}: update employee success.`, res);
            if (Array.isArray(res) && res.length > 0) {
                this.employee = this.mapEmployee(res[0]);
                return this.employee;
            }
            return undefined;
        }
        catch (error) {
            if (error instanceof HttpErrorResponse) {
                const msg = this.getMessageFromTags(error);
                if (msg) {
                    throw new Error(msg);
                }
            }
            console.error(`${logContext$7}: update employee failed.`, error);
            throw (error);
        }
    }
    /**
     * Convert MiCC error tags to translated message
     * @param error
     * @returns string
     */
    getMessageFromTags(error) {
        // {
        //     "status": 400,
        //     "statusText": "OK",
        //     "url": "https://tunnel.dev.api.mitel.io/miccconfig/api/v1/employees",
        //     "ok": false,
        //     "name": "HttpErrorResponse",
        //     "message": "Http failure response for https://tunnel.dev.api.mitel.io/miccconfig/api/v1/employees: 400 OK",
        //     "error": [
        //         "reporting_number_required",
        //         "no_devices_exist_for_employee"
        //     ]
        // }
        //
        // will return
        // You must enter a Reporting number. There are no devices associated with this employee.
        let msg;
        if (error.status === 400) {
            msg =
                error.error instanceof Array
                    ? error.error.map(errCode => this.translateService.instant(`miccb_user_config.validationErrors.${errCode}`)).join(' ')
                    : undefined;
            if (!msg && error.error?.message) {
                msg = error.error.message;
            }
        }
        return msg;
    }
    async deleteEmployee(accountId) {
        try {
            if (!!this.employee) {
                const result = await this.apiService.deleteEmployee(accountId, this.employee.id).toPromise();
                console.log(`${logContext$7}: delete employee success.`, { employee: this.employee, result });
                this.employee = undefined;
            }
        }
        catch (error) {
            console.error(`${logContext$7}: delete employee failed.`, { employee: this.employee });
        }
    }
    async getEmployeeByCloudlinkId(accountId, cloudlinkId) {
        try {
            const result = await this.apiService.getEmployeeByCloudlinkId(accountId, cloudlinkId).toPromise();
            console.log(`${logContext$7}: get employee by cloudlinkId success.`, { cloudlinkId, result });
            if (result?._embedded?.items.length > 0) {
                // $filter param in MiCCConfig is currently broken, so all users are returned.  Find the one that matches the CL ID
                if (result._embedded.items.length > 1) {
                    const employee = result._embedded.items.find(item => item.cloudlinkId === cloudlinkId);
                    this.employee = this.mapEmployee(employee);
                }
                else {
                    this.employee = this.mapEmployee(result._embedded.items[0]);
                }
            }
            if (result?._embedded?.items.length === 0) {
                this.employee = undefined;
            }
        }
        catch (error) {
            console.error(`${logContext$7}: get employee by cloudlinkId failed.`, cloudlinkId);
        }
    }
    async getEmployeeByCloudlinkIdOrEmail(accountId, cloudlinkId, email) {
        try {
            if (!email) {
                return this.getEmployeeByCloudlinkId(accountId, cloudlinkId); //fixxx check sync
            }
            const result = await this.apiService.getEmployeeByCloudlinkIdOrEmail(accountId, cloudlinkId, email.replaceAll("'", "''")).toPromise();
            console.log(`${logContext$7}: get Employee by cloudlinkId ${cloudlinkId} or email ${email} success.`, result);
            if (result?._embedded?.items.length > 0) {
                // $filter param in MiCCConfig is currently broken, so all users are returned.  Find the one that matches the CL ID
                if (result._embedded.items.length > 1) {
                    const employee = result._embedded.items.find(item => item.cloudlinkId === cloudlinkId || item.email === email);
                    this.employee = this.mapEmployee(employee);
                }
                else {
                    this.employee = this.mapEmployee(result._embedded.items[0]);
                }
            }
            if (result?._embedded?.items.length === 0) {
                this.employee = undefined;
            }
        }
        catch (error) {
            console.error(`${logContext$7}: get employee by cloudlinkId ${cloudlinkId} or email ${email} failed.`);
        }
    }
    async deleteEmployeeByCloudlinkId(accountId, cloudlinkId) {
        try {
            if (!!this.employee && this.employee.cloudlinkId === cloudlinkId) {
                await this.deleteEmployee(accountId);
            }
            if (!this.employee || this.employee.cloudlinkId !== cloudlinkId) {
                await this.getEmployeeByCloudlinkId(accountId, cloudlinkId);
                if (!!this.employee) {
                    await this.deleteEmployee(accountId);
                }
            }
        }
        catch (error) {
            console.error(`${logContext$7}: delete employee by cloudlinkId failed.`, { employee: this.employee });
        }
    }
    // Used to check logged on user's security role in MiCC-B.
    async getUserSecurityAccess() {
        let securityAccess = MiccSecurityAccess.None;
        try {
            const claims = await Config.authentication.whoAmI();
            if (!!claims) {
                const result = await this.apiService.getEmployee(claims.accountId, 'me').toPromise();
                if (!!result) {
                    // Ensure that the supervisorLicenseType is Premium; otherwise, MiCC APIs can't be accessed so treat the user as undefined
                    if (result.supervisorLicenseType === 'Premium') {
                        securityAccess = MiccSecurityAccess.ReadOnly;
                        const securityRoleResult = await this.apiService.getSecurityRole(claims.accountId, result.securityRoleRefId).toPromise();
                        if (!!securityRoleResult) {
                            console.log(`${logContext$7}.getUserSecurityAccess:`, securityRoleResult);
                            const securityRole = securityRoleResult?.mayManageDeviceConfiguration;
                            if (securityRole >= 2) {
                                securityAccess = MiccSecurityAccess.All;
                            }
                        }
                    }
                }
            }
        }
        catch (error) {
            console.error(`${logContext$7}: getUserSecurityAccess error=`, { error: error });
            if (error.status && error.status !== 401) {
                // 401 indicates user is not defined in MiCC-B or doesn't have access to the data
                // Other errors indicate the tunnel connection is down
                securityAccess = MiccSecurityAccess.CommunicationError;
            }
        }
        return securityAccess;
    }
    mapEmployee(result) {
        const employee = {
            id: result.id,
            name: result.name,
            firstName: result.firstName,
            lastName: result.lastName,
            reporting: result.reporting,
            email: result.email,
            username: result.username,
            password: result.password,
            siteRefId: result.siteRefId,
            securityRoleRefId: result.securityRoleRefId,
            language: result.language,
            workLoadRefId: result.workLoadRefId,
            preferredPrinter: result.preferredPrinter,
            printLocally: result.printLocally,
            useEmployeeEmailUseEmployeeEmailForReportDistribution: result.useEmployeeEmailUseEmployeeEmailForReportDistribution,
            supervisorLicenseType: result.supervisorLicenseType,
            phoneTypeLicense: result.phoneTypeLicense,
            hasLicenseForMCC: result.hasLicenseForMCC,
            hasLicenseForVoice: result.hasLicenseForVoice,
            isEnabledForVoice: result.isEnabledForVoice,
            isEnabledForEmail: result.isEnabledForEmail,
            isEnabledForChat: result.isEnabledForChat,
            isEnabledForSMS: result.isEnabledForSMS,
            isEnabledForOpenMedia: result.isEnabledForOpenMedia,
            cloudlinkId: result.cloudlinkId,
            photoUrl: result.photoUrl,
            lastModified: result.lastModified,
            lineUri: result.lineUri,
            isRealTime: result.isRealTime,
            isActive: result.isActive,
            isMaySeeAllQueuesEnabled: result.isMaySeeAllQueuesEnabled,
            gatewayMediaServerId: result.gatewayMediaServerId,
            isEnabledForWebRTC: result.isEnabledForWebRTC
        };
        return employee;
    }
    // Used to generate a password for users on systems with basic authentication
    // This is the same function used in Mitel Admin to generate MiCollab passwords
    createPassword() {
        /*
        Steps:
        1. Randomly determine the order of password requirements (e.g. numbers, letters, then special chars)
        2. Randomly determine the target length of the password (consider overall max & min, and each type's min)
        3. Randomly determine how many of each character type to use in password to achieve target length (consider each type's min)
        4. Randomly choose that many characters of each type
        5. Concat the selections and shuffle the characters
        */
        let password = '';
        let reqs = appPasswordRequirements.map(a => { return { ...a }; });
        //pick the order of character requirements to satify. ie. numbers, then letters, then special
        //for better randomization, don't always do the same order of character type
        let orderOfReqs = this.getRandomOrderOfRequirements(reqs.length); //Step 1
        let totalReservedForMinRequirements = 0;
        totalReservedForMinRequirements = reqs.reduce((a, b) => a + b.num, 0);
        let rangeMin = totalReservedForMinRequirements < appPasswordMinLength ? appPasswordMinLength : totalReservedForMinRequirements;
        if (0 === rangeMin || rangeMin > appPasswordMaxLength || !orderOfReqs) {
            console.log("Error with auto-password requirements");
        }
        else {
            let targetPasswordLength = this.randomIntFromInterval(rangeMin, appPasswordMaxLength); //Step 2
            let spacesUsed = totalReservedForMinRequirements;
            let k = 0;
            let rangeMax = appPasswordMaxLength;
            while (spacesUsed < targetPasswordLength) { //Step 3
                for (let j = 0; j < orderOfReqs.length; ++j) {
                    k = orderOfReqs[j];
                    rangeMin = reqs[k].num;
                    rangeMax = rangeMin + (targetPasswordLength - spacesUsed); //num already reserved by this type + free spaces that remain
                    if (rangeMax > rangeMin) {
                        spacesUsed = spacesUsed - reqs[k].num;
                        reqs[k].num = this.randomIntFromInterval(rangeMin, rangeMax);
                        spacesUsed = spacesUsed + reqs[k].num;
                    }
                    else {
                        break;
                    }
                }
            }
            if (spacesUsed === targetPasswordLength) {
                /*
                Step 4. Now that the number of each character type has been determined,
                randomly select that number of characters for each type. Repeats are allowed.
                Step 5 Once all the characters have been chosen for a type, concat them into the final password.
                Then do a final shuffle
                */
                reqs.forEach(req => {
                    req.selected = '';
                    for (let i = 0; i < req.num; ++i) {
                        req.selected = req.selected.concat(_.sample(req.characters) || '');
                    }
                    password = password.concat(req.selected);
                });
                password = (_.shuffle(password)).join("");
                console.log("Auto-generation of password complete");
            }
        }
        return password;
    }
    ;
    getRandomOrderOfRequirements(numOfRequirements) {
        let tempArray = [];
        let shuffleArray;
        if (numOfRequirements > 0) {
            for (let i = 0; i < numOfRequirements; ++i) {
                tempArray.push(i);
            }
            shuffleArray = _.shuffle(tempArray);
        }
        return shuffleArray;
    }
    ;
    randomIntFromInterval(min, max) {
        return Math.floor(Math.random() * (max - min + 1) + min);
    }
    ;
    static ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: EmployeeService, deps: [{ token: MiccbApiService }, { token: AdminService }, { token: i2.TranslateService }], target: i0.ɵɵFactoryTarget.Injectable });
    static ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: EmployeeService, providedIn: 'root' });
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: EmployeeService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root'
                }]
        }], ctorParameters: function () { return [{ type: MiccbApiService }, { type: AdminService }, { type: i2.TranslateService }]; } });

const LIB_VERSION = '16.0.36';
// Version convention
// Major = Angular Major version
// Minor = Cloudlink SDK Major version  (0 for alpha)

const logContext$6 = 'MiccbGenericToggleFieldComponent';
class GenericToggleFieldComponent {
    value = false;
    parentFormGroup = {};
    changeState = new EventEmitter();
    constructor() { }
    // is this required?
    ngOnChanges(changes) {
        console.log('ngOnChanges - currentValue', changes.value.currentValue);
        console.log(`${logContext$6}.ngOnChanges - currentValue`, changes.value.currentValue);
        this.value = changes.value.currentValue;
        this.changeState.emit({ value: this.value });
    }
    getFormControl(control) {
        return control;
    }
    static ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: GenericToggleFieldComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
    static ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.2.12", type: GenericToggleFieldComponent, selector: "miccb-generic-toggle-field", inputs: { value: "value", parentFormGroup: "parentFormGroup" }, outputs: { changeState: "changeState" }, usesOnChanges: true, ngImport: i0, template: "<div class=\"toggle-field-item-box\">\n    <label class=\"toggle\">\n        <input\n            type=\"checkbox\"\n            [checked]=\"value\"\n            [formControl]=\"getFormControl(parentFormGroup.controls['contactCenter'])\"\n        />\n        <span class=\"slider round\"></span>\n    </label>\n</div>\n", styles: [".toggle{position:relative;display:inline-block;right:0;width:36px;height:20px;margin-top:.25rem;margin-bottom:.25rem}.toggle-field-item-box{height:48px;display:table-cell;vertical-align:middle;margin-right:10px;padding-right:10px}.toggle input{opacity:0;width:0;height:0}.slider{position:absolute;cursor:pointer;inset:0;background-color:#bac1c7;transition:.4s}.slider:before{position:absolute;content:\"\";height:16px;width:16px;left:2px;bottom:2px;background-color:#fff;transition:.4s}input:checked+.slider{background-color:#2196f3}input:checked:disabled+.slider{background-color:#b5d6f2}input:disabled+.slider{background-color:#d8d8d8;cursor:default}input:focus+.slider{box-shadow:0 0 5px 1px #2196f3}input:checked+.slider:before{transform:translate(16px)}.slider.round{border-radius:34px}.slider.round:before{border-radius:50%}\n"], dependencies: [{ kind: "directive", type: i1.CheckboxControlValueAccessor, selector: "input[type=checkbox][formControlName],input[type=checkbox][formControl],input[type=checkbox][ngModel]" }, { kind: "directive", type: i1.NgControlStatus, selector: "[formControlName],[ngModel],[formControl]" }, { kind: "directive", type: i1.FormControlDirective, selector: "[formControl]", inputs: ["formControl", "disabled", "ngModel"], outputs: ["ngModelChange"], exportAs: ["ngForm"] }] });
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: GenericToggleFieldComponent, decorators: [{
            type: Component,
            args: [{ selector: 'miccb-generic-toggle-field', template: "<div class=\"toggle-field-item-box\">\n    <label class=\"toggle\">\n        <input\n            type=\"checkbox\"\n            [checked]=\"value\"\n            [formControl]=\"getFormControl(parentFormGroup.controls['contactCenter'])\"\n        />\n        <span class=\"slider round\"></span>\n    </label>\n</div>\n", styles: [".toggle{position:relative;display:inline-block;right:0;width:36px;height:20px;margin-top:.25rem;margin-bottom:.25rem}.toggle-field-item-box{height:48px;display:table-cell;vertical-align:middle;margin-right:10px;padding-right:10px}.toggle input{opacity:0;width:0;height:0}.slider{position:absolute;cursor:pointer;inset:0;background-color:#bac1c7;transition:.4s}.slider:before{position:absolute;content:\"\";height:16px;width:16px;left:2px;bottom:2px;background-color:#fff;transition:.4s}input:checked+.slider{background-color:#2196f3}input:checked:disabled+.slider{background-color:#b5d6f2}input:disabled+.slider{background-color:#d8d8d8;cursor:default}input:focus+.slider{box-shadow:0 0 5px 1px #2196f3}input:checked+.slider:before{transform:translate(16px)}.slider.round{border-radius:34px}.slider.round:before{border-radius:50%}\n"] }]
        }], ctorParameters: function () { return []; }, propDecorators: { value: [{
                type: Input
            }], parentFormGroup: [{
                type: Input
            }], changeState: [{
                type: Output
            }] } });

const logContext$5 = 'MiccbEmployeeComponent';
class EmployeeComponent {
    matIconRegistry;
    domSanitizer;
    miccApiService;
    employeeService;
    translateService;
    formBuilder;
    cd;
    Accordion;
    expansionPanels;
    action;
    /**
     *  Indicate the case of micc only where there is no mivb so there is no mivb component UI.
     *  Will be true if the MiVB UX is not present, such as in MiCC-B only deployments.
     */
    nonmivb = false;
    /**
     * If client is creating a user from a template, and the template includes contact center stuff, we pass you that as an input
     */
    cceServiceTemplate;
    user;
    formStatusSvc;
    interProductDataShareSvc;
    onFormChanged = new EventEmitter();
    static emptyGuid = '00000000-0000-0000-0000-000000000000';
    miccbForm = {};
    miccbAuthType = '';
    subscription = new Subscription();
    baseUrl = '';
    voiceMediaDisableReason = '';
    deskphoneOnly = false;
    miccbSecurityAccess = '';
    showAgentLoginID = false;
    showLineUri = false;
    version = LIB_VERSION;
    validation$ = new Subject();
    validationErrors = [];
    disableActivate = false;
    isEmployeeInactive = false;
    showToggleContactCenter = true;
    enableContactCenter = false;
    employeeMiccId = '';
    generatedEmployeePassword = '';
    sites$;
    securityRoles$;
    workloads$;
    supervisorLicenseTypes$;
    authType$;
    mediaServers$;
    // Placeholder item in Phone Type list to be used when Hot Desk + Integrated Softphone is added as extension type in
    phoneTypes = [];
    deskphoneTypes = [];
    constructor(matIconRegistry, domSanitizer, miccApiService, employeeService, translateService, formBuilder, cd) {
        this.matIconRegistry = matIconRegistry;
        this.domSanitizer = domSanitizer;
        this.miccApiService = miccApiService;
        this.employeeService = employeeService;
        this.translateService = translateService;
        this.formBuilder = formBuilder;
        this.cd = cd;
        this.matIconRegistry.addSvgIcon('caution-circle', this.domSanitizer.bypassSecurityTrustResourceUrl('assets/miccb-components/images/caution-circ-solid.svg'));
        this.matIconRegistry.addSvgIcon('caution', this.domSanitizer.bypassSecurityTrustResourceUrl('assets/miccb-components/images/caution.svg'));
    }
    async ngOnInit() {
        this.initForm();
        if (this.nonmivb) {
            this.deskphoneOnly = true;
            this.showAgentLoginID = false;
            this.showToggleContactCenter = false;
            this.enableContactCenter = true;
        }
        this.miccbSecurityAccess = await this.employeeService.getUserSecurityAccess();
        console.log(`${logContext$5}.ngOnInit setting userSecurityAccess to ${this.miccbSecurityAccess}`);
        this.updateReadOnlySetting();
        if (this.cceServiceTemplate) {
            console.log(`${logContext$5}.ngOnInit cceServiceTemplate`, this.cceServiceTemplate);
            // inits the form from that template
            this.setForm(this.cceServiceTemplate);
        }
        this.sites$ = this.miccApiService.getSites(this.user.accountId);
        this.securityRoles$ = this.miccApiService.getSecurityRoles(this.user.accountId);
        this.workloads$ = this.miccApiService.getWorkloads(this.user.accountId);
        this.supervisorLicenseTypes$ = this.miccApiService.getSupervisorLicenseTypes(this.user.accountId);
        this.authType$ = this.miccApiService.getAuthType(this.user.accountId);
        this.mediaServers$ = this.miccApiService.getMediaServers(this.user.accountId);
        this.miccApiService
            .getPhoneTypes(this.user.accountId)
            .toPromise()
            .then(items => {
            items.map(item => {
                item.label = this.translateService.instant(`miccb_user_config.phoneTypes.${item.id}`);
            });
            this.phoneTypes.push(...items);
            this.deskphoneTypes = this.phoneTypes.filter(item => item.id.toLowerCase() === 'deskphone');
        });
        const employee = await this.getEmployee();
        if (!!employee) {
            this.employeeMiccId = employee.id;
        }
        await this.applyEmployee(employee); // load form with employee
        if (this.nonmivb) {
            if (this.miccbForm.get('voice')?.value === true) {
                this.showLineUri = true;
                if (!employee && this.user.extension) {
                    this.miccbForm.controls['lineUri'].patchValue(this.user.extension);
                }
            }
        }
        /**
         * Form is now populated, notify interested parties - DO NOT MARK AS DIRTY
         */
        this.handleFormChange(false);
        this.subscription.add(this.authType$.subscribe(value => {
            this.miccbAuthType = value;
        }));
        this.subscription.add(this.validation$.subscribe(value => {
            this.employeeValidator();
        }));
        this.subscription.add(this.mediaServers$.subscribe((mediaTypes) => {
            if (!mediaTypes.includes('voice')) {
                this.miccbForm.get('voice')?.setValue(false);
                this.miccbForm.get('voice')?.disable();
                // this supercedes noACDAgentPhone
                this.voiceMediaDisableReason = this.translateService.instant('miccb_user_config.mediaTypeNotAvailable', {
                    type: this.translateService.instant('miccb_user_config.voice')
                });
                this.showAgentLoginID = false;
                this.showLineUri = false;
            }
            if (!mediaTypes.includes('chat')) {
                this.miccbForm.get('chat')?.setValue(false);
                this.miccbForm.get('chat')?.disable();
            }
            if (!mediaTypes.includes('email')) {
                this.miccbForm.get('email')?.setValue(false);
                this.miccbForm.get('email')?.disable();
            }
            if (!mediaTypes.includes('sms')) {
                this.miccbForm.get('sms')?.setValue(false);
                this.miccbForm.get('sms')?.disable();
            }
            if (!mediaTypes.includes('openmedia')) {
                this.miccbForm.get('openMedia')?.setValue(false);
                this.miccbForm.get('openMedia')?.disable();
            }
        }));
        if (!this.nonmivb && !!this.interProductDataShareSvc && this.allowedToModifyCCData()) {
            this.checkACDsData(employee);
            this.subscription.add(this.interProductDataShareSvc.numberOfACDsChanged.subscribe(() => {
                console.log(`${logContext$5} Numbers of ACD Agent configured`, this.interProductDataShareSvc.numberOfACDsData.count);
                this.checkACDsData(employee);
            }));
        }
        this.listenForFormUpdates();
    }
    listenForFormUpdates() {
        console.log(`${logContext$5}.detectFormChange`);
        const initialFormValues = JSON.stringify(this.miccbForm.getRawValue());
        this.miccbForm.valueChanges.subscribe(values => {
            const updatedValues = JSON.stringify(this.miccbForm.getRawValue());
            if (updatedValues !== initialFormValues) {
                this.miccbForm.markAsDirty();
                this.handleFormChange(true);
            }
            else {
                this.miccbForm.markAsPristine();
                this.handleFormChange(false);
            }
        });
    }
    checkACDsData(employee) {
        console.log(`${logContext$5} agentDNs`, this.interProductDataShareSvc.agentDNs);
        let extension = '';
        const count = this.interProductDataShareSvc.agentDNs.length;
        if (count > 0) {
            extension = this.interProductDataShareSvc.agentDNs[count - 1];
        }
        if (this.interProductDataShareSvc.numberOfACDsData.count === 0) {
            this.miccbForm.get('voice')?.setValue(false);
            this.miccbForm.get('voice')?.disable();
            if (!this.voiceMediaDisableReason) {
                this.voiceMediaDisableReason = this.translateService.instant('miccb_user_config.noACDAgentPhone');
            }
            this.deskphoneOnly = true;
            this.showAgentLoginID = false;
        }
        else if (this.interProductDataShareSvc.numberOfACDsData.count > 0) {
            this.miccbForm.get('voice')?.enable();
            this.deskphoneOnly = false;
            if (this.miccbForm.get('voice')?.value === true) {
                this.showAgentLoginID = true;
            }
            if (!!employee && employee.id && employee.lineUri) {
                // make it read-only on edit employee, if the value exists
                this.miccbForm.get('agentLoginID')?.disable();
            }
            if (!employee || !employee.lineUri) {
                // set default if employee is not defined or lineUri not yet defined
                this.miccbForm.controls['agentLoginID'].patchValue(extension);
            }
        }
    }
    // Update form controls to read-only if security setting doesn't allow updates
    updateReadOnlySetting() {
        if (this.miccbSecurityAccess !== MiccSecurityAccess.All) {
            for (const field in this.miccbForm.controls) {
                this.miccbForm.controls[field]?.disable();
            }
        }
    }
    async applyEmployee(employee) {
        if (!!employee) {
            console.log(`${logContext$5}.applyEmployee:`, {
                id: employee.id,
                site: employee.siteRefId,
                securityRole: employee.securityRoleRefId,
                voice: employee.isEnabledForVoice,
                chat: employee.isEnabledForChat,
                email: employee.isEnabledForEmail,
                sms: employee.isEnabledForSMS,
                openMedia: employee.isEnabledForOpenMedia,
                workloadDescriptor: employee.workLoadRefId,
                supervisorLicense: employee.supervisorLicenseType,
                phoneTypeLicense: employee.phoneTypeLicense,
                isMaySeeAllQueuesEnabled: employee.isMaySeeAllQueuesEnabled,
                reporting: employee.reporting,
                lineUri: employee.lineUri,
                isRealTime: employee.isRealTime,
                isActive: employee.isActive,
                gatewayMediaServerId: employee.gatewayMediaServerId
            });
            this.miccbForm.controls['site'].patchValue(employee.siteRefId);
            this.miccbForm.controls['securityRole'].patchValue(employee.securityRoleRefId);
            this.miccbForm.controls['reporting'].patchValue(employee.reporting);
            this.miccbForm.controls['agentLoginID'].patchValue(employee.lineUri);
            this.miccbForm.controls['lineUri'].patchValue(employee.lineUri);
            this.miccbForm.controls['voice'].patchValue(employee.isEnabledForVoice);
            this.miccbForm.controls['chat'].patchValue(employee.isEnabledForChat);
            this.miccbForm.controls['email'].patchValue(employee.isEnabledForEmail);
            this.miccbForm.controls['sms'].patchValue(employee.isEnabledForSMS);
            this.miccbForm.controls['openMedia'].patchValue(employee.isEnabledForOpenMedia);
            this.miccbForm.controls['workloadDescriptor'].patchValue(employee.workLoadRefId);
            this.miccbForm.controls['networkPrinter'].patchValue(employee.preferredPrinter);
            this.miccbForm.controls['printLocally'].patchValue(employee.printLocally);
            this.miccbForm.controls['useEmailForDistribution'].patchValue(employee.useEmployeeEmailUseEmployeeEmailForReportDistribution);
            this.miccbForm.controls['seeAllQueues'].patchValue(employee.isMaySeeAllQueuesEnabled);
            this.miccbForm.controls['supervisorLicense'].patchValue(employee.supervisorLicenseType);
            this.miccbForm.controls['mccLicense'].patchValue(employee.hasLicenseForMCC);
            this.miccbForm.controls['voiceLicense'].patchValue(employee.hasLicenseForVoice);
            this.miccbForm.controls['username'].patchValue(employee.username);
            this.miccbForm.controls['phoneTypeLicense'].patchValue(employee.phoneTypeLicense);
            // If employee is deactivated in MiCC-B, set all controls to read-only until the employee is activated
            // Only allow activation if logged on user has full access in MiCC-B
            if (!employee.isActive && this.miccbSecurityAccess === MiccSecurityAccess.All) {
                this.isEmployeeInactive = true;
                if (!this.nonmivb) {
                    this.showToggleContactCenter = false;
                    this.enableContactCenter = true;
                }
                for (const field in this.miccbForm.controls) {
                    this.miccbForm.controls[field]?.disable();
                }
            }
            else {
                this.isEmployeeInactive = false;
                if (!this.nonmivb) {
                    this.showToggleContactCenter = true;
                    this.enableContactCenter = true;
                }
            }
            this.miccbForm.controls['contactCenter'].patchValue(this.enableContactCenter);
            this.miccbForm.markAsDirty();
            this.cd.detectChanges();
        }
    }
    initForm() {
        this.miccbForm = this.formBuilder.group({
            site: ['', [Validators.required]],
            securityRole: ['', [Validators.required]],
            reporting: ['', [Validators.required]],
            agentLoginID: ['', [this.agentLoginIDValidator()]],
            lineUri: ['', [this.lineUriValidator()]],
            voice: [false],
            chat: [false],
            email: [false],
            sms: [false],
            openMedia: [false],
            workloadDescriptor: ['', [Validators.required]],
            networkPrinter: [''],
            printLocally: [false],
            useEmailForDistribution: [false],
            seeAllQueues: [false],
            supervisorLicense: ['', [Validators.required]],
            phoneTypeLicense: ['', [Validators.required]],
            mccLicense: [{ value: false, disabled: true }],
            voiceLicense: [{ value: false, disabled: true }],
            username: [''],
            contactCenter: [false]
        });
    }
    setForm(cceServiceTemplate) {
        if (!!cceServiceTemplate) {
            this.enableContactCenter = true;
            this.miccbForm.controls['site'].patchValue(cceServiceTemplate.site);
            this.miccbForm.controls['securityRole'].patchValue(cceServiceTemplate.securityRole);
            this.miccbForm.controls['voice'].patchValue(cceServiceTemplate.voice);
            this.miccbForm.controls['chat'].patchValue(cceServiceTemplate.chat);
            this.miccbForm.controls['email'].patchValue(cceServiceTemplate.email);
            this.miccbForm.controls['sms'].patchValue(cceServiceTemplate.sms);
            this.miccbForm.controls['openMedia'].patchValue(cceServiceTemplate.openMedia);
            this.miccbForm.controls['workloadDescriptor'].patchValue(cceServiceTemplate.workloadDescriptor);
            this.miccbForm.controls['networkPrinter'].patchValue(cceServiceTemplate.networkPrinter);
            this.miccbForm.controls['printLocally'].patchValue(cceServiceTemplate.printLocally);
            this.miccbForm.controls['useEmailForDistribution'].patchValue(cceServiceTemplate.useEmailForDistribution);
            this.miccbForm.controls['seeAllQueues'].patchValue(cceServiceTemplate.seeAllQueues);
            this.miccbForm.controls['supervisorLicense'].patchValue(cceServiceTemplate.supervisorLicense);
            this.miccbForm.controls['phoneTypeLicense'].patchValue(cceServiceTemplate.phoneTypeLicense);
            this.miccbForm.controls['mccLicense'].patchValue(cceServiceTemplate.mccLicense);
            this.miccbForm.controls['voiceLicense'].patchValue(cceServiceTemplate.voiceLicense);
            this.miccbForm.controls['contactCenter'].patchValue(this.enableContactCenter);
            this.miccbForm.markAsDirty();
            this.cd.detectChanges();
        }
    }
    ngOnDestroy() {
        if (this.subscription) {
            this.subscription.unsubscribe();
        }
    }
    employeeValidator() {
        const reqBody = this.getReqBody();
        if (Array.isArray(reqBody) && reqBody.length > 0) {
            if (this.employeeMiccId.length > 0) {
                reqBody[0].id = this.employeeMiccId;
            }
            else if (this.passwordRequired()) {
                if (this.generatedEmployeePassword.length <= 0) {
                    this.generatedEmployeePassword = this.employeeService.createPassword();
                }
                reqBody[0].password = this.generatedEmployeePassword;
            }
        }
        this.employeeService.validateEmployee(this.user.accountId, reqBody).then(res => {
            if (Array.isArray(res)) {
                this.validationErrors = res.map(item => {
                    const empErr = {
                        severity: item.severity,
                        errorMessageCode: item.errorMessageCode,
                        description: item.description
                    };
                    return empErr;
                });
            }
            else {
                this.validationErrors = [];
            }
            this.formStatusSvc.contactCenterErrors = this.validationErrors.filter(error => error.severity === employeeErrorSeverityType.ERROR);
        });
    }
    checkForFormValidity() {
        const valid = !this.miccbForm.invalid && this.allowedToModifyCCData() && !this.isEmployeeInactive;
        if (valid) {
            this.validationErrors = [];
            this.validation$.next();
        }
        else {
            if (this.miccbForm.invalid && this.enableContactCenter) {
                const errorMessageCode = 'requiredFields';
                const description = this.translateService.instant(`miccb_user_config.validationErrors.${errorMessageCode}`);
                const empErr = { severity: employeeErrorSeverityType.ERROR, errorMessageCode, description };
                this.validationErrors = [empErr];
            }
            else {
                this.validationErrors = [];
            }
            this.formStatusSvc.contactCenterErrors = this.validationErrors.filter(error => error.severity === employeeErrorSeverityType.ERROR);
        }
    }
    isDirty() {
        return this.miccbForm.dirty;
    }
    handleFormChange(dirty) {
        if (this.formStatusSvc && this.formStatusSvc.contactCenterEmployee) {
            this.formStatusSvc.contactCenterEmployee.dirty = dirty;
        }
        this.onFormChanged.emit({ id: 'contactCenterEmployee', dirty });
        this.checkForFormValidity();
    }
    async getEmployee() {
        let employee = undefined;
        if (!this.user || !this.user.userId) {
            console.warn(`${logContext$5}.getEmployee: CL user not valid`);
            this.employeeService.employee = undefined;
            return employee;
        }
        employee = this.employeeService.employee;
        if (!!employee && (employee.cloudlinkId === this.user.userId || (!employee.cloudlinkId && employee.email === this.user.email))) {
            return employee;
        }
        // not in cache
        if (!employee) {
            await this.employeeService.getEmployeeByCloudlinkIdOrEmail(this.user.accountId, this.user.userId, this.user.email);
            employee = this.employeeService.employee;
        }
        return employee;
    }
    getReqBody() {
        let lineUri = '';
        if (this.showAgentLoginID) {
            lineUri = this.miccbForm.get('agentLoginID')?.value;
        }
        else if (this.showLineUri) {
            lineUri = this.miccbForm.get('lineUri')?.value;
        }
        const reqBody = [
            {
                name: this.user.name,
                firstName: this.user.firstName,
                lastName: this.user.lastName,
                reporting: this.miccbForm.get('reporting')?.value,
                lineUri: lineUri,
                email: this.user.email,
                username: this.miccbForm.get('username')?.value ? this.miccbForm.get('username')?.value : this.user.email,
                siteRefId: this.miccbForm.get('site')?.value,
                securityRoleRefId: this.miccbForm.get('securityRole')?.value,
                language: 'English_UnitedStates',
                workLoadRefId: this.miccbForm.get('workloadDescriptor')?.value,
                preferredPrinter: this.miccbForm.get('networkPrinter')?.value,
                printLocally: this.miccbForm.get('printLocally')?.value,
                useEmployeeEmailUseEmployeeEmailForReportDistribution: this.miccbForm.get('useEmailForDistribution')?.value,
                supervisorLicenseType: this.miccbForm.get('supervisorLicense')?.value,
                hasLicenseForMCC: this.miccbForm.get('mccLicense')?.value,
                hasLicenseForVoice: this.miccbForm.get('voiceLicense')?.value,
                isEnabledForVoice: this.miccbForm.get('voice')?.value,
                isEnabledForEmail: this.miccbForm.get('email')?.value,
                isEnabledForChat: this.miccbForm.get('chat')?.value,
                isEnabledForSMS: this.miccbForm.get('sms')?.value,
                isEnabledForOpenMedia: this.miccbForm.get('openMedia')?.value,
                isMaySeeAllQueuesEnabled: this.miccbForm.get('seeAllQueues')?.value,
                cloudlinkId: this.user.uniqueUserId,
                photoUrl: this.user.photoUrl,
                isRealTime: true,
                isActive: true,
                bypassWriteback: true // if this is not true, the MiCC will create a phone on MiVB with number same as lineUri
            }
        ];
        return reqBody;
    }
    async save() {
        if (!this.allowedToModifyCCData() || this.isEmployeeInactive) {
            console.log(`${logContext$5}.save: User cannot be saved due to limited MiCCB security access ${this.miccbSecurityAccess} or inactive ${this.isEmployeeInactive}`);
            return;
        }
        let reqBody = this.getReqBody();
        const employee = await this.getEmployee();
        if (!!employee) {
            const updatedEmployee = { ...employee, ...reqBody[0] };
            if (!this.enableContactCenter) {
                // deactivate
                reqBody = [
                    {
                        id: employee.id,
                        isRealTime: false,
                        isActive: false,
                        isEnabledForVoice: false,
                        isEnabledForEmail: false,
                        isEnabledForChat: false,
                        isEnabledForSMS: false,
                        isEnabledForOpenMedia: false
                    }
                ];
            }
            return this.employeeService.updateEmployee(this.user.accountId, employee.id, [updatedEmployee]);
        }
        else if (this.enableContactCenter) {
            if (this.passwordRequired()) {
                // For basic auth, generate a password so that creating the user will succeed
                // When deploy is selected, the password will be updated
                reqBody[0].password =
                    this.generatedEmployeePassword.length > 0 ? this.generatedEmployeePassword : this.employeeService.createPassword();
            }
            return this.employeeService.createEmployee(this.user.accountId, reqBody);
        }
        return undefined;
    }
    userNameRequired() {
        return this.miccbAuthType === 'WindowsAuthentication' || this.miccbAuthType === 'BasicAuthentication';
    }
    passwordRequired() {
        return this.miccbAuthType === 'BasicAuthentication';
    }
    areAllMediaOptionsUnchecked() {
        return (this.miccbForm.controls['chat'].value === false &&
            this.miccbForm.controls['email'].value === false &&
            this.miccbForm.controls['sms'].value === false &&
            this.miccbForm.controls['openMedia'].value === false);
    }
    onVoiceChanged(event) {
        this.miccbForm.controls['voiceLicense'].patchValue(event.target.checked ? true : false);
        if (!this.nonmivb) {
            this.showAgentLoginID = event.target.checked ? true : false;
        }
        else {
            this.showLineUri = event.target.checked ? true : false;
        }
        if (!event.target.checked) {
            this.miccbForm.controls['phoneTypeLicense'].patchValue('DeskPhone');
            // workaround since async validate employee response is not necessary return in the order of sending
            setTimeout(() => {
                this.validation$.next();
            }, 500);
        }
    }
    onMediaChanged(event) {
        if (event.target.checked) {
            this.miccbForm.controls['mccLicense'].patchValue(true);
        }
        else if (this.areAllMediaOptionsUnchecked() === true) {
            this.miccbForm.controls['mccLicense'].patchValue(false);
        }
    }
    onCCToggleChanged(event) {
        console.log(`${logContext$5}.onCCToggleChanged:`, event);
        this.enableContactCenter = event.value;
        this.checkForFormValidity();
    }
    ableToAccessCCData() {
        // If a template is being applied to a user, the logged on user must have full access.
        // Otherwise, only read-only access is required to view the user's info
        return (this.miccbSecurityAccess === MiccSecurityAccess.All ||
            (!this.cceServiceTemplate &&
                ![MiccSecurityAccess.None, MiccSecurityAccess.CommunicationError].includes(this.miccbSecurityAccess)));
    }
    allowedToModifyCCData() {
        return this.miccbSecurityAccess === MiccSecurityAccess.All;
    }
    agentLoginIDValidator() {
        return (control) => {
            if (!this.showAgentLoginID) {
                return null;
            }
            const regex = /^[0-9*#]{1,7}$/;
            if (!regex.test(control.value)) {
                return { invalid: true };
            }
            return null;
        };
    }
    lineUriValidator() {
        return (control) => {
            if (!this.showLineUri) {
                return null;
            }
            const regex = /^[0-9*#]{1,7}$/;
            if (!regex.test(control.value)) {
                return { invalid: true };
            }
            return null;
        };
    }
    getAccessErrorMessage() {
        let errorMsg = '';
        if (this.miccbSecurityAccess === MiccSecurityAccess.CommunicationError) {
            errorMsg = 'miccb_user_config.errors.miccbConnectionUnavailable';
        }
        else if (this.miccbSecurityAccess === MiccSecurityAccess.None || this.miccbSecurityAccess === MiccSecurityAccess.ReadOnly) {
            errorMsg = 'miccb_user_config.errors.insufficientPermission';
        }
        return errorMsg;
    }
    async onActivateMiCCB() {
        if (!this.disableActivate) {
            this.disableActivate = true;
            let employee = await this.getEmployee();
            if (!!employee && employee.isActive === false) {
                const reqBody = [
                    {
                        id: employee.id,
                        isRealTime: true,
                        isActive: true,
                        CloudlinkId: this.user.uniqueUserId
                    }
                ];
                await this.employeeService.updateEmployee(this.user.accountId, employee.id, reqBody);
                employee = await this.getEmployee();
                if (!!employee && employee.isActive) {
                    this.isEmployeeInactive = false;
                    if (!this.nonmivb) {
                        this.showToggleContactCenter = true;
                        this.enableContactCenter = true;
                        this.miccbForm.controls['contactCenter'].patchValue(this.enableContactCenter);
                    }
                    this.miccbForm.controls['voice'].patchValue(employee.isEnabledForVoice);
                    this.miccbForm.controls['chat'].patchValue(employee.isEnabledForChat);
                    this.miccbForm.controls['email'].patchValue(employee.isEnabledForEmail);
                    this.miccbForm.controls['sms'].patchValue(employee.isEnabledForSMS);
                    this.miccbForm.controls['openMedia'].patchValue(employee.isEnabledForOpenMedia);
                    console.log(`${logContext$5} Successfully activated employee`, employee);
                    for (const field in this.miccbForm.controls) {
                        this.miccbForm.controls[field]?.enable();
                    }
                }
            }
        }
        this.disableActivate = false;
    }
    static ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: EmployeeComponent, deps: [{ token: i1$2.MatIconRegistry }, { token: i2$1.DomSanitizer }, { token: MiccbApiService }, { token: EmployeeService }, { token: i2.TranslateService }, { token: i1.UntypedFormBuilder }, { token: i0.ChangeDetectorRef }], target: i0.ɵɵFactoryTarget.Component });
    static ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.2.12", type: EmployeeComponent, selector: "miccb-employee", inputs: { action: "action", nonmivb: "nonmivb", cceServiceTemplate: "cceServiceTemplate", user: "user", formStatusSvc: "formStatusSvc", interProductDataShareSvc: "interProductDataShareSvc" }, outputs: { onFormChanged: "onFormChanged" }, viewQueries: [{ propertyName: "Accordion", first: true, predicate: ["accordion"], descendants: true, static: true }, { propertyName: "expansionPanels", predicate: MatExpansionPanel, descendants: true }], ngImport: i0, template: "<div class=\"row section-container\" [ngClass]=\"{ nonmivb }\">\n    <!-- section-details -->\n    <div class=\"col section-details\">\n        <div *ngIf=\"isEmployeeInactive\">\n            <span class=\"title\">{{ 'miccb_user_config.contactCenter' | translate }}&nbsp;&nbsp;&nbsp;</span>\n            <span class=\"badge\">{{ 'miccb_user_config.inactive' | translate }}</span>\n        </div>\n        <div *ngIf=\"!isEmployeeInactive\">\n            <span class=\"title\">{{ 'miccb_user_config.contactCenter' | translate }}</span>\n        </div>\n        <div class=\"row form-group\" *ngIf=\"isEmployeeInactive\">\n            <div class=\"col-12 action-form\">\n                <span>\n                    <a (keyup.enter)=\"onActivateMiCCB()\" (click)=\"onActivateMiCCB()\">\n                        {{ 'miccb_user_config.buttons.reactivate' | translate }}\n                    </a>\n                </span>\n            </div>\n        </div>\n        <miccb-generic-toggle-field\n            *ngIf=\"ableToAccessCCData() && showToggleContactCenter\"\n            [value]=\"miccbForm.controls['contactCenter']?.value\"\n            [parentFormGroup]=\"miccbForm\"\n            (changeState)=\"onCCToggleChanged($event)\"\n        ></miccb-generic-toggle-field>\n    </div>\n    <!-- section-content -->\n    <div class=\"col section-content\" *ngIf=\"!ableToAccessCCData()\">\n        {{ getAccessErrorMessage() | translate }}\n    </div>\n    <div class=\"col section-content\" *ngIf=\"ableToAccessCCData() && showToggleContactCenter && !enableContactCenter\">\n        {{ 'miccb_user_config.enableContactCenter' | translate }}\n    </div>\n    <div class=\"col section-content\" *ngIf=\"ableToAccessCCData() && enableContactCenter\">\n        <div class=\"row\">\n            <!-- Site -->\n            <div class=\"col-md-6 col-sm-12 form-group\">\n                <mat-form-field class=\"form-input\" category=\"usertemplates\">\n                    <mat-label>{{ 'miccb_user_config.site' | translate }}</mat-label>\n                    <mat-select\n                        id=\"site\"\n                        data-e2e=\"site-dropdown\"\n                        [formControl]=\"miccbForm.controls['site']\"\n                    >\n                        <mat-option [value]=\"option.id\" *ngFor=\"let option of sites$ | async\">\n                            {{ option.label }}\n                        </mat-option>\n                    </mat-select>\n                </mat-form-field>\n            </div>\n            <!-- Security Role -->\n            <div class=\"col-md-6 col-sm-12 form-group\">\n                <mat-form-field class=\"form-input\" category=\"usertemplates\">\n                    <mat-label>{{ 'miccb_user_config.securityRole' | translate }}</mat-label>\n                    <mat-select\n                        id=\"securityRole\"\n                        data-e2e=\"security-role-dropdown\"\n                        [formControl]=\"miccbForm.controls['securityRole']\"\n                    >\n                        <mat-option [value]=\"option.id\" *ngFor=\"let option of securityRoles$ | async\">\n                            {{ option.label }}\n                        </mat-option>\n                    </mat-select>\n                </mat-form-field>\n            </div>\n        </div>\n        <div class=\"row\" *ngIf=\"userNameRequired()\">\n            <!-- Authentication: -->\n            <div class=\"col-12 group-label\">\n                {{ 'miccb_user_config.authentication.title' | translate }}\n            </div>\n        </div>\n        <div class=\"row\" *ngIf=\"userNameRequired()\">\n            <div class=\"col-md-6 col-sm-12 form-group\">\n                <mat-form-field class=\"form-input\">\n                    <mat-label>{{ 'miccb_user_config.authentication.username' | translate }}</mat-label>\n                    <input\n                        matInput\n                        type=\"string\"\n                        data-e2e=\"authentication-username\"\n                        id=\"username\"\n                        required\n                        placeholder=\"{{\n                            passwordRequired()\n                                ? ('miccb_user_config.authentication.username-placeholder' | translate)\n                                : ('miccb_user_config.authentication.windows-username-placeholder' | translate)\n                        }}\"\n                        [formControl]=\"miccbForm.controls['username']\"\n                    />\n                </mat-form-field>\n            </div>\n        </div>\n        <div class=\"row\">\n            <div class=\"col-md-6 col-sm-12 form-group\">\n                <mat-form-field class=\"form-input\">\n                    <mat-label>{{ 'miccb_user_config.reporting.title' | translate }}</mat-label>\n                    <input\n                        matInput\n                        type=\"string\"\n                        data-e2e=\"reporting\"\n                        id=\"reporting\"\n                        required\n                        placeholder=\"{{ 'miccb_user_config.reporting.placeholder' | translate }}\"\n                        [formControl]=\"miccbForm.controls['reporting']\"\n                    />\n                </mat-form-field>\n            </div>\n            <div class=\"col-md-6 col-sm-12 form-group\" *ngIf=\"showAgentLoginID\">\n                <mat-form-field class=\"form-input\">\n                    <mat-label>{{ 'miccb_user_config.agentLoginID.title' | translate }}</mat-label>\n                    <input\n                        matInput\n                        type=\"string\"\n                        data-e2e=\"agentLoginID\"\n                        id=\"agentLoginID\"\n                        required\n                        placeholder=\"{{ 'miccb_user_config.agentLoginID.placeholder' | translate }}\"\n                        [formControl]=\"miccbForm.controls['agentLoginID']\"\n                    />\n                    <mat-error *ngIf=\"miccbForm.controls['agentLoginID'].hasError('invalid')\">{{\n                        'miccb_user_config.agentLoginID.invalid' | translate\n                    }}</mat-error>\n                </mat-form-field>\n            </div>\n            <div class=\"col-md-6 col-sm-12 form-group\" *ngIf=\"showLineUri\">\n                <mat-form-field class=\"form-input\">\n                    <mat-label>{{ 'miccb_user_config.lineUri.title' | translate }}</mat-label>\n                    <input\n                        matInput\n                        type=\"string\"\n                        data-e2e=\"lineUri\"\n                        id=\"lineUri\"\n                        required\n                        placeholder=\"{{ 'miccb_user_config.lineUri.placeholder' | translate }}\"\n                        [formControl]=\"miccbForm.controls['lineUri']\"\n                    />\n                    <mat-error *ngIf=\"miccbForm.controls['lineUri'].hasError('invalid')\">{{\n                        'miccb_user_config.lineUri.invalid' | translate\n                    }}</mat-error>\n                </mat-form-field>\n            </div>\n        </div>\n        <div class=\"row\">\n            <!-- Media Type: -->\n            <div class=\"col-12 group-label\">\n                {{ 'miccb_user_config.mediaType' | translate }}\n            </div>\n        </div>\n        <div class=\"row\">\n            <div class=\"col-12 form-group\">\n                <div class=\"group-element\">\n                    <div class=\"media-type-option\">\n                        <div class=\"checkbox-section\">\n                            <input\n                                type=\"checkbox\"\n                                data-e2e=\"templates-voice-checkbox\"\n                                id=\"voice\"\n                                [formControl]=\"miccbForm.controls['voice']\"\n                                (change)=\"onVoiceChanged($event)\"\n                                [matTooltip]=\"voiceMediaDisableReason\"\n                                [matTooltipDisabled]=\"miccbForm.controls['voice'].disabled && allowedToModifyCCData() ? false : true\"\n                                matTooltipPosition=\"above\"\n                            />\n                            <label for=\"voice\">\n                                <img [src]=\"baseUrl + '/assets/miccb-components/icons/voice.svg'\" />\n                                {{ 'miccb_user_config.voice' | translate }}\n                            </label>\n                        </div>\n                    </div>\n                    <div class=\"media-type-option\">\n                        <div class=\"checkbox-section\">\n                            <input\n                                type=\"checkbox\"\n                                data-e2e=\"templates-chat-checkbox\"\n                                id=\"chat\"\n                                [formControl]=\"miccbForm.controls['chat']\"\n                                (change)=\"onMediaChanged($event)\"\n                                matTooltip=\"{{\n                                    'miccb_user_config.mediaTypeNotAvailable' | translate: { type: 'miccb_user_config.chat' | translate }\n                                }}\"\n                                [matTooltipDisabled]=\"miccbForm.controls['chat'].disabled && allowedToModifyCCData() ? false : true\"\n                                matTooltipPosition=\"above\"\n                            />\n                            <label for=\"chat\">\n                                <img [src]=\"baseUrl + '/assets/miccb-components/icons/chat.svg'\" />\n                                {{ 'miccb_user_config.chat' | translate }}\n                            </label>\n                        </div>\n                    </div>\n                    <div class=\"media-type-option\">\n                        <div class=\"checkbox-section\">\n                            <input\n                                type=\"checkbox\"\n                                data-e2e=\"templates-email-checkbox\"\n                                id=\"email\"\n                                [formControl]=\"miccbForm.controls['email']\"\n                                (change)=\"onMediaChanged($event)\"\n                                matTooltip=\"{{\n                                    'miccb_user_config.mediaTypeNotAvailable' | translate: { type: 'miccb_user_config.email' | translate }\n                                }}\"\n                                [matTooltipDisabled]=\"miccbForm.controls['email'].disabled && allowedToModifyCCData() ? false : true\"\n                                matTooltipPosition=\"above\"\n                            />\n                            <label for=\"email\">\n                                <img [src]=\"baseUrl + '/assets/miccb-components/icons/email.svg'\" />\n                                {{ 'miccb_user_config.email' | translate }}\n                            </label>\n                        </div>\n                    </div>\n                    <div class=\"media-type-option\">\n                        <div class=\"checkbox-section\">\n                            <input\n                                type=\"checkbox\"\n                                data-e2e=\"templates-sms-checkbox\"\n                                id=\"sms\"\n                                [formControl]=\"miccbForm.controls['sms']\"\n                                (change)=\"onMediaChanged($event)\"\n                                matTooltip=\"{{\n                                    'miccb_user_config.mediaTypeNotAvailable' | translate: { type: 'miccb_user_config.sms' | translate }\n                                }}\"\n                                [matTooltipDisabled]=\"miccbForm.controls['sms'].disabled && allowedToModifyCCData() ? false : true\"\n                                matTooltipPosition=\"above\"\n                            />\n                            <label for=\"sms\">\n                                <img [src]=\"baseUrl + '/assets/miccb-components/icons/sms.svg'\" />\n                                {{ 'miccb_user_config.sms' | translate }}\n                            </label>\n                        </div>\n                    </div>\n                    <div class=\"media-type-option\">\n                        <div class=\"checkbox-section\">\n                            <input\n                                type=\"checkbox\"\n                                data-e2e=\"templates-openMedia-checkbox\"\n                                id=\"openMedia\"\n                                [formControl]=\"miccbForm.controls['openMedia']\"\n                                (change)=\"onMediaChanged($event)\"\n                                matTooltip=\"{{\n                                    'miccb_user_config.mediaTypeNotAvailable'\n                                        | translate: { type: 'miccb_user_config.openMedia' | translate }\n                                }}\"\n                                [matTooltipDisabled]=\"miccbForm.controls['openMedia'].disabled && allowedToModifyCCData() ? false : true\"\n                                matTooltipPosition=\"above\"\n                            />\n                            <label for=\"openMedia\">\n                                <img [src]=\"baseUrl + '/assets/miccb-components/icons/open-media.svg'\" />\n                                {{ 'miccb_user_config.openMedia' | translate }}\n                            </label>\n                        </div>\n                    </div>\n                </div>\n            </div>\n        </div>\n        <mat-accordion multi>\n            <mat-expansion-panel [expanded]=\"true\">\n                <mat-expansion-panel-header>\n                    <mat-panel-title class=\"expansion-section-title\">\n                        {{ 'miccb_user_config.advanced.title' | translate }}\n                    </mat-panel-title>\n                </mat-expansion-panel-header>\n                <div class=\"row\">\n                    <!-- Workloads -->\n                    <div class=\"col-md-6 col-sm-12 form-group\">\n                        <mat-form-field class=\"form-input\" category=\"usertemplates\">\n                            <mat-label>{{ 'miccb_user_config.advanced.workloadDescriptor.label' | translate }}</mat-label>\n                            <mat-select\n                                id=\"workload-descriptor\"\n                                data-e2e=\"templates-workload-descriptor\"\n                                [formControl]=\"miccbForm.controls['workloadDescriptor']\"\n                            >\n                                <mat-option [value]=\"option.id\" *ngFor=\"let option of workloads$ | async\">\n                                    {{ option.label }}\n                                </mat-option>\n                            </mat-select>\n                        </mat-form-field>\n                    </div>\n                    <div class=\"col-md-6 col-sm-12 form-group\">\n                        <mat-form-field class=\"form-input\">\n                            <mat-label>{{ 'miccb_user_config.advanced.networkPrinter.label' | translate }}</mat-label>\n                            <input\n                                matInput\n                                type=\"string\"\n                                data-e2e=\"templates-network-printer\"\n                                id=\"network-printer\"\n                                placeholder=\"{{ 'miccb_user_config.advanced.networkPrinter.placeholder' | translate }}\"\n                                [formControl]=\"miccbForm.controls['networkPrinter']\"\n                            />\n                        </mat-form-field>\n                    </div>\n                </div>\n                <!-- Print Locally -->\n                <div class=\"row\">\n                    <div class=\"col-12 checkbox-section\">\n                        <input\n                            type=\"checkbox\"\n                            data-e2e=\"templates-print-locally-checkbox\"\n                            id=\"print-locally\"\n                            [formControl]=\"miccbForm.controls['printLocally']\"\n                        />\n                        <label for=\"print-locally\">\n                            {{ 'miccb_user_config.advanced.printLocally' | translate }}\n                        </label>\n                    </div>\n                </div>\n                <!-- Use email for distribution -->\n                <div class=\"row\">\n                    <div class=\"col-12 checkbox-section\">\n                        <input\n                            type=\"checkbox\"\n                            data-e2e=\"templates-use-email-for-distribution-checkbox\"\n                            id=\"use-email-for-distribution\"\n                            [formControl]=\"miccbForm.controls['useEmailForDistribution']\"\n                        />\n                        <label for=\"use-email-for-distribution\">\n                            {{ 'miccb_user_config.advanced.useEmailForDistribution' | translate }}\n                        </label>\n                    </div>\n                </div>\n                <!-- See all queues -->\n                <div class=\"row\">\n                    <div class=\"col-12 checkbox-section\">\n                        <input\n                            type=\"checkbox\"\n                            data-e2e=\"templates-see-all-queues-checkbox\"\n                            id=\"see-all-queues\"\n                            [formControl]=\"miccbForm.controls['seeAllQueues']\"\n                        />\n                        <label for=\"see-all-queues\">\n                            {{ 'miccb_user_config.advanced.seeAllQueues' | translate }}\n                        </label>\n                    </div>\n                </div>\n            </mat-expansion-panel>\n            <mat-expansion-panel [expanded]=\"true\">\n                <mat-expansion-panel-header>\n                    <mat-panel-title class=\"expansion-section-title\">\n                        {{ 'miccb_user_config.licensing.title' | translate }}\n                    </mat-panel-title>\n                </mat-expansion-panel-header>\n                <div class=\"row\">\n                    <!-- Supervisor License -->\n                    <div class=\"col-md-6 col-sm-12 form-group\">\n                        <mat-form-field class=\"form-input\" category=\"usertemplates\">\n                            <mat-label>{{ 'miccb_user_config.licensing.supervisorLicense' | translate }}</mat-label>\n                            <mat-select\n                                id=\"supervisorLicense\"\n                                data-e2e=\"supervisor-license-dropdown\"\n                                [formControl]=\"miccbForm.controls['supervisorLicense']\"\n                            >\n                                <mat-option [value]=\"option.id\" *ngFor=\"let option of supervisorLicenseTypes$ | async\">\n                                    {{ option.label }}\n                                </mat-option>\n                            </mat-select>\n                        </mat-form-field>\n                    </div>\n                    <!-- Phone types -->\n                    <div *ngIf=\"!deskphoneOnly\" class=\"col-md-6 col-sm-12 form-group\">\n                        <mat-form-field class=\"form-input\" category=\"usertemplates\">\n                            <mat-label>{{ 'miccb_user_config.licensing.phoneTypeLicense' | translate }}</mat-label>\n                            <mat-select\n                                id=\"phoneTypeLicense\"\n                                data-e2e=\"phone-type-license-dropdown\"\n                                [formControl]=\"miccbForm.controls['phoneTypeLicense']\"\n                            >\n                                <mat-option [value]=\"option.id\" *ngFor=\"let option of phoneTypes\">\n                                    {{ option.label }}\n                                </mat-option>\n                            </mat-select>\n                        </mat-form-field>\n                    </div>\n                    <div *ngIf=\"deskphoneOnly\" class=\"col-md-6 col-sm-12 form-group\">\n                        <mat-form-field class=\"form-input\" category=\"usertemplates\">\n                            <mat-label>{{ 'miccb_user_config.licensing.phoneTypeLicense' | translate }}</mat-label>\n                            <mat-select\n                                id=\"phoneTypeLicense\"\n                                data-e2e=\"phone-type-license-dropdown\"\n                                [formControl]=\"miccbForm.controls['phoneTypeLicense']\"\n                            >\n                                <mat-option [value]=\"option.id\" *ngFor=\"let option of deskphoneTypes\">\n                                    {{ option.label }}\n                                </mat-option>\n                            </mat-select>\n                        </mat-form-field>\n                    </div>\n                </div>\n                <!-- Multimedia Contact Center License -->\n                <div class=\"row\">\n                    <div class=\"col-12 checkbox-section\">\n                        <input\n                            type=\"checkbox\"\n                            data-e2e=\"templates-mcc-license-checkbox\"\n                            id=\"mcc-license\"\n                            [formControl]=\"miccbForm.controls['mccLicense']\"\n                        />\n                        <label for=\"mcc-license\">\n                            {{ 'miccb_user_config.licensing.mccLicense' | translate }}\n                        </label>\n                    </div>\n                </div>\n                <!-- Contact Center Voice License -->\n                <div class=\"row\">\n                    <div class=\"col-12 checkbox-section\">\n                        <input\n                            type=\"checkbox\"\n                            data-e2e=\"templates-voice-license-checkbox\"\n                            id=\"voice-license\"\n                            [formControl]=\"miccbForm.controls['voiceLicense']\"\n                        />\n                        <label for=\"voice-license\">\n                            {{ 'miccb_user_config.licensing.voiceLicense' | translate }}\n                        </label>\n                    </div>\n                </div>\n            </mat-expansion-panel>\n        </mat-accordion>\n        <div class=\"row\" *ngFor=\"let validationError of validationErrors\">\n            <div class=\"error\" *ngIf=\"validationError.severity === 'Error'\">\n                <mat-icon class=\"error-icon\" svgIcon=\"caution-circle\"></mat-icon>\n                <div class=\"error-text\">{{ validationError.description }}</div>\n            </div>\n            <div class=\"error\" *ngIf=\"validationError.severity === 'Warning'\">\n                <mat-icon class=\"error-icon\" svgIcon=\"caution\"></mat-icon>\n                <div class=\"warn-text\">{{ validationError.description }}</div>\n            </div>\n        </div>\n        <div class=\"version\">{{ 'miccb_user_config.version' | translate: {version} }}</div>\n    </div>\n    <!-- end of section-content -->\n</div>\n<!-- end of section-container -->\n", styles: ["@charset \"UTF-8\";.section-container{margin:0 -20px}.section-container>.col{border-bottom:1px solid #d1d6db;padding:24px}.section-container.nonmivb{border-top:1px solid #d1d6db}.section-details{border-right:1px solid #d1d6db;background:#f1f4f8;max-width:280px;padding-top:24px!important}.section-details .section-details-container{position:sticky;top:87px}.section-details .title{font-family:Open Sans;font-style:normal;font-weight:600;font-size:16px;line-height:24px;color:#464b51;position:sticky;top:87px}.section-details .description{font-family:Open Sans;font-style:normal;font-weight:400;font-size:12px;line-height:16px;color:#595e64}.section-details button{margin-top:16px}.section-details .badge{background-color:#595e64;color:#fff;padding:4px 8px;text-align:center;border-radius:5px}.section-details .action-form a{color:#0073d0;text-decoration:underline;font-size:14px;font-weight:600;font-stretch:normal;font-style:normal;line-height:1.75;letter-spacing:normal;font-family:Open Sans,sans-serif}.section-details .action-form a:hover{cursor:pointer}.section-details .action-form a.disableLink{color:#acb3b9;cursor:default}.section-content .row{margin-right:-8px;margin-left:-8px}.section-content .col{padding-right:8px;padding-left:8px}.section-content .row~.row{margin-top:8px}.section-content .error{display:flex;align-items:center;font-family:Open Sans;font-style:normal;font-weight:600;font-size:13px;line-height:normal}.section-content .error .error-icon{width:20px;height:20px}.section-content .error .error-text{padding-left:3px;color:#a4221e}.section-content .error .warn-text{padding-left:3px;color:#876001}mat-expansion-panel{border:1px solid #d1d6db;border-radius:12px!important;box-shadow:none!important;margin-bottom:8px!important}mat-expansion-panel mat-expansion-panel-header{height:60px;max-width:570px}mat-expansion-panel mat-expansion-panel-header mat-panel-title{width:100%;margin-right:0}mat-expansion-panel .error-icon-container{align-self:center}mat-expansion-panel .error-icon-container.phone-header{margin-left:auto;margin-right:10px}mat-expansion-panel .error-icon{margin-right:10px}mat-expansion-panel .info-icon{vertical-align:top}.checkbox-section{display:flex;flex-direction:row;flex-wrap:wrap;align-items:center}.checkbox-section.form-group{margin-bottom:1rem}.checkbox-section input[type=checkbox]{-webkit-appearance:none;width:16px;height:16px;border-radius:4px;border:solid 1px #d1d6db;background-image:linear-gradient(to top,#f2f4f7,#fff);cursor:pointer}.checkbox-section input[type=checkbox]:checked{border-color:#0080e7;background-image:linear-gradient(to top,#0080e7,#0080e7);transform:translate(0)}.checkbox-section input[type=checkbox]:checked:disabled{cursor:unset;background:linear-gradient(0deg,#fff9,#fff9),#0073d0;border-color:#d1d6db}.checkbox-section input[type=checkbox]:checked:disabled+label{cursor:unset;font-weight:600;color:#49505761}.checkbox-section input[type=checkbox]:checked:after{content:\"\\2713\";color:#fff;position:absolute;left:50%;top:50%;transform:translate(-50%,-50%)}.checkbox-section input[type=checkbox]:checked+label{color:#1f1f1f;font-weight:600}.checkbox-section input[type=checkbox]:disabled{cursor:unset;background-image:linear-gradient(to top,#d1d6db,#d1d6db80)}.checkbox-section input[type=checkbox]:disabled+label{cursor:unset;color:#49505761}.checkbox-section input[type=checkbox]:focus{outline:none;box-shadow:0 0 5px 1px #2ea2f8}.checkbox-section label{margin-left:0!important;margin-bottom:0;font-family:Open Sans,serif;font-size:14px;font-weight:400;font-stretch:normal;font-style:normal;line-height:1.375;letter-spacing:normal;color:#495057;cursor:pointer}.checkbox-section .alert{max-width:95%;margin-left:24px}.checkbox-section .error-margin{margin-left:8px}.checkbox-subsection{padding-left:24px!important}.checkbox-subsection .form-group{margin-bottom:.5rem}.media-type-option{max-width:-moz-fit-content;max-width:fit-content}.media-type-option .checkbox-section{flex-wrap:nowrap}.group-label{text-align:initial;display:inline-block;font-family:Open Sans,sans-serif;font-weight:600;font-size:14px;color:#495057}.group-label.text-disabled{color:#49505761}.group-element{display:flex;align-items:center;justify-content:space-between;gap:1rem;margin-top:.5rem;margin-bottom:.5rem}.version{font-size:10px;font-weight:400;color:#acb3b9;font-family:OpenSans-Italic;float:right}\n"], dependencies: [{ kind: "directive", type: i5.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { kind: "directive", type: i5.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { kind: "directive", type: i5.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "component", type: i8.MatFormField, selector: "mat-form-field", inputs: ["hideRequiredMarker", "color", "floatLabel", "appearance", "subscriptSizing", "hintLabel"], exportAs: ["matFormField"] }, { kind: "directive", type: i8.MatLabel, selector: "mat-label" }, { kind: "directive", type: i8.MatError, selector: "mat-error, [matError]", inputs: ["id"] }, { kind: "directive", type: i9$1.MatInput, selector: "input[matInput], textarea[matInput], select[matNativeControl],      input[matNativeControl], textarea[matNativeControl]", inputs: ["disabled", "id", "placeholder", "name", "required", "type", "errorStateMatcher", "aria-describedby", "value", "readonly"], exportAs: ["matInput"] }, { kind: "directive", type: i1.DefaultValueAccessor, selector: "input:not([type=checkbox])[formControlName],textarea[formControlName],input:not([type=checkbox])[formControl],textarea[formControl],input:not([type=checkbox])[ngModel],textarea[ngModel],[ngDefaultControl]" }, { kind: "directive", type: i1.CheckboxControlValueAccessor, selector: "input[type=checkbox][formControlName],input[type=checkbox][formControl],input[type=checkbox][ngModel]" }, { kind: "directive", type: i1.NgControlStatus, selector: "[formControlName],[ngModel],[formControl]" }, { kind: "directive", type: i1.RequiredValidator, selector: ":not([type=checkbox])[required][formControlName],:not([type=checkbox])[required][formControl],:not([type=checkbox])[required][ngModel]", inputs: ["required"] }, { kind: "directive", type: i1.FormControlDirective, selector: "[formControl]", inputs: ["formControl", "disabled", "ngModel"], outputs: ["ngModelChange"], exportAs: ["ngForm"] }, { kind: "directive", type: i10$1.MatAccordion, selector: "mat-accordion", inputs: ["multi", "hideToggle", "displayMode", "togglePosition"], exportAs: ["matAccordion"] }, { kind: "component", type: i10$1.MatExpansionPanel, selector: "mat-expansion-panel", inputs: ["disabled", "expanded", "hideToggle", "togglePosition"], outputs: ["opened", "closed", "expandedChange", "afterExpand", "afterCollapse"], exportAs: ["matExpansionPanel"] }, { kind: "component", type: i10$1.MatExpansionPanelHeader, selector: "mat-expansion-panel-header", inputs: ["tabIndex", "expandedHeight", "collapsedHeight"] }, { kind: "directive", type: i10$1.MatExpansionPanelTitle, selector: "mat-panel-title" }, { kind: "component", type: i7.MatSelect, selector: "mat-select", inputs: ["disabled", "disableRipple", "tabIndex", "panelWidth", "hideSingleSelectionIndicator"], exportAs: ["matSelect"] }, { kind: "component", type: i8$1.MatOption, selector: "mat-option", exportAs: ["matOption"] }, { kind: "component", type: i1$2.MatIcon, selector: "mat-icon", inputs: ["color", "inline", "svgIcon", "fontSet", "fontIcon"], exportAs: ["matIcon"] }, { kind: "directive", type: i10.MatTooltip, selector: "[matTooltip]", exportAs: ["matTooltip"] }, { kind: "component", type: GenericToggleFieldComponent, selector: "miccb-generic-toggle-field", inputs: ["value", "parentFormGroup"], outputs: ["changeState"] }, { kind: "pipe", type: i5.AsyncPipe, name: "async" }, { kind: "pipe", type: i2.TranslatePipe, name: "translate" }] });
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: EmployeeComponent, decorators: [{
            type: Component,
            args: [{ selector: 'miccb-employee', template: "<div class=\"row section-container\" [ngClass]=\"{ nonmivb }\">\n    <!-- section-details -->\n    <div class=\"col section-details\">\n        <div *ngIf=\"isEmployeeInactive\">\n            <span class=\"title\">{{ 'miccb_user_config.contactCenter' | translate }}&nbsp;&nbsp;&nbsp;</span>\n            <span class=\"badge\">{{ 'miccb_user_config.inactive' | translate }}</span>\n        </div>\n        <div *ngIf=\"!isEmployeeInactive\">\n            <span class=\"title\">{{ 'miccb_user_config.contactCenter' | translate }}</span>\n        </div>\n        <div class=\"row form-group\" *ngIf=\"isEmployeeInactive\">\n            <div class=\"col-12 action-form\">\n                <span>\n                    <a (keyup.enter)=\"onActivateMiCCB()\" (click)=\"onActivateMiCCB()\">\n                        {{ 'miccb_user_config.buttons.reactivate' | translate }}\n                    </a>\n                </span>\n            </div>\n        </div>\n        <miccb-generic-toggle-field\n            *ngIf=\"ableToAccessCCData() && showToggleContactCenter\"\n            [value]=\"miccbForm.controls['contactCenter']?.value\"\n            [parentFormGroup]=\"miccbForm\"\n            (changeState)=\"onCCToggleChanged($event)\"\n        ></miccb-generic-toggle-field>\n    </div>\n    <!-- section-content -->\n    <div class=\"col section-content\" *ngIf=\"!ableToAccessCCData()\">\n        {{ getAccessErrorMessage() | translate }}\n    </div>\n    <div class=\"col section-content\" *ngIf=\"ableToAccessCCData() && showToggleContactCenter && !enableContactCenter\">\n        {{ 'miccb_user_config.enableContactCenter' | translate }}\n    </div>\n    <div class=\"col section-content\" *ngIf=\"ableToAccessCCData() && enableContactCenter\">\n        <div class=\"row\">\n            <!-- Site -->\n            <div class=\"col-md-6 col-sm-12 form-group\">\n                <mat-form-field class=\"form-input\" category=\"usertemplates\">\n                    <mat-label>{{ 'miccb_user_config.site' | translate }}</mat-label>\n                    <mat-select\n                        id=\"site\"\n                        data-e2e=\"site-dropdown\"\n                        [formControl]=\"miccbForm.controls['site']\"\n                    >\n                        <mat-option [value]=\"option.id\" *ngFor=\"let option of sites$ | async\">\n                            {{ option.label }}\n                        </mat-option>\n                    </mat-select>\n                </mat-form-field>\n            </div>\n            <!-- Security Role -->\n            <div class=\"col-md-6 col-sm-12 form-group\">\n                <mat-form-field class=\"form-input\" category=\"usertemplates\">\n                    <mat-label>{{ 'miccb_user_config.securityRole' | translate }}</mat-label>\n                    <mat-select\n                        id=\"securityRole\"\n                        data-e2e=\"security-role-dropdown\"\n                        [formControl]=\"miccbForm.controls['securityRole']\"\n                    >\n                        <mat-option [value]=\"option.id\" *ngFor=\"let option of securityRoles$ | async\">\n                            {{ option.label }}\n                        </mat-option>\n                    </mat-select>\n                </mat-form-field>\n            </div>\n        </div>\n        <div class=\"row\" *ngIf=\"userNameRequired()\">\n            <!-- Authentication: -->\n            <div class=\"col-12 group-label\">\n                {{ 'miccb_user_config.authentication.title' | translate }}\n            </div>\n        </div>\n        <div class=\"row\" *ngIf=\"userNameRequired()\">\n            <div class=\"col-md-6 col-sm-12 form-group\">\n                <mat-form-field class=\"form-input\">\n                    <mat-label>{{ 'miccb_user_config.authentication.username' | translate }}</mat-label>\n                    <input\n                        matInput\n                        type=\"string\"\n                        data-e2e=\"authentication-username\"\n                        id=\"username\"\n                        required\n                        placeholder=\"{{\n                            passwordRequired()\n                                ? ('miccb_user_config.authentication.username-placeholder' | translate)\n                                : ('miccb_user_config.authentication.windows-username-placeholder' | translate)\n                        }}\"\n                        [formControl]=\"miccbForm.controls['username']\"\n                    />\n                </mat-form-field>\n            </div>\n        </div>\n        <div class=\"row\">\n            <div class=\"col-md-6 col-sm-12 form-group\">\n                <mat-form-field class=\"form-input\">\n                    <mat-label>{{ 'miccb_user_config.reporting.title' | translate }}</mat-label>\n                    <input\n                        matInput\n                        type=\"string\"\n                        data-e2e=\"reporting\"\n                        id=\"reporting\"\n                        required\n                        placeholder=\"{{ 'miccb_user_config.reporting.placeholder' | translate }}\"\n                        [formControl]=\"miccbForm.controls['reporting']\"\n                    />\n                </mat-form-field>\n            </div>\n            <div class=\"col-md-6 col-sm-12 form-group\" *ngIf=\"showAgentLoginID\">\n                <mat-form-field class=\"form-input\">\n                    <mat-label>{{ 'miccb_user_config.agentLoginID.title' | translate }}</mat-label>\n                    <input\n                        matInput\n                        type=\"string\"\n                        data-e2e=\"agentLoginID\"\n                        id=\"agentLoginID\"\n                        required\n                        placeholder=\"{{ 'miccb_user_config.agentLoginID.placeholder' | translate }}\"\n                        [formControl]=\"miccbForm.controls['agentLoginID']\"\n                    />\n                    <mat-error *ngIf=\"miccbForm.controls['agentLoginID'].hasError('invalid')\">{{\n                        'miccb_user_config.agentLoginID.invalid' | translate\n                    }}</mat-error>\n                </mat-form-field>\n            </div>\n            <div class=\"col-md-6 col-sm-12 form-group\" *ngIf=\"showLineUri\">\n                <mat-form-field class=\"form-input\">\n                    <mat-label>{{ 'miccb_user_config.lineUri.title' | translate }}</mat-label>\n                    <input\n                        matInput\n                        type=\"string\"\n                        data-e2e=\"lineUri\"\n                        id=\"lineUri\"\n                        required\n                        placeholder=\"{{ 'miccb_user_config.lineUri.placeholder' | translate }}\"\n                        [formControl]=\"miccbForm.controls['lineUri']\"\n                    />\n                    <mat-error *ngIf=\"miccbForm.controls['lineUri'].hasError('invalid')\">{{\n                        'miccb_user_config.lineUri.invalid' | translate\n                    }}</mat-error>\n                </mat-form-field>\n            </div>\n        </div>\n        <div class=\"row\">\n            <!-- Media Type: -->\n            <div class=\"col-12 group-label\">\n                {{ 'miccb_user_config.mediaType' | translate }}\n            </div>\n        </div>\n        <div class=\"row\">\n            <div class=\"col-12 form-group\">\n                <div class=\"group-element\">\n                    <div class=\"media-type-option\">\n                        <div class=\"checkbox-section\">\n                            <input\n                                type=\"checkbox\"\n                                data-e2e=\"templates-voice-checkbox\"\n                                id=\"voice\"\n                                [formControl]=\"miccbForm.controls['voice']\"\n                                (change)=\"onVoiceChanged($event)\"\n                                [matTooltip]=\"voiceMediaDisableReason\"\n                                [matTooltipDisabled]=\"miccbForm.controls['voice'].disabled && allowedToModifyCCData() ? false : true\"\n                                matTooltipPosition=\"above\"\n                            />\n                            <label for=\"voice\">\n                                <img [src]=\"baseUrl + '/assets/miccb-components/icons/voice.svg'\" />\n                                {{ 'miccb_user_config.voice' | translate }}\n                            </label>\n                        </div>\n                    </div>\n                    <div class=\"media-type-option\">\n                        <div class=\"checkbox-section\">\n                            <input\n                                type=\"checkbox\"\n                                data-e2e=\"templates-chat-checkbox\"\n                                id=\"chat\"\n                                [formControl]=\"miccbForm.controls['chat']\"\n                                (change)=\"onMediaChanged($event)\"\n                                matTooltip=\"{{\n                                    'miccb_user_config.mediaTypeNotAvailable' | translate: { type: 'miccb_user_config.chat' | translate }\n                                }}\"\n                                [matTooltipDisabled]=\"miccbForm.controls['chat'].disabled && allowedToModifyCCData() ? false : true\"\n                                matTooltipPosition=\"above\"\n                            />\n                            <label for=\"chat\">\n                                <img [src]=\"baseUrl + '/assets/miccb-components/icons/chat.svg'\" />\n                                {{ 'miccb_user_config.chat' | translate }}\n                            </label>\n                        </div>\n                    </div>\n                    <div class=\"media-type-option\">\n                        <div class=\"checkbox-section\">\n                            <input\n                                type=\"checkbox\"\n                                data-e2e=\"templates-email-checkbox\"\n                                id=\"email\"\n                                [formControl]=\"miccbForm.controls['email']\"\n                                (change)=\"onMediaChanged($event)\"\n                                matTooltip=\"{{\n                                    'miccb_user_config.mediaTypeNotAvailable' | translate: { type: 'miccb_user_config.email' | translate }\n                                }}\"\n                                [matTooltipDisabled]=\"miccbForm.controls['email'].disabled && allowedToModifyCCData() ? false : true\"\n                                matTooltipPosition=\"above\"\n                            />\n                            <label for=\"email\">\n                                <img [src]=\"baseUrl + '/assets/miccb-components/icons/email.svg'\" />\n                                {{ 'miccb_user_config.email' | translate }}\n                            </label>\n                        </div>\n                    </div>\n                    <div class=\"media-type-option\">\n                        <div class=\"checkbox-section\">\n                            <input\n                                type=\"checkbox\"\n                                data-e2e=\"templates-sms-checkbox\"\n                                id=\"sms\"\n                                [formControl]=\"miccbForm.controls['sms']\"\n                                (change)=\"onMediaChanged($event)\"\n                                matTooltip=\"{{\n                                    'miccb_user_config.mediaTypeNotAvailable' | translate: { type: 'miccb_user_config.sms' | translate }\n                                }}\"\n                                [matTooltipDisabled]=\"miccbForm.controls['sms'].disabled && allowedToModifyCCData() ? false : true\"\n                                matTooltipPosition=\"above\"\n                            />\n                            <label for=\"sms\">\n                                <img [src]=\"baseUrl + '/assets/miccb-components/icons/sms.svg'\" />\n                                {{ 'miccb_user_config.sms' | translate }}\n                            </label>\n                        </div>\n                    </div>\n                    <div class=\"media-type-option\">\n                        <div class=\"checkbox-section\">\n                            <input\n                                type=\"checkbox\"\n                                data-e2e=\"templates-openMedia-checkbox\"\n                                id=\"openMedia\"\n                                [formControl]=\"miccbForm.controls['openMedia']\"\n                                (change)=\"onMediaChanged($event)\"\n                                matTooltip=\"{{\n                                    'miccb_user_config.mediaTypeNotAvailable'\n                                        | translate: { type: 'miccb_user_config.openMedia' | translate }\n                                }}\"\n                                [matTooltipDisabled]=\"miccbForm.controls['openMedia'].disabled && allowedToModifyCCData() ? false : true\"\n                                matTooltipPosition=\"above\"\n                            />\n                            <label for=\"openMedia\">\n                                <img [src]=\"baseUrl + '/assets/miccb-components/icons/open-media.svg'\" />\n                                {{ 'miccb_user_config.openMedia' | translate }}\n                            </label>\n                        </div>\n                    </div>\n                </div>\n            </div>\n        </div>\n        <mat-accordion multi>\n            <mat-expansion-panel [expanded]=\"true\">\n                <mat-expansion-panel-header>\n                    <mat-panel-title class=\"expansion-section-title\">\n                        {{ 'miccb_user_config.advanced.title' | translate }}\n                    </mat-panel-title>\n                </mat-expansion-panel-header>\n                <div class=\"row\">\n                    <!-- Workloads -->\n                    <div class=\"col-md-6 col-sm-12 form-group\">\n                        <mat-form-field class=\"form-input\" category=\"usertemplates\">\n                            <mat-label>{{ 'miccb_user_config.advanced.workloadDescriptor.label' | translate }}</mat-label>\n                            <mat-select\n                                id=\"workload-descriptor\"\n                                data-e2e=\"templates-workload-descriptor\"\n                                [formControl]=\"miccbForm.controls['workloadDescriptor']\"\n                            >\n                                <mat-option [value]=\"option.id\" *ngFor=\"let option of workloads$ | async\">\n                                    {{ option.label }}\n                                </mat-option>\n                            </mat-select>\n                        </mat-form-field>\n                    </div>\n                    <div class=\"col-md-6 col-sm-12 form-group\">\n                        <mat-form-field class=\"form-input\">\n                            <mat-label>{{ 'miccb_user_config.advanced.networkPrinter.label' | translate }}</mat-label>\n                            <input\n                                matInput\n                                type=\"string\"\n                                data-e2e=\"templates-network-printer\"\n                                id=\"network-printer\"\n                                placeholder=\"{{ 'miccb_user_config.advanced.networkPrinter.placeholder' | translate }}\"\n                                [formControl]=\"miccbForm.controls['networkPrinter']\"\n                            />\n                        </mat-form-field>\n                    </div>\n                </div>\n                <!-- Print Locally -->\n                <div class=\"row\">\n                    <div class=\"col-12 checkbox-section\">\n                        <input\n                            type=\"checkbox\"\n                            data-e2e=\"templates-print-locally-checkbox\"\n                            id=\"print-locally\"\n                            [formControl]=\"miccbForm.controls['printLocally']\"\n                        />\n                        <label for=\"print-locally\">\n                            {{ 'miccb_user_config.advanced.printLocally' | translate }}\n                        </label>\n                    </div>\n                </div>\n                <!-- Use email for distribution -->\n                <div class=\"row\">\n                    <div class=\"col-12 checkbox-section\">\n                        <input\n                            type=\"checkbox\"\n                            data-e2e=\"templates-use-email-for-distribution-checkbox\"\n                            id=\"use-email-for-distribution\"\n                            [formControl]=\"miccbForm.controls['useEmailForDistribution']\"\n                        />\n                        <label for=\"use-email-for-distribution\">\n                            {{ 'miccb_user_config.advanced.useEmailForDistribution' | translate }}\n                        </label>\n                    </div>\n                </div>\n                <!-- See all queues -->\n                <div class=\"row\">\n                    <div class=\"col-12 checkbox-section\">\n                        <input\n                            type=\"checkbox\"\n                            data-e2e=\"templates-see-all-queues-checkbox\"\n                            id=\"see-all-queues\"\n                            [formControl]=\"miccbForm.controls['seeAllQueues']\"\n                        />\n                        <label for=\"see-all-queues\">\n                            {{ 'miccb_user_config.advanced.seeAllQueues' | translate }}\n                        </label>\n                    </div>\n                </div>\n            </mat-expansion-panel>\n            <mat-expansion-panel [expanded]=\"true\">\n                <mat-expansion-panel-header>\n                    <mat-panel-title class=\"expansion-section-title\">\n                        {{ 'miccb_user_config.licensing.title' | translate }}\n                    </mat-panel-title>\n                </mat-expansion-panel-header>\n                <div class=\"row\">\n                    <!-- Supervisor License -->\n                    <div class=\"col-md-6 col-sm-12 form-group\">\n                        <mat-form-field class=\"form-input\" category=\"usertemplates\">\n                            <mat-label>{{ 'miccb_user_config.licensing.supervisorLicense' | translate }}</mat-label>\n                            <mat-select\n                                id=\"supervisorLicense\"\n                                data-e2e=\"supervisor-license-dropdown\"\n                                [formControl]=\"miccbForm.controls['supervisorLicense']\"\n                            >\n                                <mat-option [value]=\"option.id\" *ngFor=\"let option of supervisorLicenseTypes$ | async\">\n                                    {{ option.label }}\n                                </mat-option>\n                            </mat-select>\n                        </mat-form-field>\n                    </div>\n                    <!-- Phone types -->\n                    <div *ngIf=\"!deskphoneOnly\" class=\"col-md-6 col-sm-12 form-group\">\n                        <mat-form-field class=\"form-input\" category=\"usertemplates\">\n                            <mat-label>{{ 'miccb_user_config.licensing.phoneTypeLicense' | translate }}</mat-label>\n                            <mat-select\n                                id=\"phoneTypeLicense\"\n                                data-e2e=\"phone-type-license-dropdown\"\n                                [formControl]=\"miccbForm.controls['phoneTypeLicense']\"\n                            >\n                                <mat-option [value]=\"option.id\" *ngFor=\"let option of phoneTypes\">\n                                    {{ option.label }}\n                                </mat-option>\n                            </mat-select>\n                        </mat-form-field>\n                    </div>\n                    <div *ngIf=\"deskphoneOnly\" class=\"col-md-6 col-sm-12 form-group\">\n                        <mat-form-field class=\"form-input\" category=\"usertemplates\">\n                            <mat-label>{{ 'miccb_user_config.licensing.phoneTypeLicense' | translate }}</mat-label>\n                            <mat-select\n                                id=\"phoneTypeLicense\"\n                                data-e2e=\"phone-type-license-dropdown\"\n                                [formControl]=\"miccbForm.controls['phoneTypeLicense']\"\n                            >\n                                <mat-option [value]=\"option.id\" *ngFor=\"let option of deskphoneTypes\">\n                                    {{ option.label }}\n                                </mat-option>\n                            </mat-select>\n                        </mat-form-field>\n                    </div>\n                </div>\n                <!-- Multimedia Contact Center License -->\n                <div class=\"row\">\n                    <div class=\"col-12 checkbox-section\">\n                        <input\n                            type=\"checkbox\"\n                            data-e2e=\"templates-mcc-license-checkbox\"\n                            id=\"mcc-license\"\n                            [formControl]=\"miccbForm.controls['mccLicense']\"\n                        />\n                        <label for=\"mcc-license\">\n                            {{ 'miccb_user_config.licensing.mccLicense' | translate }}\n                        </label>\n                    </div>\n                </div>\n                <!-- Contact Center Voice License -->\n                <div class=\"row\">\n                    <div class=\"col-12 checkbox-section\">\n                        <input\n                            type=\"checkbox\"\n                            data-e2e=\"templates-voice-license-checkbox\"\n                            id=\"voice-license\"\n                            [formControl]=\"miccbForm.controls['voiceLicense']\"\n                        />\n                        <label for=\"voice-license\">\n                            {{ 'miccb_user_config.licensing.voiceLicense' | translate }}\n                        </label>\n                    </div>\n                </div>\n            </mat-expansion-panel>\n        </mat-accordion>\n        <div class=\"row\" *ngFor=\"let validationError of validationErrors\">\n            <div class=\"error\" *ngIf=\"validationError.severity === 'Error'\">\n                <mat-icon class=\"error-icon\" svgIcon=\"caution-circle\"></mat-icon>\n                <div class=\"error-text\">{{ validationError.description }}</div>\n            </div>\n            <div class=\"error\" *ngIf=\"validationError.severity === 'Warning'\">\n                <mat-icon class=\"error-icon\" svgIcon=\"caution\"></mat-icon>\n                <div class=\"warn-text\">{{ validationError.description }}</div>\n            </div>\n        </div>\n        <div class=\"version\">{{ 'miccb_user_config.version' | translate: {version} }}</div>\n    </div>\n    <!-- end of section-content -->\n</div>\n<!-- end of section-container -->\n", styles: ["@charset \"UTF-8\";.section-container{margin:0 -20px}.section-container>.col{border-bottom:1px solid #d1d6db;padding:24px}.section-container.nonmivb{border-top:1px solid #d1d6db}.section-details{border-right:1px solid #d1d6db;background:#f1f4f8;max-width:280px;padding-top:24px!important}.section-details .section-details-container{position:sticky;top:87px}.section-details .title{font-family:Open Sans;font-style:normal;font-weight:600;font-size:16px;line-height:24px;color:#464b51;position:sticky;top:87px}.section-details .description{font-family:Open Sans;font-style:normal;font-weight:400;font-size:12px;line-height:16px;color:#595e64}.section-details button{margin-top:16px}.section-details .badge{background-color:#595e64;color:#fff;padding:4px 8px;text-align:center;border-radius:5px}.section-details .action-form a{color:#0073d0;text-decoration:underline;font-size:14px;font-weight:600;font-stretch:normal;font-style:normal;line-height:1.75;letter-spacing:normal;font-family:Open Sans,sans-serif}.section-details .action-form a:hover{cursor:pointer}.section-details .action-form a.disableLink{color:#acb3b9;cursor:default}.section-content .row{margin-right:-8px;margin-left:-8px}.section-content .col{padding-right:8px;padding-left:8px}.section-content .row~.row{margin-top:8px}.section-content .error{display:flex;align-items:center;font-family:Open Sans;font-style:normal;font-weight:600;font-size:13px;line-height:normal}.section-content .error .error-icon{width:20px;height:20px}.section-content .error .error-text{padding-left:3px;color:#a4221e}.section-content .error .warn-text{padding-left:3px;color:#876001}mat-expansion-panel{border:1px solid #d1d6db;border-radius:12px!important;box-shadow:none!important;margin-bottom:8px!important}mat-expansion-panel mat-expansion-panel-header{height:60px;max-width:570px}mat-expansion-panel mat-expansion-panel-header mat-panel-title{width:100%;margin-right:0}mat-expansion-panel .error-icon-container{align-self:center}mat-expansion-panel .error-icon-container.phone-header{margin-left:auto;margin-right:10px}mat-expansion-panel .error-icon{margin-right:10px}mat-expansion-panel .info-icon{vertical-align:top}.checkbox-section{display:flex;flex-direction:row;flex-wrap:wrap;align-items:center}.checkbox-section.form-group{margin-bottom:1rem}.checkbox-section input[type=checkbox]{-webkit-appearance:none;width:16px;height:16px;border-radius:4px;border:solid 1px #d1d6db;background-image:linear-gradient(to top,#f2f4f7,#fff);cursor:pointer}.checkbox-section input[type=checkbox]:checked{border-color:#0080e7;background-image:linear-gradient(to top,#0080e7,#0080e7);transform:translate(0)}.checkbox-section input[type=checkbox]:checked:disabled{cursor:unset;background:linear-gradient(0deg,#fff9,#fff9),#0073d0;border-color:#d1d6db}.checkbox-section input[type=checkbox]:checked:disabled+label{cursor:unset;font-weight:600;color:#49505761}.checkbox-section input[type=checkbox]:checked:after{content:\"\\2713\";color:#fff;position:absolute;left:50%;top:50%;transform:translate(-50%,-50%)}.checkbox-section input[type=checkbox]:checked+label{color:#1f1f1f;font-weight:600}.checkbox-section input[type=checkbox]:disabled{cursor:unset;background-image:linear-gradient(to top,#d1d6db,#d1d6db80)}.checkbox-section input[type=checkbox]:disabled+label{cursor:unset;color:#49505761}.checkbox-section input[type=checkbox]:focus{outline:none;box-shadow:0 0 5px 1px #2ea2f8}.checkbox-section label{margin-left:0!important;margin-bottom:0;font-family:Open Sans,serif;font-size:14px;font-weight:400;font-stretch:normal;font-style:normal;line-height:1.375;letter-spacing:normal;color:#495057;cursor:pointer}.checkbox-section .alert{max-width:95%;margin-left:24px}.checkbox-section .error-margin{margin-left:8px}.checkbox-subsection{padding-left:24px!important}.checkbox-subsection .form-group{margin-bottom:.5rem}.media-type-option{max-width:-moz-fit-content;max-width:fit-content}.media-type-option .checkbox-section{flex-wrap:nowrap}.group-label{text-align:initial;display:inline-block;font-family:Open Sans,sans-serif;font-weight:600;font-size:14px;color:#495057}.group-label.text-disabled{color:#49505761}.group-element{display:flex;align-items:center;justify-content:space-between;gap:1rem;margin-top:.5rem;margin-bottom:.5rem}.version{font-size:10px;font-weight:400;color:#acb3b9;font-family:OpenSans-Italic;float:right}\n"] }]
        }], ctorParameters: function () { return [{ type: i1$2.MatIconRegistry }, { type: i2$1.DomSanitizer }, { type: MiccbApiService }, { type: EmployeeService }, { type: i2.TranslateService }, { type: i1.UntypedFormBuilder }, { type: i0.ChangeDetectorRef }]; }, propDecorators: { Accordion: [{
                type: ViewChild,
                args: ['accordion', { static: true }]
            }], expansionPanels: [{
                type: ViewChildren,
                args: [MatExpansionPanel]
            }], action: [{
                type: Input
            }], nonmivb: [{
                type: Input
            }], cceServiceTemplate: [{
                type: Input
            }], user: [{
                type: Input
            }], formStatusSvc: [{
                type: Input
            }], interProductDataShareSvc: [{
                type: Input
            }], onFormChanged: [{
                type: Output
            }] } });

const logContext$4 = 'MiccbUserConfigurationComponent';
class MiccbUserConfigurationComponent {
    propertyShareSvc;
    translateService;
    formStatusService;
    cd;
    employeeComponent;
    user;
    allInputsSentFromParent = new Subject();
    errMsgStyle = { 'max-width': '500px' };
    submitted = false;
    loading = true;
    setupComplete = false;
    enableSave = false;
    // There are subscriptions in Account's App user-prod-miccb.service.ts, that listen to these outputs.
    // eg,
    //       componentInstance.error?.subscribe()
    //       componentInstance.processing.subscribe(
    saving = new EventEmitter();
    processing = new EventEmitter();
    error = new EventEmitter();
    dirty = new EventEmitter();
    initialized = new EventEmitter();
    tableOfContentsItemChanged = new EventEmitter();
    formStatusUpdate = new EventEmitter();
    action = ActionType.CREATE;
    errorInForm = false;
    errorCount = 0;
    errorMessage = null;
    isDirty = true; // enable save on create
    subscription = new Subscription();
    loadingErrors = [];
    cceServiceTemplate;
    showSaveMenu = false;
    selectedSaveType = saveTypes.SAVE;
    saveButtonOptions = [
        {
            value: saveTypes.SAVE,
            enabled: false
        },
        {
            value: saveTypes.SAVE_AND_DEPLOY,
            enabled: false
        },
        {
            value: saveTypes.DEPLOY,
            enabled: false
        }
    ];
    constructor(propertyShareSvc, translateService, formStatusService, cd) {
        this.propertyShareSvc = propertyShareSvc;
        this.translateService = translateService;
        this.formStatusService = formStatusService;
        this.cd = cd;
        translateService.onLangChange.subscribe((event) => {
            this.setErrorMessage();
            this.tableOfContentsItemChanged.emit(this.formStatusService.getTableOfContents());
        });
    }
    async ngOnInit() {
        this.subscription.add(this.allInputsSentFromParent.subscribe(async (sent) => {
            console.log(`${logContext$4}.allInputsSentFromParent:`, sent);
            this.setFormStatusListener();
            this.setTemplate();
            this.loading = false;
            this.setSaveOptions();
        }));
        //tells the parent ngOnInit has completed - we have now subscribed to allInputsSentFromParent
        this.initialized.emit();
    }
    setTemplate() {
        if (this.propertyShareSvc.temporaryTemplate) {
            const currentUserTemplate = this.propertyShareSvc.temporaryTemplate;
            if (currentUserTemplate?.pbxConfig?.cceServiceTemplate) {
                this.cceServiceTemplate = currentUserTemplate.pbxConfig.cceServiceTemplate;
                console.log(`${logContext$4} cceServiceTemplate`, this.cceServiceTemplate);
            }
            this.propertyShareSvc.temporaryTemplate = undefined;
        }
    }
    ngOnDestroy() {
        if (this.subscription) {
            this.subscription.unsubscribe();
        }
    }
    areSaveOptionsEnabled() {
        if (!!this.employeeComponent && !this.errorInForm) {
            this.enableSave = true;
            this.setSaveOptions();
        }
        else {
            this.enableSave = false;
        }
    }
    handleFormChange(data) {
        let isDirty = this.formStatusService.hasTableOfContentsUnsavedChanges();
        if (isDirty != this.isDirty) {
            this.isDirty = isDirty;
            this.dirty.emit(this.isDirty);
        }
        this.areSaveOptionsEnabled();
        this.tableOfContentsItemChanged.emit(this.formStatusService.getTableOfContents());
    }
    setFormStatusListener() {
        console.log(`${logContext$4}.setFormStatusListner`);
        this.formStatusService.init();
        this.subscription.add(this.formStatusService.update$.subscribe(() => {
            let errorInForm = this.formStatusService.userConfiguration.hasErrors();
            if (this.errorInForm !== errorInForm) {
                this.formStatusUpdate.next(errorInForm);
            }
            this.errorInForm = errorInForm;
            this.errorCount = this.formStatusService.userConfiguration.errorCount();
            this.areSaveOptionsEnabled();
            this.setErrorMessage();
            this.tableOfContentsItemChanged.emit(this.formStatusService.getTableOfContents());
        }));
    }
    setErrorMessage() {
        let newErrorMessage;
        if (this.errorCount > 1) {
            newErrorMessage = this.translateService.instant('miccb_user_config.errors.errorsInForm', { count: this.errorCount });
        }
        else if (this.errorCount === 1) {
            newErrorMessage = this.translateService.instant('miccb_user_config.errors.errorInForm', { count: this.errorCount });
        }
        else {
            newErrorMessage = null;
        }
        if (newErrorMessage !== this.errorMessage) {
            this.errorMessage = newErrorMessage;
            this.cd.detectChanges(); // To avoid an ExpressionChangedAfterItHasBeenCheckedError https://angular.io/errors/NG0100
        }
    }
    getTableOfContents() {
        if (this.loading) {
            // asking for table of contents before the component is done loading
            // need to ensure the formStatusService is reset/initialized
            this.formStatusService.init();
        }
        return this.formStatusService.getTableOfContents();
    }
    setSaveOptions() {
        if (!this.loading || !this.enableSave) {
            if (!!this.employeeComponent && this.employeeComponent.isDirty()) {
                this.saveButtonOptions[0].enabled = true; //save
                this.saveButtonOptions[1].enabled = true; //save and deploy
                this.saveButtonOptions[2].enabled = false; //deploy
            }
            else {
                this.saveButtonOptions[0].enabled = false;
                this.saveButtonOptions[1].enabled = false;
                this.saveButtonOptions[2].enabled = true; //enable deploy
            }
        }
        else {
            this.saveButtonOptions[0].enabled = false;
            this.saveButtonOptions[1].enabled = false;
            this.saveButtonOptions[2].enabled = false;
        }
        this.setDefaultSaveOption();
    }
    setDefaultSaveOption() {
        if (this.enableSave) {
            //find the first one that is enabled
            let enabledOptionIndex = this.saveButtonOptions.findIndex(opt => opt.enabled === true);
            if (enabledOptionIndex > -1) {
                this.selectedSaveType = this.saveButtonOptions[enabledOptionIndex].value;
            }
            else if (this.showSaveMenu) {
                //no save options are enabled, so make sure the save menu is closed
                this.closeSaveMenu();
            }
        }
    }
    closeSaveMenu() {
        this.showSaveMenu = false;
    }
    openSaveMenu() {
        this.showSaveMenu = true;
    }
    toggleShowSaveMenu() {
        if (this.showSaveMenu) {
            this.closeSaveMenu();
        }
        else {
            this.areSaveOptionsEnabled();
            this.openSaveMenu();
            setTimeout(() => {
                const elem = document.getElementById(`${this.selectedSaveType}-option`);
                if (elem && elem.focus) {
                    elem.focus({ preventScroll: true });
                }
            }, 0);
        }
    }
    onFocusOutOfSaveOption(event) {
        if (event && event.relatedTarget) {
            if (event.relatedTarget.id) {
                if (event.relatedTarget.id === `${saveTypes.SAVE}-option` ||
                    event.relatedTarget.id === `${saveTypes.SAVE_AND_DEPLOY}-option` ||
                    event.relatedTarget.id === `${saveTypes.DEPLOY}-option` ||
                    event.relatedTarget.id === 'save-dropdown-button') {
                    return;
                }
            }
        }
        this.closeSaveMenu();
    }
    selectSaveOption(saveType) {
        this.selectedSaveType = saveType;
        this.closeSaveMenu();
        this.saveConfiguration();
    }
    async saveConfiguration() {
        if (!!this.employeeComponent) {
            this.processing.emit({
                status: asyncJobProcessingStatus.START,
                asyncJobId: this.user.userId,
                saveType: this.selectedSaveType
            });
            const employee = await this.employeeComponent.getEmployee();
            if (this.selectedSaveType === saveTypes.SAVE || this.selectedSaveType === saveTypes.SAVE_AND_DEPLOY) {
                this.employeeComponent
                    .save()
                    .then(() => {
                    this.processing.emit({
                        asyncJobId: this.user.userId,
                        status: asyncJobStatus.COMPLETE,
                        saveType: this.selectedSaveType,
                        method: !!employee ? HTTP_METHODS.PUT : HTTP_METHODS.POST
                    });
                })
                    .catch(err => {
                    this.error.emit(err);
                    this.processing.emit({
                        asyncJobId: this.user.userId,
                        status: asyncJobStatus.FAILED,
                        saveType: this.selectedSaveType,
                        method: !!employee ? HTTP_METHODS.PUT : HTTP_METHODS.POST
                    });
                });
            }
            this.processing.emit({
                asyncJobId: this.user.userId,
                status: asyncJobProcessingStatus.IN_PROGRESS,
                saveType: this.selectedSaveType,
                method: !!employee ? HTTP_METHODS.PUT : HTTP_METHODS.POST
            });
        }
    }
    static ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: MiccbUserConfigurationComponent, deps: [{ token: PropertyShareService }, { token: i2.TranslateService }, { token: FormStatusService }, { token: i0.ChangeDetectorRef }], target: i0.ɵɵFactoryTarget.Component });
    static ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.2.12", type: MiccbUserConfigurationComponent, selector: "miccb-user-configuration", inputs: { user: "user", allInputsSentFromParent: "allInputsSentFromParent" }, outputs: { saving: "saving", processing: "processing", error: "error", dirty: "dirty", initialized: "initialized", tableOfContentsItemChanged: "tableOfContentsItemChanged", formStatusUpdate: "formStatusUpdate" }, viewQueries: [{ propertyName: "employeeComponent", first: true, predicate: ["contactCenterEmployee"], descendants: true }], ngImport: i0, template: "<form>\n    <div class=\"spinner-state\" *ngIf=\"loading\">\n        <img *ngIf=\"loading\" src=\"assets/miccb-components/images/Spinner.png\" class=\"config-loading animate-spinner\" />\n    </div>\n    <ng-container *ngIf=\"!loading && loadingErrors.length > 0\">\n        <ul>\n            <li *ngFor=\"let error of loadingErrors\" class=\"loading-error\">\n                <span class=\"loading-error message\">{{ 'miccb_user_config.errors.loading' + error | translate }}</span>\n            </li>\n        </ul>\n    </ng-container>\n    <ng-container *ngIf=\"!loading && loadingErrors.length === 0\">\n        <div class=\"form-container\">\n            <miccb-employee\n                id=\"miccb-employee\"\n                #contactCenterEmployee\n                [user]=\"user\"\n                [nonmivb]=\"true\"\n                [cceServiceTemplate]=\"cceServiceTemplate\"\n                [formStatusSvc]=\"formStatusService\"\n                (onFormChanged)=\"handleFormChange($event)\"\n            ></miccb-employee>\n        </div>\n        <!-- end of form-container -->\n        <div class=\"form-action-container\">\n            <div class=\"row\">\n                <div id=\"error-in-form\" *ngIf=\"errorInForm\" class=\"col col-9 clickable\" (click)=\"expandForErrors()\">\n                    <div class=\"row\">\n                        <mat-icon class=\"error-col\" svgIcon=\"caution-circle\"></mat-icon>\n                        <div class=\"error-col col\">{{ errorMessage }}</div>\n                    </div>\n                </div>\n                <div class=\"col button-group\">\n                  <button\n                      class=\"save-button\"\n                      type=\"button\"\n                      mat-flat-button\n                      color=\"primary\"\n                      data-e2e=\"cap-save-button\"\n                      [disabled]=\"!enableSave\"\n                      (click)=\"saveConfiguration()\">\n                      {{'miccb_user_config.save_options.' + selectedSaveType + '.heading' | translate}}\n                  </button>\n                  <div class = \"save-dropdown-group\">\n                      <button\n                      class=\"save-dropdown-button\"\n                      id= \"save-dropdown-button\"\n                      type=\"button\"\n                      mat-flat-button\n                      color=\"primary\"\n                      data-e2e=\"cap-save-button\"\n                      [disabled]=\"!enableSave\"\n                      (click)=\"toggleShowSaveMenu()\"\n                      (focus)=\"closeSaveMenu()\"\n                      >\n                      \u25BC\n                      </button>\n\n                      <div *ngIf =\"showSaveMenu\" class=\"save-options-menu\" id= \"save-options-menu\">\n                          <div class=\"select-save-options-menu-list\">\n                              <button *ngFor=\"let saveOption of saveButtonOptions\"\n                                  class=\"save-menu-item\"\n                                  id= '{{saveOption.value}}-option'\n                                  [attr.data-e2e]=\"'cap-'+ saveOption.value + '-option-button'\"\n                                  [disabled]=\"!saveOption.enabled\"\n                                  (focusout)= \"onFocusOutOfSaveOption($event)\"\n                                  (click)=\"selectSaveOption(saveOption.value)\"\n                                  >\n                                  <p *ngIf =\"saveOption.value === selectedSaveType\" class=\"save-option-selected-check\">&#10004;</p>\n                                  <p *ngIf =\"saveOption.value !== selectedSaveType\" class=\"save-option-selected-check\"></p>\n                                  <div class=\"save-menu-item-text\">\n                                      <span class=\"save-menu-item-heading\">\n                                          {{ 'miccb_user_config.save_options.' + saveOption.value +'.heading' | translate }}</span>\n                                      <span class=\"save-menu-item-description\">\n                                          {{ 'miccb_user_config.save_options.' + saveOption.value +'.description' | translate }}</span>\n                                  </div>\n                              </button>\n                          </div>\n                      </div>\n                  </div>\n              </div >\n            </div>\n        </div>\n    </ng-container>\n</form>\n", styles: ["form{max-width:-moz-fit-content;max-width:fit-content;min-width:-webkit-fill-available;min-width:-moz-available}.form-action-container{margin:16px -20px -4px;font-family:Open Sans;font-style:normal;font-weight:400;font-size:14px;line-height:19px;color:#a4221e}.form-action-container .row{align-items:center;margin-left:0;margin-right:0}.form-action-container .col{padding-left:16px;padding-right:16px}.form-action-container .clickable{cursor:pointer}.form-action-container .error-col{padding:0}.loading-error{color:red}.loading-error .message{font-size:14px;font-family:sans-serif}.spinner-state{height:36px;padding-top:2px;overflow:hidden}.spinner-state .config-loading{height:27px;width:27px;opacity:.6;display:inline-block;vertical-align:middle;white-space:nowrap}.spinner-state .animate-spinner{animation:rotate .75s linear infinite}.button-group{text-align:end;width:-moz-fit-content;width:fit-content;max-width:-moz-fit-content;max-width:fit-content;flex:0;display:flex;margin-left:auto}.save-button{text-align:end;border-top-right-radius:0;border-bottom-right-radius:0;border-right:0!important;border:1px solid;border-color:#a9a9a9}.save-dropdown-group{position:relative}.save-dropdown-button{border:1px solid!important;border-top-left-radius:0;border-bottom-left-radius:0;border-color:#a9a9a9!important;max-width:10px;padding:0;min-width:41px;font-size:11px}.save-options-menu{position:absolute!important;left:-270px!important;top:100%;z-index:99;width:310px;margin-top:3px;padding-bottom:50px}.select-save-options-menu-list{position:relative;max-height:400px;overflow:auto;border-radius:7px;border:1px solid #D1D6DB}.save-menu-item{display:flex;padding:8px;overflow:hidden;cursor:pointer;width:100%!important;text-align:left;background-color:#fff;border:none}.save-menu-item:not(:last-child){border-bottom:1px solid #D1D6DB}.save-menu-item:hover:enabled{background-color:#0073d0!important;color:#fff!important}.save-menu-item:hover:enabled .save-option-selected-check{color:#fff!important}.save-menu-item:hover:not(:enabled){cursor:default}.save-menu-item:focus{background-color:#0073d0!important;color:#fff!important}.save-menu-item:focus .save-option-selected-check{color:#fff!important}.save-option-selected-icon{margin-right:5px}.save-option-selected-check{margin-right:5px;color:#0073d0;width:11.125px!important}.save-menu-item-heading{display:block;margin-top:0;margin-bottom:0;font-size:14px;font-weight:var(--base-text-weight-semibold, 600)}.save-menu-item-description{display:block;max-width:265px;font-size:12px;overflow-wrap:break-word}.save-menu-item-description.extra-details{font-weight:600;color:red}\n"], dependencies: [{ kind: "directive", type: i5.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { kind: "directive", type: i5.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: i1.ɵNgNoValidate, selector: "form:not([ngNoForm]):not([ngNativeValidate])" }, { kind: "directive", type: i1.NgControlStatusGroup, selector: "[formGroupName],[formArrayName],[ngModelGroup],[formGroup],form:not([ngNoForm]),[ngForm]" }, { kind: "directive", type: i1.NgForm, selector: "form:not([ngNoForm]):not([formGroup]),ng-form,[ngForm]", inputs: ["ngFormOptions"], outputs: ["ngSubmit"], exportAs: ["ngForm"] }, { kind: "component", type: i1$2.MatIcon, selector: "mat-icon", inputs: ["color", "inline", "svgIcon", "fontSet", "fontIcon"], exportAs: ["matIcon"] }, { kind: "component", type: i9.MatButton, selector: "    button[mat-button], button[mat-raised-button], button[mat-flat-button],    button[mat-stroked-button]  ", inputs: ["disabled", "disableRipple", "color"], exportAs: ["matButton"] }, { kind: "component", type: EmployeeComponent, selector: "miccb-employee", inputs: ["action", "nonmivb", "cceServiceTemplate", "user", "formStatusSvc", "interProductDataShareSvc"], outputs: ["onFormChanged"] }, { kind: "pipe", type: i2.TranslatePipe, name: "translate" }] });
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: MiccbUserConfigurationComponent, decorators: [{
            type: Component,
            args: [{ selector: 'miccb-user-configuration', template: "<form>\n    <div class=\"spinner-state\" *ngIf=\"loading\">\n        <img *ngIf=\"loading\" src=\"assets/miccb-components/images/Spinner.png\" class=\"config-loading animate-spinner\" />\n    </div>\n    <ng-container *ngIf=\"!loading && loadingErrors.length > 0\">\n        <ul>\n            <li *ngFor=\"let error of loadingErrors\" class=\"loading-error\">\n                <span class=\"loading-error message\">{{ 'miccb_user_config.errors.loading' + error | translate }}</span>\n            </li>\n        </ul>\n    </ng-container>\n    <ng-container *ngIf=\"!loading && loadingErrors.length === 0\">\n        <div class=\"form-container\">\n            <miccb-employee\n                id=\"miccb-employee\"\n                #contactCenterEmployee\n                [user]=\"user\"\n                [nonmivb]=\"true\"\n                [cceServiceTemplate]=\"cceServiceTemplate\"\n                [formStatusSvc]=\"formStatusService\"\n                (onFormChanged)=\"handleFormChange($event)\"\n            ></miccb-employee>\n        </div>\n        <!-- end of form-container -->\n        <div class=\"form-action-container\">\n            <div class=\"row\">\n                <div id=\"error-in-form\" *ngIf=\"errorInForm\" class=\"col col-9 clickable\" (click)=\"expandForErrors()\">\n                    <div class=\"row\">\n                        <mat-icon class=\"error-col\" svgIcon=\"caution-circle\"></mat-icon>\n                        <div class=\"error-col col\">{{ errorMessage }}</div>\n                    </div>\n                </div>\n                <div class=\"col button-group\">\n                  <button\n                      class=\"save-button\"\n                      type=\"button\"\n                      mat-flat-button\n                      color=\"primary\"\n                      data-e2e=\"cap-save-button\"\n                      [disabled]=\"!enableSave\"\n                      (click)=\"saveConfiguration()\">\n                      {{'miccb_user_config.save_options.' + selectedSaveType + '.heading' | translate}}\n                  </button>\n                  <div class = \"save-dropdown-group\">\n                      <button\n                      class=\"save-dropdown-button\"\n                      id= \"save-dropdown-button\"\n                      type=\"button\"\n                      mat-flat-button\n                      color=\"primary\"\n                      data-e2e=\"cap-save-button\"\n                      [disabled]=\"!enableSave\"\n                      (click)=\"toggleShowSaveMenu()\"\n                      (focus)=\"closeSaveMenu()\"\n                      >\n                      \u25BC\n                      </button>\n\n                      <div *ngIf =\"showSaveMenu\" class=\"save-options-menu\" id= \"save-options-menu\">\n                          <div class=\"select-save-options-menu-list\">\n                              <button *ngFor=\"let saveOption of saveButtonOptions\"\n                                  class=\"save-menu-item\"\n                                  id= '{{saveOption.value}}-option'\n                                  [attr.data-e2e]=\"'cap-'+ saveOption.value + '-option-button'\"\n                                  [disabled]=\"!saveOption.enabled\"\n                                  (focusout)= \"onFocusOutOfSaveOption($event)\"\n                                  (click)=\"selectSaveOption(saveOption.value)\"\n                                  >\n                                  <p *ngIf =\"saveOption.value === selectedSaveType\" class=\"save-option-selected-check\">&#10004;</p>\n                                  <p *ngIf =\"saveOption.value !== selectedSaveType\" class=\"save-option-selected-check\"></p>\n                                  <div class=\"save-menu-item-text\">\n                                      <span class=\"save-menu-item-heading\">\n                                          {{ 'miccb_user_config.save_options.' + saveOption.value +'.heading' | translate }}</span>\n                                      <span class=\"save-menu-item-description\">\n                                          {{ 'miccb_user_config.save_options.' + saveOption.value +'.description' | translate }}</span>\n                                  </div>\n                              </button>\n                          </div>\n                      </div>\n                  </div>\n              </div >\n            </div>\n        </div>\n    </ng-container>\n</form>\n", styles: ["form{max-width:-moz-fit-content;max-width:fit-content;min-width:-webkit-fill-available;min-width:-moz-available}.form-action-container{margin:16px -20px -4px;font-family:Open Sans;font-style:normal;font-weight:400;font-size:14px;line-height:19px;color:#a4221e}.form-action-container .row{align-items:center;margin-left:0;margin-right:0}.form-action-container .col{padding-left:16px;padding-right:16px}.form-action-container .clickable{cursor:pointer}.form-action-container .error-col{padding:0}.loading-error{color:red}.loading-error .message{font-size:14px;font-family:sans-serif}.spinner-state{height:36px;padding-top:2px;overflow:hidden}.spinner-state .config-loading{height:27px;width:27px;opacity:.6;display:inline-block;vertical-align:middle;white-space:nowrap}.spinner-state .animate-spinner{animation:rotate .75s linear infinite}.button-group{text-align:end;width:-moz-fit-content;width:fit-content;max-width:-moz-fit-content;max-width:fit-content;flex:0;display:flex;margin-left:auto}.save-button{text-align:end;border-top-right-radius:0;border-bottom-right-radius:0;border-right:0!important;border:1px solid;border-color:#a9a9a9}.save-dropdown-group{position:relative}.save-dropdown-button{border:1px solid!important;border-top-left-radius:0;border-bottom-left-radius:0;border-color:#a9a9a9!important;max-width:10px;padding:0;min-width:41px;font-size:11px}.save-options-menu{position:absolute!important;left:-270px!important;top:100%;z-index:99;width:310px;margin-top:3px;padding-bottom:50px}.select-save-options-menu-list{position:relative;max-height:400px;overflow:auto;border-radius:7px;border:1px solid #D1D6DB}.save-menu-item{display:flex;padding:8px;overflow:hidden;cursor:pointer;width:100%!important;text-align:left;background-color:#fff;border:none}.save-menu-item:not(:last-child){border-bottom:1px solid #D1D6DB}.save-menu-item:hover:enabled{background-color:#0073d0!important;color:#fff!important}.save-menu-item:hover:enabled .save-option-selected-check{color:#fff!important}.save-menu-item:hover:not(:enabled){cursor:default}.save-menu-item:focus{background-color:#0073d0!important;color:#fff!important}.save-menu-item:focus .save-option-selected-check{color:#fff!important}.save-option-selected-icon{margin-right:5px}.save-option-selected-check{margin-right:5px;color:#0073d0;width:11.125px!important}.save-menu-item-heading{display:block;margin-top:0;margin-bottom:0;font-size:14px;font-weight:var(--base-text-weight-semibold, 600)}.save-menu-item-description{display:block;max-width:265px;font-size:12px;overflow-wrap:break-word}.save-menu-item-description.extra-details{font-weight:600;color:red}\n"] }]
        }], ctorParameters: function () { return [{ type: PropertyShareService }, { type: i2.TranslateService }, { type: FormStatusService }, { type: i0.ChangeDetectorRef }]; }, propDecorators: { employeeComponent: [{
                type: ViewChild,
                args: ['contactCenterEmployee']
            }], user: [{
                type: Input
            }], allInputsSentFromParent: [{
                type: Input
            }], saving: [{
                type: Output
            }], processing: [{
                type: Output
            }], error: [{
                type: Output
            }], dirty: [{
                type: Output
            }], initialized: [{
                type: Output
            }], tableOfContentsItemChanged: [{
                type: Output
            }], formStatusUpdate: [{
                type: Output
            }] } });

const logContext$3 = 'MiccbAgentGroupsService';
const mediaTypes = ['voice', 'chat', 'email', 'sms', 'openMedia'];
class AgentGroupsService {
    apiService;
    translateService;
    constructor(apiService, translateService) {
        this.apiService = apiService;
        this.translateService = translateService;
    }
    async getAgentGroups(accountId) {
        if (!accountId) {
            console.error(`${logContext$3}: unable to get agent groups - missing accountId.`);
            return;
        }
        try {
            const res = await this.apiService.getAgentGroups(accountId).toPromise();
            console.log(`${logContext$3}: get Agent Groups success.`, res);
            return res._embedded.items;
        }
        catch (error) {
            console.error(`${logContext$3}: get Agent Groups failed.`, error);
            throw error;
        }
    }
    async createAgentGroup(accountId, data) {
        if (!accountId) {
            console.error(`${logContext$3}: unable to create agent group - missing accountId.`);
            return;
        }
        try {
            if (data?.resilentFqdnOrIpAddress) {
                data.voiceFailoverMediaServerRefId = await this.apiService
                    .getMediaServerByIpAddressOrDnsName(accountId, data.resilentFqdnOrIpAddress)
                    .toPromise();
            }
            const reqBody = this.getReqBody(data);
            console.log(`${logContext$3}.createAgentGroup`, reqBody);
            const res = await this.apiService.createAgentGroup(accountId, reqBody).toPromise();
            console.log(`${logContext$3}: create Agent Group success.`, res);
            return res?.id;
        }
        catch (error) {
            console.error(`${logContext$3}: create Agent Group failed.`, error);
            throw error;
        }
    }
    async updateAgentGroup(accountId, data) {
        if (!accountId) {
            console.error(`${logContext$3}: Unable to update agent group - missing accountId.`);
            return;
        }
        let groupId = '';
        try {
            if (data?.resilentFqdnOrIpAddress) {
                data.voiceFailoverMediaServerRefId = await this.apiService
                    .getMediaServerByIpAddressOrDnsName(accountId, data.resilentFqdnOrIpAddress)
                    .toPromise();
            }
            const reqBody = this.getReqBody(data);
            console.log(`${logContext$3}.updateAgentGroup`, reqBody);
            groupId = await this.getAgentGroupIdByGroupIdNumber(accountId, data.groupNumber);
            const res = await this.apiService.updateAgentGroup(accountId, groupId, reqBody).toPromise();
            console.log(`${logContext$3}: update Agent Group ${groupId} success.`, res);
            return groupId;
        }
        catch (error) {
            console.error(`${logContext$3}: update Agent Group ${groupId} failed.`, error);
            throw error;
        }
    }
    async deleteAgentGroup(accountId, data) {
        if (!accountId) {
            console.error(`${logContext$3}: Unable to delete agent group - missing accountId.`);
            return;
        }
        let groupId = '';
        try {
            groupId = await this.getAgentGroupIdByGroupIdNumber(accountId, data.groupNumber);
            const result = await this.apiService.deleteAgentGroup(accountId, groupId).toPromise();
            console.log(`${logContext$3}: delete Agent Group ${groupId} success.`, { result });
        }
        catch (error) {
            console.error(`${logContext$3}: delete Agent Group ${groupId} failed.`, error);
            throw error;
        }
    }
    async getAgentGroupByReporting(accountId, reporting) {
        if (!accountId) {
            console.error(`${logContext$3}: Unable to get Agent Group by reporting - missing accountId.`);
            return '';
        }
        try {
            const result = await this.apiService.getAgentGroupByReporting(accountId, reporting).toPromise();
            console.log(`${logContext$3}: get Agent Group by reporting success.`, { result });
            return result._embedded.items[0];
        }
        catch (error) {
            console.error(`${logContext$3}: get Agent Group by reporting failed.`, error);
            throw error;
        }
    }
    async getAgentGroupIdByGroupIdNumber(accountId, number) {
        if (!accountId) {
            console.error(`${logContext$3}: Unable to get Agent Group ID by GroupIdNumber - missing accountId.`);
            return '';
        }
        try {
            const result = await this.apiService.getAgentGroupByGroupIdNumber(accountId, number).toPromise();
            console.log(`${logContext$3}: get Agent Group ID by GroupIdNumber success.`, { result });
            return result._embedded.items[0]?.id;
        }
        catch (error) {
            console.error(`${logContext$3}: get Agent Group ID by GroupIdNumber failed.`, error);
            throw error;
        }
    }
    async getAgentGroupByGroupIdNumber(accountId, number) {
        if (!accountId || !number) {
            console.info(`${logContext$3}: Skipping get Agent Group by GroupIdNumber ${accountId} ${number}.`);
            return '';
        }
        try {
            const result = await this.apiService.getAgentGroupByGroupIdNumber(accountId, number).toPromise();
            console.log(`${logContext$3}: get Agent Group by GroupIdNumber success.`, { result });
            return result._embedded.items[0];
        }
        catch (error) {
            console.error(`${logContext$3}: get Agent Group by GroupIdNumber failed.`, error);
            throw error;
        }
    }
    async getAgentGroupMembers(accountId, groupId) {
        if (!accountId || !groupId) {
            console.info(`${logContext$3}: unable to getAgentGroupMembers - missing accountId ${accountId} or groupId ${groupId}`);
            return;
        }
        try {
            const res = await this.apiService.getAgentGroupMembers(accountId, groupId).toPromise();
            console.log(`${logContext$3}: get Agent Group Members ${groupId} success.`, res);
            const updatedItems = await Promise.all(res._embedded.items.map(async (item) => {
                item.employeeRefId = item.id;
                const employee = await this.apiService.getEmployee(accountId, item.id).toPromise();
                item.reporting = employee.reporting;
                delete item.id;
                return item; // Return the modified item
            }));
            return updatedItems;
        }
        catch (error) {
            console.error(`${logContext$3}: get Agent Group Members ${groupId} failed.`);
            throw error;
        }
    }
    async updateGroupMembers(accountId, groupId, data) {
        if (!accountId || !groupId) {
            console.info(`${logContext$3}: unable to updateGroupMembers - missing accountId ${accountId} or groupId ${groupId}`);
            return;
        }
        const supportedMediaTypes = mediaTypes.filter(type => data?.[type]);
        console.info(`${logContext$3} supportedMediaTypes ${supportedMediaTypes}`);
        const result = this.syncGroupMembers(data.originalGroupMembers, data.newGroupMembers);
        try {
            // delete members
            await Promise.all(result.deleteGroupMembers.map(async (member) => {
                await this.apiService.deleteAgentGroupMember(accountId, groupId, member.employeeRefId).toPromise();
                console.log(`${logContext$3}: delete agent group member success.`, groupId, member.employeeRefId);
            }));
            // add members
            await Promise.all(result.addGroupMembers.map(async (member) => {
                let reqBody = {
                    id: member.employeeRefId,
                    reporting: member.number,
                    skillLevel: member.skillLevel,
                    BypassWriteback: true
                };
                supportedMediaTypes.forEach(type => {
                    const agentRefIdKey = `${type}AgentRefId`;
                    const presenceStateDefaultKey = `${type}PresenceStateDefault`;
                    if (member[agentRefIdKey]) {
                        reqBody[agentRefIdKey] = member[agentRefIdKey];
                        reqBody[presenceStateDefaultKey] = member[presenceStateDefaultKey];
                    }
                });
                await this.apiService.addAgentGroupMember(accountId, groupId, reqBody).toPromise();
                console.log(`${logContext$3}: add agent group member success.`, groupId, reqBody);
            }));
            // update members
            await Promise.all(result.updateGroupMembers.map(async (member) => {
                let reqBody = { reporting: member.number, skillLevel: member.skillLevel, BypassWriteback: true };
                supportedMediaTypes.forEach(type => {
                    const agentRefIdKey = `${type}AgentRefId`;
                    const presenceStateDefaultKey = `${type}PresenceStateDefault`;
                    if (member[agentRefIdKey]) {
                        reqBody[agentRefIdKey] = member[agentRefIdKey];
                        reqBody[presenceStateDefaultKey] = member[presenceStateDefaultKey];
                    }
                });
                await this.apiService.updateAgentGroupMember(accountId, groupId, member.employeeRefId, reqBody).toPromise();
                console.log(`${logContext$3}: update agent group member success.`, groupId, reqBody);
            }));
            console.log(`${logContext$3}: update Agent Group Members ${groupId} success.`);
            return '';
        }
        catch (error) {
            console.error(`${logContext$3}: update Agent Group Members ${groupId} failed.`);
            throw error;
        }
    }
    async updateSystemGroup(accountId, groupIdNumber, number, status, additionalOptions) {
        if (!accountId) {
            console.error(`${logContext$3}: update system group member - missing accountId.`);
            return;
        }
        try {
            const skillLevel = additionalOptions?.find(option => option.type === SystemGroupAdditionalOptionTypes.SKILL_LEVEL)?.value;
            let reqBody = { reporting: number, skillLevel, BypassWriteback: true };
            const agentGroup = await this.getAgentGroupByGroupIdNumber(accountId, groupIdNumber);
            const supportedMediaTypes = mediaTypes.filter(type => {
                const key = `is${type.charAt(0).toUpperCase()}${type.slice(1)}Enabled`;
                return agentGroup[key];
            });
            console.info(`${logContext$3} supportedMediaTypes ${supportedMediaTypes}`);
            const res = await this.apiService.getAgentByReporting(accountId, number).toPromise();
            let memberId = '';
            res._embedded.items.forEach((item) => {
                memberId = item.employeeRefId;
                supportedMediaTypes.forEach(media => {
                    const refKey = `${media}AgentRefId`;
                    const presenceKey = `${media}PresenceStateDefault`;
                    if (item.mediaType.toLowerCase() === media.toLowerCase()) {
                        reqBody[refKey] = item.id;
                        reqBody[presenceKey] = 'Present';
                    }
                });
            });
            if (status === SystemGroupStatus.JOINING) {
                reqBody.id = memberId;
                await this.apiService.addAgentGroupMember(accountId, agentGroup.id, reqBody).toPromise();
            }
            else if (status === SystemGroupStatus.LEAVING) {
                await this.apiService.deleteAgentGroupMember(accountId, agentGroup.id, memberId).toPromise();
            }
            else if (status === SystemGroupStatus.MODIFYING) {
                await this.apiService.updateAgentGroupMember(accountId, agentGroup.id, memberId, reqBody).toPromise();
            }
            console.log(`${logContext$3}: ${status} system group member success.`);
            return;
        }
        catch (error) {
            console.error(`${logContext$3}: ${status} system group member failed.`, error);
            throw error;
        }
    }
    getReqBody(data) {
        const isRealTime = !data?.disableRealtime;
        const isVoiceEnabled = data?.voice ? true : false;
        const isEmailEnabled = data?.email ? true : false;
        const isChatEnabled = data?.chat ? true : false;
        const isSmsEnabled = data?.sms ? true : false;
        const isOpenMediaEnabled = data?.openMedia ? true : false;
        const queueCallersToGroup = data?.queueCallersToGroup ? true : false;
        const voiceFailoverMediaServerRefId = data?.voiceFailoverMediaServerRefId;
        const reqBody = {
            name: data?.name,
            reporting: data?.reportingNumber,
            groupIdNumber: data?.groupNumber,
            groupUsesSkills: data?.useSkillLevels,
            isVoiceEnabled,
            isEmailEnabled,
            isChatEnabled,
            isSmsEnabled,
            isOpenMediaEnabled,
            isActive: true,
            isRealTime,
            queueCallersToGroup,
            voiceFailoverMediaServerRefId,
            BypassWriteback: true
        };
        return reqBody;
    }
    syncGroupMembers(originalGroupMembers, newGroupMembers) {
        const originalMap = new Map((originalGroupMembers ?? []).map(member => [member.number, member]));
        const newMap = new Map((newGroupMembers ?? []).map(member => [member.number, member]));
        const addGroupMembers = [];
        const deleteGroupMembers = [];
        const updateGroupMembers = [];
        const areMembersIdentical = (a, b) => {
            return JSON.stringify(a) === JSON.stringify(b);
        };
        for (let [number, originalMember] of originalMap) {
            const newMember = newMap.get(number);
            if (!newMember) {
                deleteGroupMembers.push(originalMember);
            }
            else {
                // CL-18243 Agent Group supported media types could be changed. Always update the existing
                updateGroupMembers.push(newMember);
            }
        }
        for (let [number, member] of newMap) {
            if (!originalMap.has(number)) {
                addGroupMembers.push(member);
            }
        }
        return { addGroupMembers, deleteGroupMembers, updateGroupMembers };
    }
    static ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: AgentGroupsService, deps: [{ token: MiccbApiService }, { token: i2.TranslateService }], target: i0.ɵɵFactoryTarget.Injectable });
    static ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: AgentGroupsService, providedIn: 'root' });
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: AgentGroupsService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root'
                }]
        }], ctorParameters: function () { return [{ type: MiccbApiService }, { type: i2.TranslateService }]; } });

const logContext$2 = 'MiccbGroupProfileComponent';
class MiccbGroupProfileComponent {
    matIconRegistry;
    domSanitizer;
    miccApiService;
    agentGroupsService;
    employeeService;
    translateService;
    formBuilder;
    cdr;
    accountId;
    groupNumber;
    onFormChanged = new EventEmitter();
    baseUrl = '';
    miccbSecurityAccess = '';
    subscription = new Subscription();
    form;
    mediaServers$;
    constructor(matIconRegistry, domSanitizer, miccApiService, agentGroupsService, employeeService, translateService, formBuilder, cdr) {
        this.matIconRegistry = matIconRegistry;
        this.domSanitizer = domSanitizer;
        this.miccApiService = miccApiService;
        this.agentGroupsService = agentGroupsService;
        this.employeeService = employeeService;
        this.translateService = translateService;
        this.formBuilder = formBuilder;
        this.cdr = cdr;
    }
    async ngOnInit() {
        this.initForm();
        this.mediaServers$ = this.miccApiService.getMediaServers(this.accountId);
        this.miccbSecurityAccess = await this.employeeService.getUserSecurityAccess();
        console.log(`${logContext$2}.ngOnInit setting userSecurityAccess to ${this.miccbSecurityAccess}`);
        await this.setForm();
        if (this.miccbSecurityAccess === MiccSecurityAccess.CommunicationError) {
            const errorMsg = this.translateService.instant('miccb_user_config.errors.miccbConnectionUnavailable');
            console.log(`${logContext$2} TBD:${errorMsg}`);
        }
        this.subscription.add(this.mediaServers$.subscribe((mediaTypes) => {
            if (!mediaTypes.includes('voice')) {
                this.form.get('voice')?.patchValue(false);
                this.form.get('voice')?.disable({ emitEvent: false });
            }
            if (!mediaTypes.includes('chat')) {
                this.form.get('chat')?.patchValue(false);
                this.form.get('chat')?.disable({ emitEvent: false });
            }
            if (!mediaTypes.includes('email')) {
                this.form.get('email')?.patchValue(false);
                this.form.get('email')?.disable({ emitEvent: false });
            }
            if (!mediaTypes.includes('sms')) {
                this.form.get('sms')?.patchValue(false);
                this.form.get('sms')?.disable({ emitEvent: false });
            }
            if (!mediaTypes.includes('openmedia')) {
                this.form.get('openMedia')?.patchValue(false);
                this.form.get('openMedia')?.disable({ emitEvent: false });
            }
        }));
    }
    initForm() {
        this.form = this.formBuilder.group({
            disableRealtime: [false],
            voice: [true],
            chat: [false],
            email: [false],
            sms: [false],
            openMedia: [false]
        }, {
            validators: this.atLeastOneSelectedValidator(['voice', 'chat', 'email', 'sms', 'openMedia'])
        });
    }
    async setForm() {
        const data = await this.agentGroupsService.getAgentGroupByGroupIdNumber(this.accountId, this.groupNumber);
        if (!!data) {
            this.form.patchValue({
                disableRealtime: !data?.isRealTime,
                voice: data?.isVoiceEnabled,
                chat: data?.isChatEnabled,
                email: data?.isEmailEnabled,
                sms: data?.isSmsEnabled,
                openMedia: data?.isOpenMediaEnabled
            });
        }
        this.cdr.detectChanges();
    }
    ngOnDestroy() {
        if (this.subscription) {
            this.subscription.unsubscribe();
        }
    }
    isDirty() {
        return this.form.dirty;
    }
    allowedToModifyCCData() {
        return this.miccbSecurityAccess === MiccSecurityAccess.All;
    }
    onVoiceChanged(event) {
        //console.log('onVoiceChanged:', event.target.checked);
    }
    onMediaChanged(event) {
        //console.log('onMediaChanged:', event.target.checked);
    }
    atLeastOneSelectedValidator(controlNames) {
        return (formGroup) => {
            const hasAtLeastOne = controlNames.some(name => formGroup.get(name)?.value);
            return hasAtLeastOne ? null : { atLeastOneRequired: true };
        };
    }
    static ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: MiccbGroupProfileComponent, deps: [{ token: i1$2.MatIconRegistry }, { token: i2$1.DomSanitizer }, { token: MiccbApiService }, { token: AgentGroupsService }, { token: EmployeeService }, { token: i2.TranslateService }, { token: i1.FormBuilder }, { token: i0.ChangeDetectorRef }], target: i0.ɵɵFactoryTarget.Component });
    static ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.2.12", type: MiccbGroupProfileComponent, selector: "miccb-group-profile", inputs: { accountId: "accountId", groupNumber: "groupNumber" }, outputs: { onFormChanged: "onFormChanged" }, ngImport: i0, template: "<form [formGroup]=\"form\">\n    <div class=\"row\">\n        <div class=\"col-12 checkbox-section\">\n            <input\n                type=\"checkbox\"\n                data-e2e=\"group-disable-realtime-checkbox\"\n                id=\"group-disable-realtime\"\n                [formControl]=\"form.controls['disableRealtime']\"\n            />\n            <label for=\"group-disable-realtime\">\n                {{ 'miccb_group_profile.disable_realtime' | translate }}\n            </label>\n        </div>\n    </div>\n    <div class=\"row\">\n        <!-- Media Type: -->\n        <div class=\"col-12 group-label\">\n            {{ 'miccb_group_profile.mediaType' | translate }}\n        </div>\n        <div *ngIf=\"form.hasError('atLeastOneRequired')\" class=\"text-danger form-error\">\n            {{ 'miccb_group_profile.errors.mediaTypeRequired' | translate }}\n        </div>\n    </div>\n    <div class=\"row\">\n        <div class=\"col-12 form-group\">\n            <div class=\"group-element\">\n                <div class=\"media-type-option\">\n                    <div class=\"checkbox-section\">\n                        <input\n                            type=\"checkbox\"\n                            data-e2e=\"voice-checkbox\"\n                            id=\"voice\"\n                            [formControl]=\"form.controls['voice']\"\n                            (change)=\"onVoiceChanged($event)\"\n                            matTooltip=\"{{\n                                'miccb_user_config.mediaTypeNotAvailable' | translate: { type: 'miccb_user_config.voice' | translate }\n                            }}\"\n                            [matTooltipDisabled]=\"form.controls['voice'].disabled && allowedToModifyCCData() ? false : true\"\n                            matTooltipPosition=\"above\"\n                        />\n                        <label for=\"voice\">\n                            <img [src]=\"baseUrl + '/assets/miccb-components/icons/voice.svg'\" />\n                            {{ 'miccb_group_profile.voice' | translate }}\n                        </label>\n                    </div>\n                </div>\n                <div class=\"media-type-option\">\n                    <div class=\"checkbox-section\">\n                        <input\n                            type=\"checkbox\"\n                            data-e2e=\"chat-checkbox\"\n                            id=\"chat\"\n                            [formControl]=\"form.controls['chat']\"\n                            (change)=\"onMediaChanged($event)\"\n                            matTooltip=\"{{\n                                'miccb_user_config.mediaTypeNotAvailable' | translate: { type: 'miccb_user_config.chat' | translate }\n                            }}\"\n                            [matTooltipDisabled]=\"form.controls['chat'].disabled && allowedToModifyCCData() ? false : true\"\n                            matTooltipPosition=\"above\"\n                        />\n                        <label for=\"chat\">\n                            <img [src]=\"baseUrl + '/assets/miccb-components/icons/chat.svg'\" />\n                            {{ 'miccb_group_profile.chat' | translate }}\n                        </label>\n                    </div>\n                </div>\n                <div class=\"media-type-option\">\n                    <div class=\"checkbox-section\">\n                        <input\n                            type=\"checkbox\"\n                            data-e2e=\"email-checkbox\"\n                            id=\"email\"\n                            [formControl]=\"form.controls['email']\"\n                            (change)=\"onMediaChanged($event)\"\n                            matTooltip=\"{{\n                                'miccb_user_config.mediaTypeNotAvailable' | translate: { type: 'miccb_user_config.email' | translate }\n                            }}\"\n                            [matTooltipDisabled]=\"form.controls['email'].disabled && allowedToModifyCCData() ? false : true\"\n                            matTooltipPosition=\"above\"\n                        />\n                        <label for=\"email\">\n                            <img [src]=\"baseUrl + '/assets/miccb-components/icons/email.svg'\" />\n                            {{ 'miccb_group_profile.email' | translate }}\n                        </label>\n                    </div>\n                </div>\n                <div class=\"media-type-option\">\n                    <div class=\"checkbox-section\">\n                        <input\n                            type=\"checkbox\"\n                            data-e2e=\"sms-checkbox\"\n                            id=\"sms\"\n                            [formControl]=\"form.controls['sms']\"\n                            (change)=\"onMediaChanged($event)\"\n                            matTooltip=\"{{\n                                'miccb_user_config.mediaTypeNotAvailable' | translate: { type: 'miccb_user_config.sms' | translate }\n                            }}\"\n                            [matTooltipDisabled]=\"form.controls['sms'].disabled && allowedToModifyCCData() ? false : true\"\n                            matTooltipPosition=\"above\"\n                        />\n                        <label for=\"sms\">\n                            <img [src]=\"baseUrl + '/assets/miccb-components/icons/sms.svg'\" />\n                            {{ 'miccb_group_profile.sms' | translate }}\n                        </label>\n                    </div>\n                </div>\n                <div class=\"media-type-option\">\n                    <div class=\"checkbox-section\">\n                        <input\n                            type=\"checkbox\"\n                            data-e2e=\"openMedia-checkbox\"\n                            id=\"openMedia\"\n                            [formControl]=\"form.controls['openMedia']\"\n                            (change)=\"onMediaChanged($event)\"\n                            matTooltip=\"{{\n                                'miccb_user_config.mediaTypeNotAvailable' | translate: { type: 'miccb_user_config.openMedia' | translate }\n                            }}\"\n                            [matTooltipDisabled]=\"form.controls['openMedia'].disabled && allowedToModifyCCData() ? false : true\"\n                            matTooltipPosition=\"above\"\n                        />\n                        <label for=\"openMedia\">\n                            <img [src]=\"baseUrl + '/assets/miccb-components/icons/open-media.svg'\" />\n                            {{ 'miccb_group_profile.openMedia' | translate }}\n                        </label>\n                    </div>\n                </div>\n            </div>\n        </div>\n    </div>\n</form>\n", styles: ["::ng-deep .green-snackbar{--mdc-snackbar-container-color: #298632;--mdc-snackbar-supporting-text-color: #fff;--mat-snack-bar-button-color: #fff}::ng-deep .red-snackbar{--mdc-snackbar-container-color: #cd2b26;--mdc-snackbar-supporting-text-color: #fff;--mat-snack-bar-button-color: #fff}::ng-deep .blue-snackbar{--mdc-snackbar-container-color: #00a1e0;--mdc-snackbar-supporting-text-color: #fff;--mat-snack-bar-button-color: #fff}.media-type-option{max-width:-moz-fit-content;max-width:fit-content}.media-type-option .checkbox-section{flex-wrap:nowrap}.group-label{text-align:initial;display:inline-block;font-family:Open Sans,sans-serif;font-weight:400;font-size:14px;color:#495057}.group-label.text-disabled{color:#49505761}.group-element{display:flex;align-items:center;justify-content:space-between;gap:1rem;margin:.5rem 0}.checkbox-section{margin:.5rem 0}.checkbox-section label{margin-left:0!important}.col-12{width:95%!important}.form-error{font-size:12px;font-weight:400}.text-danger{--bs-text-opacity: 1;color:rgba(var(--bs-danger-rgb),var(--bs-text-opacity))!important}\n"], dependencies: [{ kind: "directive", type: i5.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: i1.ɵNgNoValidate, selector: "form:not([ngNoForm]):not([ngNativeValidate])" }, { kind: "directive", type: i1.CheckboxControlValueAccessor, selector: "input[type=checkbox][formControlName],input[type=checkbox][formControl],input[type=checkbox][ngModel]" }, { kind: "directive", type: i1.NgControlStatus, selector: "[formControlName],[ngModel],[formControl]" }, { kind: "directive", type: i1.NgControlStatusGroup, selector: "[formGroupName],[formArrayName],[ngModelGroup],[formGroup],form:not([ngNoForm]),[ngForm]" }, { kind: "directive", type: i1.FormControlDirective, selector: "[formControl]", inputs: ["formControl", "disabled", "ngModel"], outputs: ["ngModelChange"], exportAs: ["ngForm"] }, { kind: "directive", type: i1.FormGroupDirective, selector: "[formGroup]", inputs: ["formGroup"], outputs: ["ngSubmit"], exportAs: ["ngForm"] }, { kind: "directive", type: i10.MatTooltip, selector: "[matTooltip]", exportAs: ["matTooltip"] }, { kind: "pipe", type: i2.TranslatePipe, name: "translate" }] });
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: MiccbGroupProfileComponent, decorators: [{
            type: Component,
            args: [{ selector: 'miccb-group-profile', template: "<form [formGroup]=\"form\">\n    <div class=\"row\">\n        <div class=\"col-12 checkbox-section\">\n            <input\n                type=\"checkbox\"\n                data-e2e=\"group-disable-realtime-checkbox\"\n                id=\"group-disable-realtime\"\n                [formControl]=\"form.controls['disableRealtime']\"\n            />\n            <label for=\"group-disable-realtime\">\n                {{ 'miccb_group_profile.disable_realtime' | translate }}\n            </label>\n        </div>\n    </div>\n    <div class=\"row\">\n        <!-- Media Type: -->\n        <div class=\"col-12 group-label\">\n            {{ 'miccb_group_profile.mediaType' | translate }}\n        </div>\n        <div *ngIf=\"form.hasError('atLeastOneRequired')\" class=\"text-danger form-error\">\n            {{ 'miccb_group_profile.errors.mediaTypeRequired' | translate }}\n        </div>\n    </div>\n    <div class=\"row\">\n        <div class=\"col-12 form-group\">\n            <div class=\"group-element\">\n                <div class=\"media-type-option\">\n                    <div class=\"checkbox-section\">\n                        <input\n                            type=\"checkbox\"\n                            data-e2e=\"voice-checkbox\"\n                            id=\"voice\"\n                            [formControl]=\"form.controls['voice']\"\n                            (change)=\"onVoiceChanged($event)\"\n                            matTooltip=\"{{\n                                'miccb_user_config.mediaTypeNotAvailable' | translate: { type: 'miccb_user_config.voice' | translate }\n                            }}\"\n                            [matTooltipDisabled]=\"form.controls['voice'].disabled && allowedToModifyCCData() ? false : true\"\n                            matTooltipPosition=\"above\"\n                        />\n                        <label for=\"voice\">\n                            <img [src]=\"baseUrl + '/assets/miccb-components/icons/voice.svg'\" />\n                            {{ 'miccb_group_profile.voice' | translate }}\n                        </label>\n                    </div>\n                </div>\n                <div class=\"media-type-option\">\n                    <div class=\"checkbox-section\">\n                        <input\n                            type=\"checkbox\"\n                            data-e2e=\"chat-checkbox\"\n                            id=\"chat\"\n                            [formControl]=\"form.controls['chat']\"\n                            (change)=\"onMediaChanged($event)\"\n                            matTooltip=\"{{\n                                'miccb_user_config.mediaTypeNotAvailable' | translate: { type: 'miccb_user_config.chat' | translate }\n                            }}\"\n                            [matTooltipDisabled]=\"form.controls['chat'].disabled && allowedToModifyCCData() ? false : true\"\n                            matTooltipPosition=\"above\"\n                        />\n                        <label for=\"chat\">\n                            <img [src]=\"baseUrl + '/assets/miccb-components/icons/chat.svg'\" />\n                            {{ 'miccb_group_profile.chat' | translate }}\n                        </label>\n                    </div>\n                </div>\n                <div class=\"media-type-option\">\n                    <div class=\"checkbox-section\">\n                        <input\n                            type=\"checkbox\"\n                            data-e2e=\"email-checkbox\"\n                            id=\"email\"\n                            [formControl]=\"form.controls['email']\"\n                            (change)=\"onMediaChanged($event)\"\n                            matTooltip=\"{{\n                                'miccb_user_config.mediaTypeNotAvailable' | translate: { type: 'miccb_user_config.email' | translate }\n                            }}\"\n                            [matTooltipDisabled]=\"form.controls['email'].disabled && allowedToModifyCCData() ? false : true\"\n                            matTooltipPosition=\"above\"\n                        />\n                        <label for=\"email\">\n                            <img [src]=\"baseUrl + '/assets/miccb-components/icons/email.svg'\" />\n                            {{ 'miccb_group_profile.email' | translate }}\n                        </label>\n                    </div>\n                </div>\n                <div class=\"media-type-option\">\n                    <div class=\"checkbox-section\">\n                        <input\n                            type=\"checkbox\"\n                            data-e2e=\"sms-checkbox\"\n                            id=\"sms\"\n                            [formControl]=\"form.controls['sms']\"\n                            (change)=\"onMediaChanged($event)\"\n                            matTooltip=\"{{\n                                'miccb_user_config.mediaTypeNotAvailable' | translate: { type: 'miccb_user_config.sms' | translate }\n                            }}\"\n                            [matTooltipDisabled]=\"form.controls['sms'].disabled && allowedToModifyCCData() ? false : true\"\n                            matTooltipPosition=\"above\"\n                        />\n                        <label for=\"sms\">\n                            <img [src]=\"baseUrl + '/assets/miccb-components/icons/sms.svg'\" />\n                            {{ 'miccb_group_profile.sms' | translate }}\n                        </label>\n                    </div>\n                </div>\n                <div class=\"media-type-option\">\n                    <div class=\"checkbox-section\">\n                        <input\n                            type=\"checkbox\"\n                            data-e2e=\"openMedia-checkbox\"\n                            id=\"openMedia\"\n                            [formControl]=\"form.controls['openMedia']\"\n                            (change)=\"onMediaChanged($event)\"\n                            matTooltip=\"{{\n                                'miccb_user_config.mediaTypeNotAvailable' | translate: { type: 'miccb_user_config.openMedia' | translate }\n                            }}\"\n                            [matTooltipDisabled]=\"form.controls['openMedia'].disabled && allowedToModifyCCData() ? false : true\"\n                            matTooltipPosition=\"above\"\n                        />\n                        <label for=\"openMedia\">\n                            <img [src]=\"baseUrl + '/assets/miccb-components/icons/open-media.svg'\" />\n                            {{ 'miccb_group_profile.openMedia' | translate }}\n                        </label>\n                    </div>\n                </div>\n            </div>\n        </div>\n    </div>\n</form>\n", styles: ["::ng-deep .green-snackbar{--mdc-snackbar-container-color: #298632;--mdc-snackbar-supporting-text-color: #fff;--mat-snack-bar-button-color: #fff}::ng-deep .red-snackbar{--mdc-snackbar-container-color: #cd2b26;--mdc-snackbar-supporting-text-color: #fff;--mat-snack-bar-button-color: #fff}::ng-deep .blue-snackbar{--mdc-snackbar-container-color: #00a1e0;--mdc-snackbar-supporting-text-color: #fff;--mat-snack-bar-button-color: #fff}.media-type-option{max-width:-moz-fit-content;max-width:fit-content}.media-type-option .checkbox-section{flex-wrap:nowrap}.group-label{text-align:initial;display:inline-block;font-family:Open Sans,sans-serif;font-weight:400;font-size:14px;color:#495057}.group-label.text-disabled{color:#49505761}.group-element{display:flex;align-items:center;justify-content:space-between;gap:1rem;margin:.5rem 0}.checkbox-section{margin:.5rem 0}.checkbox-section label{margin-left:0!important}.col-12{width:95%!important}.form-error{font-size:12px;font-weight:400}.text-danger{--bs-text-opacity: 1;color:rgba(var(--bs-danger-rgb),var(--bs-text-opacity))!important}\n"] }]
        }], ctorParameters: function () { return [{ type: i1$2.MatIconRegistry }, { type: i2$1.DomSanitizer }, { type: MiccbApiService }, { type: AgentGroupsService }, { type: EmployeeService }, { type: i2.TranslateService }, { type: i1.FormBuilder }, { type: i0.ChangeDetectorRef }]; }, propDecorators: { accountId: [{
                type: Input
            }], groupNumber: [{
                type: Input
            }], onFormChanged: [{
                type: Output
            }] } });

class ProgressBarColorDirective {
    el;
    name = '';
    fillColor;
    backgroundColor;
    nativeEl;
    styleEl = document.createElement('style');
    uniqueAttr = `progress-bar-color-${this.name}`;
    constructor(el) {
        this.el = el;
        this.nativeEl = this.el.nativeElement;
    }
    ngOnChanges(changes) {
        if (changes.name && changes.name.currentValue) {
            this.name = changes.name.currentValue;
            this.uniqueAttr = `progress-bar-color-${this.name}`;
            this.nativeEl.setAttribute(this.uniqueAttr, '');
            this.nativeEl.appendChild(this.styleEl);
        }
        this.updateColor();
    }
    updateColor() {
        // update dynamic style with the uniqueAttr
        this.styleEl.innerText =
            `
      [${this.uniqueAttr}] .mat-progress-bar-fill::after {
        background-color: ${this.fillColor};
      }
    ` +
                `
      [${this.uniqueAttr}] .mat-progress-bar-background  {
        fill: ${this.backgroundColor};
      }
    ` +
                `
      [${this.uniqueAttr}] .mat-progress-bar-buffer  {
        background-color: ${this.backgroundColor};
      }
    `;
    }
    static ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: ProgressBarColorDirective, deps: [{ token: i0.ElementRef }], target: i0.ɵɵFactoryTarget.Directive });
    static ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "16.2.12", type: ProgressBarColorDirective, selector: "[progress-bar-color]", inputs: { name: "name", fillColor: "fillColor", backgroundColor: "backgroundColor" }, usesOnChanges: true, ngImport: i0 });
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: ProgressBarColorDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: '[progress-bar-color]'
                }]
        }], ctorParameters: function () { return [{ type: i0.ElementRef }]; }, propDecorators: { name: [{
                type: Input
            }], fillColor: [{
                type: Input
            }], backgroundColor: [{
                type: Input
            }] } });

class MiccbComponentsModule {
    static ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: MiccbComponentsModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
    static ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "16.2.12", ngImport: i0, type: MiccbComponentsModule, declarations: [MiccbUserConfigurationComponent,
            MiccbTemplateConfigurationComponent,
            ErrorAlertComponent,
            ProgressBarColorDirective,
            EmployeeComponent,
            GenericToggleFieldComponent,
            MiccbGroupProfileComponent], imports: [CommonModule,
            MatFormFieldModule,
            MatInputModule,
            FormsModule,
            ReactiveFormsModule,
            MatDialogModule,
            MatExpansionModule,
            MatSelectModule,
            MatIconModule,
            MatButtonModule,
            MatCheckboxModule,
            MatTooltipModule,
            MatRadioModule,
            MatTableModule,
            MatSortModule,
            MatMenuModule,
            MatProgressBarModule,
            TranslateModule,
            NgxMatSelectSearchModule], exports: [EmployeeComponent] });
    static ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: MiccbComponentsModule, providers: [EmployeeService, MiccbApiService, SystemManagerService], imports: [CommonModule,
            MatFormFieldModule,
            MatInputModule,
            FormsModule,
            ReactiveFormsModule,
            MatDialogModule,
            MatExpansionModule,
            MatSelectModule,
            MatIconModule,
            MatButtonModule,
            MatCheckboxModule,
            MatTooltipModule,
            MatRadioModule,
            MatTableModule,
            MatSortModule,
            MatMenuModule,
            MatProgressBarModule,
            TranslateModule,
            NgxMatSelectSearchModule] });
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: MiccbComponentsModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [
                        MiccbUserConfigurationComponent,
                        MiccbTemplateConfigurationComponent,
                        ErrorAlertComponent,
                        ProgressBarColorDirective,
                        EmployeeComponent,
                        GenericToggleFieldComponent,
                        MiccbGroupProfileComponent
                    ],
                    providers: [EmployeeService, MiccbApiService, SystemManagerService],
                    imports: [
                        CommonModule,
                        MatFormFieldModule,
                        MatInputModule,
                        FormsModule,
                        ReactiveFormsModule,
                        MatDialogModule,
                        MatExpansionModule,
                        MatSelectModule,
                        MatIconModule,
                        MatButtonModule,
                        MatCheckboxModule,
                        MatTooltipModule,
                        MatRadioModule,
                        MatTableModule,
                        MatSortModule,
                        MatMenuModule,
                        MatProgressBarModule,
                        TranslateModule,
                        NgxMatSelectSearchModule
                    ],
                    exports: [EmployeeComponent]
                }]
        }] });

const logContext$1 = 'MiccbWorkflowService';
class WorkflowService {
    http;
    workflowUrl;
    agentGlobalActivityId;
    agentGroupGlobalActivityId;
    componentId;
    constructor(http) {
        this.http = http;
        this.workflowUrl =
            Config.cloud === 'dev' ? 'https://workflow.dev.api.mitel.io/2017-09-01' : 'https://workflow.api.mitel.io/2017-09-01';
        this.agentGlobalActivityId = 'global_7128f051-b5d2-4a16-a684-77274631ce94';
        this.agentGroupGlobalActivityId = 'global_5cb0b054-bb0b-4535-a9db-5bb2911b7c79';
    }
    async searchVoiceOnly(ComponentId, SearchTerm) {
        const token = localStorage.getItem('@mitel/token.access_token');
        let headers = new HttpHeaders().set('Authorization', `Bearer ${token}`).set('Content-Type', 'application/json');
        let body = {};
        body.inputs = { SearchTerm, Type: 'VoiceOnly', ComponentId };
        try {
            const res = await this.http
                .post(`${this.workflowUrl}/activities/${this.agentGlobalActivityId}/workers?sync=true`, body, {
                headers
            })
                .toPromise();
            console.log(`${logContext$1}.searchVoiceOnly:`, res);
            if (res?.outputs?.Response && Array.isArray(res.outputs.Response)) {
                return res.outputs.Response;
            }
            else {
                return [];
            }
        }
        catch (err) {
            console.error(`${logContext$1}.searchVoiceOnly:`, err);
            return [];
        }
    }
    async searchAgentGroups(ComponentId, SearchTerm, MediaType, isMultiMedia) {
        const token = localStorage.getItem('@mitel/token.access_token');
        let headers = new HttpHeaders().set('Authorization', `Bearer ${token}`).set('Content-Type', 'application/json');
        let body = {};
        if (isMultiMedia) {
            body.inputs = { SearchTerm, Type: 'VoiceWithMultimedia', ComponentId, MediaType };
        }
        else {
            body.inputs = { SearchTerm, Type: 'VoiceOnly', ComponentId, MediaType };
        }
        try {
            const res = await this.http
                .post(`${this.workflowUrl}/activities/${this.agentGroupGlobalActivityId}/workers?sync=true`, body, {
                headers
            })
                .toPromise();
            console.log(`${logContext$1}.searchAgentGroupMultiMedia:`, res);
            if (res?.outputs?.Response && Array.isArray(res.outputs.Response)) {
                return res.outputs.Response;
            }
            else {
                return [];
            }
        }
        catch (err) {
            console.error(`${logContext$1}.searchAgentGroupMultiMedia:`, err);
            return [];
        }
    }
    static ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: WorkflowService, deps: [{ token: i1$1.HttpClient }], target: i0.ɵɵFactoryTarget.Injectable });
    static ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: WorkflowService, providedIn: 'root' });
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: WorkflowService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root'
                }]
        }], ctorParameters: function () { return [{ type: i1$1.HttpClient }]; } });

const logContext = 'MiccbQueueService';
class QueueService {
    apiService;
    translateService;
    constructor(apiService, translateService) {
        this.apiService = apiService;
        this.translateService = translateService;
    }
    async updateMiccQueueMembers(accountId, queue) {
        if (!accountId) {
            console.info(`${logContext}: unable to updateQueueMembers - missing accountId ${accountId}`);
            return;
        }
        const qId = queue.id;
        if (!qId || !queue.members || !Array.isArray(queue.members)) {
            console.info(`${logContext}: unable to updateQueueMembers - invalid queue or members`);
            return;
        }
        const validMembers = queue.members.filter((member) => member.memberRefId && member.memberRefId.trim() !== '');
        let body = {};
        if (queue.isVoiceQueue) {
            body = {
                members: validMembers.map((member) => member.memberRefId),
                BypassWriteback: true,
                MembersWithAttributes: validMembers.map((member) => ({
                    id: member.memberRefId,
                    SkillPriority: member.remoteAgentSkillGroupPriority || 0,
                    PredictiveOverflowAverageCallSeconds: member.predictiveOverflowAverageCallSeconds || 0,
                    OverflowTimerSeconds: member.overflowTimerSeconds || 0,
                    AnswerByPosition: member.index || 0
                }))
            };
        }
        else {
            body = {
                members: validMembers.map((member) => member.memberRefId),
                BypassWriteback: true,
                MembersWithAttributes: validMembers.map((member) => ({
                    id: member.memberRefId,
                    OfferToAgentGroupProperties: {
                        priority: member.index || 0,
                        doNotAllowOverflow: !member.allowOverflow || false,
                        interflowTime: member.interflowTime || '01:00:00',
                        overflowWhenAllAgentsAreLoggedOut: member.overflowOnLogout || false,
                        overflowTime: member.overflowTime || '00:00:00',
                        pushItemsToAgent: member.pushToAgent || true
                    }
                }))
            };
        }
        try {
            await this.apiService.updateQueueMembers(accountId, qId, body).toPromise();
            console.info(`${logContext}: successfully updated queue members for queue ID ${qId}`);
        }
        catch (error) {
            console.error(`${logContext}: failed to update queue members for queue ID ${qId}`, error);
        }
    }
    static ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: QueueService, deps: [{ token: MiccbApiService }, { token: i2.TranslateService }], target: i0.ɵɵFactoryTarget.Injectable });
    static ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: QueueService, providedIn: 'root' });
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: QueueService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root'
                }]
        }], ctorParameters: function () { return [{ type: MiccbApiService }, { type: i2.TranslateService }]; } });

/*
 * Public API miccb-components
 */

/**
 * Generated bundle index. Do not edit.
 */

export { ActionType, AgentGroupsService, BaseLicense, ComponentTypes, EmployeeComponent, EmployeeService, HTTP_METHODS, MiccSecurityAccess, MiccbApiService, MiccbComponentsModule, MiccbGroupProfileComponent, MiccbTemplateConfigurationComponent, MiccbUserConfigurationComponent, QueueService, ServiceTypes, SubResourceParentType, SystemGroupAdditionalOptionTypes, SystemGroupStatus, SystemManagerService, TemplateLabel, WorkflowService, appPasswordMaxLength, appPasswordMinLength, appPasswordRequirements, asyncJobProcessingStatus, asyncJobStatus, groupTypes, ivrReportingMSId, licenseType, licenseUCCV40Tier, noneGroup, phoneTypes, saveTypes, tableOfContentsChange };
